// src/index.ts
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// src/locales/en/account.ts
var account_default = {
  account_management_page_title: "Accounts",
  account_management_account_action: "Action",
  account_management_account_id: "Account ID",
  account_management_first_name: "First Name",
  account_management_last_name: "Last Name",
  account_management_email: "Email",
  account_management_phone: "Phone",
  account_management_company: "Company",
  account_management_revenue: "Revenue",
  account_management_status: "Status",
  account_management_store_list_button: "Store List",
  account_actionbar_import_step1: "Step 1 - Download Accounts Import Template",
  account_actionbar_import_download_link: "download the template",
  account_actionbar_import_step2: "Step 2 - Import accounts as CSV",
  account_action_bar_add: "Add",
  account_action_bar_search_placeholder: "search",
  account_action_bar_import: "Import",
  account_action_bar_export: "Export",
  account_action_bar_filter: "Filter",
  account_action_bar_account_id: "Account ID",
  account_action_bar_account_id_sub: " (equals)",
  account_action_bar_first_name: "First Name",
  account_action_bar_first_name_sub: " (contains)",
  account_action_bar_last_name: "Last Name",
  account_action_bar_last_name_sub: " (contains)",
  account_action_bar_email: "Email",
  account_action_bar_email_sub: " (contains)",
  account_action_bar_phone: "Phone",
  account_action_bar_phone_sub: " (equals)",
  account_action_bar_company: "Company",
  account_action_bar_company_sub: " (contains)",
  account_action_bar_revenue: "Revenue",
  account_action_bar_revenue_sub: " (equals)",
  account_info_page_title: "Account Info",
  account_info_primary_contact: "Primary Contact",
  account_info_billing_contact: "Billing Contact",
  account_info_account_name: "Account Name",
  account_info_status: "Status",
  account_info_email: "Email",
  account_info_company: "Company",
  account_info_phone: "Phone",
  account_info_address1: "Address1",
  account_info_address2: "Address2",
  account_info_country: "Country",
  account_info_city: "City",
  account_info_revenue: "Revenue",
  account_info_country_us: "US",
  account_info_theme_list_title: "Theme List",
  account_info_theme_list_image_alt: "Loading failure",
  account_infomation_title: "Store Information",
  account_infomation_column_store_id: "Store ID",
  account_infomation_column_store_hash: "Store Hash",
  account_infomation_column_store_name: "Store Name",
  account_infomation_column_plan: "Plan",
  account_infomation_column_expire_date: "Exp. Date",
  account_infomation_column_status: "Status",
  account_logo_title_modal_header: "Notice:",
  account_logo_title_modal_text: "After logging in, please refresh the page and reconnect to continue.",
  account_logo_title_modal_login_btn: "go to Login",
  account_logo_title_form_title: "Logo and Title",
  account_logo_title_form_account_title: "Account Title",
  account_logo_title_form_account_logo: "Account Logo",
  account_logo_title_error_upload_image: "Please upload the picture file",
  account_management_action_view_detail: "View Detail",
  account_management_action_new_store: "New Store",
  account_management_action_edit: "Edit",
  account_management_action_edit_status: "Edit Status",
  account_management_action_delete: "Delete",
  account_management_action_cancel_store: "Cancel Store",
  account_management_action_delete_connect: "Delete Connect",
  account_add_page_title: "Add a New Account",
  account_add_save: "Save",
  account_add_add_success: "Add account successfully",
  account_add_primary_contact: "Primary Contact",
  account_add_first_name: "First Name",
  account_add_last_name: "Last Name",
  account_add_email: "Email",
  account_add_company: "Company",
  account_add_address_line1: "Address(line1)",
  account_add_phone_number: "Phone Number",
  account_add_address_line2: "Address(line2)",
  account_add_revenue: "Revenue",
  account_add_country: "Country",
  account_add_state: "State",
  account_add_city: "City",
  account_add_zip: "Zip",
  account_add_same_as_primary: "Fill the same content as Primary Contact.",
  account_add_create_store: "Create Store",
  account_add_store_title: "Create a new store",
  account_add_store_name: "Store Name",
  account_add_plan: "Plan",
  account_add_description: "Description",
  account_add_provisioning_profile: "Provisioning Profile",
  account_add_billing_contact: "Billing Contact",
  account_add_invalid_email: "Please enter your email address.",
  account_cancel_store_modal_title: "Canceling a Store will cause all associated orders to be deleted and is irreversible",
  account_cancel_store_destroyed_success: "Destroyed Success.",
  account_cancel_store_store_id: "Store ID",
  account_cancel_store_store_id_required: "Store ID is required",
  account_cancel_store_store_id_placeholder: "Please type Store ID",
  account_cancel_store_confirm: "Confirm",
  account_cancel_store_confirm_required: "Please type word 'CONFIRM'",
  account_cancel_store_confirm_placeholder: "Please type word 'CONFIRM'",
  account_disable_modal_title: "Disabling an Account will cause all associated stores to be deleted and is irreversible",
  account_disable_cancel: "Cancel",
  account_disable_delete: "Delete",
  account_disable_success: "Delete account successfully",
  account_disable_account_id: "Account ID",
  account_disable_account_id_required: "Account ID is required",
  account_disable_account_id_placeholder: "Please type Account ID",
  account_disable_confirm: "Confirm",
  account_disable_confirm_required: "Please type word 'CONFIRM'",
  account_disable_confirm_placeholder: "Please type word 'CONFIRM'",
  account_edit_page_title: "Edit Account",
  account_edit_primary_contact: "Primary Contact",
  account_edit_billing_contact: "Billing Contact",
  account_edit_first_name: "First Name",
  account_edit_last_name: "Last Name",
  account_edit_email: "Email",
  account_edit_email_invalid: "Please enter a valid email address.",
  account_edit_company: "Company",
  account_edit_address_line1: "Address (line 1)",
  account_edit_address_line2: "Address (line 2)",
  account_edit_phone: "Phone Number",
  account_edit_country: "Country",
  account_edit_state: "State",
  account_edit_city: "City",
  account_edit_zip: "Zip",
  account_edit_revenue: "Revenue",
  account_edit_save: "Save",
  account_edit_success: "Account updated successfully.",
  account_edit_status_title: "Set Account Status",
  account_edit_status_cancel: "Cancel",
  account_edit_status_save: "Save",
  account_edit_status_success: "Edit status successfully",
  account_edit_status_account_id: "Account ID",
  account_edit_status_account_id_required: "Account ID is required",
  account_edit_status_account_id_placeholder: "Please type Account ID",
  account_edit_status_select_label: "Select account status",
  account_edit_status_active: "Active",
  account_edit_status_unless: "Uneless",
  account_new_store_add_new_store: "Add a new Store",
  account_new_store_store_name: "Store Name",
  account_new_store_store_name_required: "store name is required",
  account_new_store_plan: "Plan",
  account_new_store_plan_required: "plan is required",
  account_new_store_company: "Company",
  account_new_store_description: "Description",
  account_new_store_provisioning_profile: "Provisioning Profile",
  account_new_store_add_store_success: "Add store successfully"
};

// src/locales/en/common.ts
var common_default = {
  common_filter_clear: "Clear",
  common_filter_apply: "Apply",
  common_filter_filter: "Filter",
  common_filter_expand: "Expand",
  common_filter_search: "Search",
  common_btn_text_ok: "OK",
  common_btn_text_cancel: "Cancel",
  common_btn_text_apply: "Apply",
  common_btn_text_save: "Save",
  common_btn_text_add: "Add",
  common_btn_text_remove: "Remove",
  common_btn_text_delete: "Delete",
  common_permission_denied: "Don't have permission.",
  common_message_success: "Success!",
  common_enabled: "Enabled",
  common_disabled: "Disabled",
  common_loadingFailure: "Loading failure"
};

// src/locales/en/content.ts
var content_default = {
  content_page_action: "Action",
  content_page_id: "Content ID",
  content_page_name: "Name",
  content_page_content_type: "Content Type",
  content_page_store: "Store",
  content_page_updated: "Updated",
  content_page_last_updated_by: "Last updated by",
  content_page_status: "Status",
  content_page_title: "Content",
  content_page_current_status: "Current Status",
  content_page_store_description: "Select Store",
  content_page_action_edit: "Edit",
  content_page_action_duplicate: "Duplicate",
  content_page_action_archive: "Archive",
  content_page_action_delete: "Delete",
  content_page_action_create_content: "Create Content",
  content_edit_tab_editor: "Editor",
  content_edit_save_button: "Save",
  content_edit_page_title: "Create Content",
  content_edit_name_required: "Name is required",
  content_edit_type_required: "Type is required",
  content_edit_headline_required: "Headline is required",
  content_edit_body_required: "Body text is required",
  content_edit_create_success: "Content created successfully.",
  content_edit_update_success: "Content updated successfully.",
  content_edit_failed_to_update_locales: "Failed to update locales",
  content_edit_max_media_files: "You can only upload up to 3 media files",
  content_edit_name_label: "Name",
  content_edit_name_description: "Input Name",
  content_edit_type_label: "Type",
  content_edit_type_description: "Select Type",
  content_edit_editor_headline_label: "Headline",
  content_edit_editor_headline_description: "Maximum 256 characters",
  content_edit_editor_body_label: "Body text",
  content_delete_success: "Content deleted successfully",
  content_delete_warning: "This content will be permanently deleted. This action cannot be undone.",
  content_name: "Content Name",
  content_name_required: "Content name is required",
  content_name_placeholder: "Please enter content name",
  confirm: "Confirm",
  confirm_required: "Please enter confirmation",
  confirm_validation: "Please type 'CONFIRM' to confirm",
  confirm_placeholder: "Please type 'CONFIRM' to confirm",
  cancel: "Cancel",
  ok: "OK",
  content_page_toggle_approved: "Approved",
  content_page_toggle_pending: "Pending",
  content_page_toggle_archived: "Archived",
  content_media_list_title: "Media Files ({{count}}/3)",
  content_media_list_no_media_files: "No media files uploaded yet",
  content_media_list_media_file: "Media File",
  content_file_upload_please_select_file_first: "Please select a file first",
  content_file_upload_failed_to_upload_file: "Failed to upload file",
  content_file_upload_success: "File uploaded successfully",
  content_file_upload_uploading: "Uploading...",
  content_file_upload_upload_file: "Upload File",
  content_file_upload_upload_media_files: "Upload Media Files (Max media files: 3)",
  content_detail_versions_failed_to_fetch_content_versions: "Failed to fetch content versions",
  content_detail_versions_updated_time: "Updated Time",
  content_detail_versions_review_status: "Review Status",
  content_detail_status_you_do_not_have_permission_to_update_review_status: "You do not have permission to update review status",
  content_detail_status_status_updated_successfully: "Status updated successfully",
  content_detail_status_failed_to_update_status: "Failed to update status",
  content_detail_status_updating: "Updating...",
  content_detail_status_change_status: "Change Status",
  content_page_last_saved: "Last Saved",
  content_detail_rich_text_editor_loading: "Loading editor...",
  content_detail_locales_failed_to_update_locales: "Failed to update locales",
  content_detail_locales_locales_updated_successfully: "Locales updated successfully",
  content_detail_locales_title: "Locales",
  content_detail_locales_current_locales: "Current Locales",
  content_detail_locales_change_locales: "Change Locales",
  content_edit_only_en_us_allowed: "Name remains consistent across all locales",
  content_edit_do_not_have_permission_to_update_review_status: "Do not have permission to update review status",
  content_filter_content_type: "Content Type",
  content_filter_update_date: "Update Date",
  content_restore_modal_title: "Restore Content",
  content_restore_modal_button: "Restore",
  content_restore_modal_message: "Restore: Confirm restoring this Content? After restoration, it will be viewable and operable normally in the content list.",
  content_restore_success: "Content restored successfully",
  content_soft_delete_modal_title: "Delete Content",
  content_soft_delete_modal_button: "Delete",
  content_soft_delete_modal_message: "This product will be removed from the content list. If you wish to retrieve it, you can restore it in the 'Deleted' tab.",
  content_soft_delete_success: "Content delete successfully",
  content_action_delete_permanently: "Delete Permanently",
  content_action_restore: "Restore",
  content_action_duplicate_success: "Duplicate success!",
  content_action_archive_success: "Archive content successfully",
  content_action_select_store_modal_title: "Select Store to Duplicate",
  content_action_cancel: "Cancel",
  content_action_confirm: "Confirm",
  content_action_un_archive: "Unarchive"
};

// src/locales/en/customerProfile.ts
var customerProfile_default = {
  customerProfile_customer_management_first_name: "First Name",
  customerProfile_customer_management_last_name: "Last Name",
  customerProfile_customer_management_email: "Email",
  customerProfile_customer_management_phone: "Phone",
  customerProfile_customer_management_store_name: "Store Name",
  customerProfile_customer_management_created_at: "Created At",
  customerProfile_customer_profile_details_page_title: "Customer Profile",
  customerProfile_customer_profile_details_orders_revenue: "Orders Revenue",
  customerProfile_customer_order_revenue_page_title: "Orders Revenue (Customer)",
  customerProfile_customer_order_revenue_action_bar_period_0: "Today",
  customerProfile_customer_order_revenue_action_bar_period_1: "Yesterday",
  customerProfile_customer_order_revenue_action_bar_period_2: "Last 7 days",
  customerProfile_customer_order_revenue_action_bar_period_3: "Last 14 days",
  customerProfile_customer_order_revenue_action_bar_period_4: "Last 30 days",
  customerProfile_customer_order_revenue_action_bar_period_5: "Last 90 days",
  customerProfile_customer_order_revenue_action_bar_period_6: "This Quarter",
  customerProfile_customer_order_revenue_action_bar_period_7: "Last Quarter",
  customerProfile_customer_order_revenue_action_bar_period_8: "This Year",
  customerProfile_customer_order_revenue_action_bar_period_9: "Last Year",
  customerProfile_customer_order_revenue_overview_title: "Customer Name",
  customerProfile_customer_order_revenue_chart_title: "Orders Revenue",
  customerProfile_customer_order_revenue_chart_unit: "Unit",
  customerProfile_customer_order_revenue_orders_table_title: "Orders",
  customerProfile_customer_order_revenue_orders_table_order_id: "Order ID",
  customerProfile_customer_order_revenue_orders_table_date: "Date",
  customerProfile_customer_order_revenue_orders_table_source: "Source",
  customerProfile_customer_order_revenue_orders_table_subtotal: "Subtotal",
  customerProfile_customer_order_revenue_orders_table_line_item_discounts: "Line item discounts",
  customerProfile_customer_order_revenue_orders_table_shipping: "Shipping",
  customerProfile_customer_order_revenue_orders_table_tax: "Tax",
  customerProfile_customer_order_revenue_orders_table_total: "Total",
  customerProfile_customer_information: "Customer Information",
  customerProfile_first_name: "First Name",
  customerProfile_last_name: "Last Name",
  customerProfile_company_name: "Company Name",
  customerProfile_phone_number: "Phone Number",
  customerProfile_email: "Email",
  customerProfile_address_line_1: "Address Line 1",
  customerProfile_address_line_2: "Address Line 2",
  customerProfile_suburb_city: "City",
  customerProfile_state_province: "State/Province",
  customerProfile_country: "Country",
  customerProfile_zip_postcode: "Zip/Postcode",
  customerProfile_store_name: "Store Name",
  customerProfile_created_at: "Created At",
  customerProfile_customer_orders: "Order List"
};

// src/locales/en/dashboard.ts
var dashboard_default = {
  dashboard_customers_report_title: "Customers Report",
  dashboard_customers_report_view_all: "View All Reports",
  dashboard_action_bar_all_stores: "All Stores",
  dashboard_action_bar_filter_by_store: "Filter by store",
  dashboard_action_bar_create_account: "Create an Account",
  dashboard_action_bar_create_store: "Create a Store",
  dashboard_latest_orders_title: "Latest Orders",
  dashboard_latest_orders_view_all: "View All Orders",
  dashboard_latest_orders_id: "ID",
  dashboard_latest_orders_platform_order_id: "Platform Order ID",
  dashboard_latest_orders_store_name: "Store Name",
  dashboard_latest_orders_date: "Date",
  dashboard_latest_orders_status: "Status",
  dashboard_latest_orders_source: "Source",
  dashboard_latest_orders_total: "Total",
  dashboard_newest_accounts_title: "Newest Accounts",
  dashboard_newest_accounts_view_all: "View All Accounts",
  dashboard_newest_accounts_view_details: "View Details",
  dashboard_orders_revenue_title: "Orders Revenue",
  dashboard_orders_revenue_view_all: "View All Revenue",
  dashboard_orders_revenue_weekly: "Weekly",
  dashboard_orders_revenue_daily: "Daily",
  dashboard_over_view_store_revenue: "Store Revenue",
  dashboard_over_view_store_revenue_total: "Total Store Revenue",
  dashboard_over_view_orders: "Orders",
  dashboard_over_view_orders_total: "Total Orders",
  dashboard_over_view_items_sold: "Total Items Sold",
  dashboard_over_view_products_total: "Total Products Sold",
  dashboard_over_view_order_revenue: "Order Revenue",
  dashboard_over_view_order_revenue_total: "Total Order Revenue",
  dashboard_over_view_fulfilled_orders: "Fulfilled Orders",
  dashboard_over_view_fulfilled_orders_total: "Total Fulfilled Orders",
  dashboard_product_orders_title: "Orders By Product",
  dashboard_product_orders_view_all: "View All Products",
  dashboard_promotion_utilization_title: "Promotion Utilization",
  dashboard_promotion_utilization_view_all: "View All Promotions",
  dashboard_promotion_utilization_store_name: "Store Name",
  dashboard_promotion_utilization_store_hash: "Store Hash",
  dashboard_promotion_utilization_promotion_name: "Promotion Name",
  dashboard_promotion_utilization_coupon: "Coupon",
  dashboard_promotion_utilization_usage: "Usage"
};

// src/locales/en/forgotPassword.ts
var forgotPassword_default = {
  forgotPassword_page_title: "Forgot Password",
  forgotPassword_form_submit_button: "Reset Password",
  forgotPassword_form_account_label: "Account",
  forgotPassword_form_verify_code_label: "Verify Code",
  forgotPassword_form_email_placeholder: "Please enter your email address.",
  forgotPassword_form_verify_code_placeholder: "Please enter the verification code.",
  forgotPassword_form_email_validation: "Please enter your email address.",
  forgotPassword_form_verify_code_required: "Verify Code is a required field.",
  forgotPassword_form_have_account: "Already have an account?",
  forgotPassword_form_login: "Log in",
  forgotPassword_captcha_loading_failure: "Loading failure",
  forgotPassword_success_message: "The verification code is correct. Please check the email."
};

// src/locales/en/layout.ts
var layout_default = {
  layout_route_text_stores: "Stores",
  layout_route_text_dashboard: "Dashboard",
  layout_route_text_account: "Accounts",
  layout_route_text_content: "Content",
  layout_route_text_products: "Catalog",
  layout_route_text_orders: "Orders",
  layout_route_text_promotions: "Promotions",
  layout_route_text_themes: "Themes",
  layout_route_text_onboarding: "Onboarding",
  layout_route_text_provisioning_profiles: "Provisioning Profiles",
  layout_route_text_customer_profiles: "Customer Profiles",
  layout_route_text_reports: "Reports",
  layout_route_text_settings: "Settings",
  loyout_global_permission_denied: "Permission denied!",
  loyout_app_brand_title: "CommerceHub Dealer Management Portal",
  loyout_app_platform_bigcommerce: "BigCommerce Platform",
  loyout_app_platform_shopify: "Shopify Platform",
  loyout_app_logout: "Logout",
  loyout_app_menu_copyright: "Copyright \xA9 {{fullYear}} Silk Software Corp. All Rights Reserved"
};

// src/locales/en/login.ts
var login_default = {
  login_page_title: "Log in",
  login_form_submit_button: "Sign in",
  login_form_account_label: "Account",
  login_form_password_label: "Password",
  login_form_email_placeholder: "Please enter your email address.",
  login_form_password_placeholder: "Please enter your password.",
  login_form_email_validation: "Please enter your email address.",
  login_form_forgot_password: "Forgot Password?",
  login_recaptcha_loading: "reCAPTCHA is loading. Please wait for a moment and try again"
};

// src/locales/en/onboarding.ts
var onboarding_default = {
  onboarding_page_title: "Onboarding Configuration",
  onboarding_bounce_rate_title: "Bounce Rate",
  onboarding_bounce_rate_weekly: "Weekly",
  onboarding_bounce_rate_daily: "Daily",
  onboarding_wizard_title: "Wizard",
  onboarding_wizard_edit_forms: "Edit Forms",
  onboarding_wizard_save: "Save",
  onboarding_wizard_success: "Success!",
  onboarding_wizard_error: "Error!",
  onboarding_wizard_form_customer_information: "Customer Information Form",
  onboarding_wizard_form_products: "Products",
  onboarding_wizard_form_themes: "Themes",
  onboarding_wizard_form_gateway: "Gateway",
  onboarding_wizard_form_billing: "Billing",
  onboarding_wizard_form_description: "Description",
  onboarding_wizard_form_description_placeholder: "Please enter a description...",
  onboarding_wizard_form_description_optional: " (optional)",
  onboarding_wizard_form_required_error: "Customer Information Form field is required.",
  onboarding_themes_title: "Themes",
  onboarding_themes_add_themes: "Add Themes",
  onboarding_themes_remove: "Remove",
  onboarding_themes_no_permission: "Don't have permission.",
  onboarding_themes_success: "Success!",
  onboarding_themes_modal_select_themes: "Select Themes",
  onboarding_themes_modal_cancel: "Cancel",
  onboarding_themes_modal_save: "Save",
  onboarding_themes_modal_success: "Success!",
  onboarding_themes_modal_styles: "styles",
  onboarding_themes_modal_utilization: "Utilization:",
  onboarding_themes_modal_search_placeholder: "Search themes...",
  onboarding_themes_loading_failure: "Loading failure",
  onboarding_themes_remove_modal_title: "The selected theme will be removed from the onboarding configuration portion.",
  onboarding_themes_remove_modal_cancel: "Cancel",
  onboarding_themes_remove_modal_delete: "Delete",
  onboarding_themes_remove_modal_success: "Success!",
  onboarding_themes_remove_modal_error: "Remove styles failed.",
  onboarding_category_profiles_title: "Category Profiles",
  onboarding_category_profiles_add_profile: "Add Profile",
  onboarding_category_profiles_remove: "Remove",
  onboarding_category_profiles_profiles: "Profiles",
  onboarding_category_profiles_table_profile_name: "Profile Name",
  onboarding_category_profiles_table_utilization: "Utilization",
  onboarding_category_profiles_table_products: "Products",
  onboarding_category_profiles_table_created_at: "Created at",
  onboarding_category_profiles_table_action: "Action",
  onboarding_category_profiles_select_modal_title: "Select Provisioning Profiles",
  onboarding_category_profiles_select_modal_cancel: "Cancel",
  onboarding_category_profiles_select_modal_add_profile: "Add Profile",
  onboarding_category_profiles_select_modal_success: "Success!",
  onboarding_category_profiles_select_modal_no_permission: "Don't have permission.",
  onboarding_category_profiles_select_modal_qty_products: "Qty Products",
  onboarding_category_profiles_select_modal_themes: "Themes",
  onboarding_category_profiles_select_modal_search_placeholder: "Search profiles..."
};

// src/locales/en/orders.ts
var orders_default = {
  orders_list_page_title: "Order Management",
  orders_list_filter_export: "Export",
  orders_list_filter_dateRange: "Date Range",
  orders_list_filter_search: "Search Orders",
  orders_list_status_ALL: "All",
  orders_list_status_PENDING: "Pending",
  orders_list_status_UNFULFILLED: "Unfulfilled",
  orders_list_status_IN_PROGRESS: "In Progress",
  orders_list_status_PARTIALLY_FULFILLED: "Partially Fulfilled",
  orders_list_status_FULFILLED: "Fulfilled",
  orders_list_status_CANCELLED: "Cancelled",
  orders_list_platform_ALL: "All Sources",
  orders_list_platform_Shopify: "Shopify",
  orders_list_platform_Bigcommerce: "BigCommerce",
  orders_list_columns_OrderID: "Order ID",
  orders_list_columns_OrderPlatformOrderID: "Platform Order ID",
  orders_list_columns_OrderName: "Order Name",
  orders_list_columns_OrderStore: "Store Name",
  orders_list_columns_OrderDate: "Date",
  orders_list_columns_OrderStatus: "Status",
  orders_list_columns_OrderPaymentStatus: "Payment Status",
  orders_list_columns_OrderSource: "Source",
  orders_list_columns_OrderCustomerName: "Customer Name",
  orders_list_columns_OrderTotal: "Total",
  orders_list_columns_OrderShipping: "Order Shipping",
  order_detail_page_title: "Order Detail",
  order_detail_info_OrderID: "Order ID",
  order_detail_info_OrderProducts: "Products",
  order_detail_info_OrderPrice: "Price",
  order_detail_info_OrderStatus: "Status",
  order_detail_info_OrderCustomer: "Customer",
  order_detail_info_OrderDate: "Date",
  order_detail_info_OrderAddress: "Address",
  order_detail_product_name: "Product Name",
  order_detail_product_quantity: "Quantity",
  order_detail_product_totalprice: "Total",
  order_detail_shoppingAddress_firstName: "First Name",
  order_detail_shoppingAddress_lastName: "Last Name",
  order_detail_shoppingAddress_email: "Email",
  order_detail_shoppingAddress_phone: "Phone",
  order_detail_shoppingAddress_zip: "Zip",
  order_detail_shoppingAddress_country: "Country",
  order_detail_shoppingAddress_country_iso2: "Country_iso2",
  order_detail_shoppingAddress_city: "City",
  order_detail_shoppingAddress_state: "State",
  order_detail_shoppingAddress_company: "Company",
  order_detail_shoppingAddress_address1: "Street 1",
  order_export_radio_filtered: "Filtered orders ({{count}} orders)",
  order_export_radio_all: "All orders"
};

// src/locales/en/packages.ts
var packages_default = {
  package_ui_d5Form_required: "{{name}} is a required field.",
  package_ui_d5Form_correctFormat: "Please enter the correct format",
  package_ui_d5Form_maxLength: "{{name}} cannot be more than {{length}} characters",
  package_ui_d5Form_please: "Please ",
  package_ui_d5Form_fileInput_context: "Click or drag file to this area to upload",
  package_ui_d5Export_success: "Export success, we will send you an email later, please check it.",
  package_ui_d5Export_title: "Are you sure?",
  package_ui_d5Export_btn_cancelText: "Cancel",
  package_ui_d5Export_btn_okText: "OK",
  package_ui_d5Export_context: "Exporting data as a CSV file may take some time. Once the CSV file export succeeds, we'll email you so you can download it from the email.",
  package_ui_d5Export_order_range: "Export Orders Range",
  package_ui_d5ImageUpload_alt: "Loading failure",
  package_ui_d5ImageUpload_upload: "Upload",
  package_ui_d5Import_success: "Import success, we will send you an email later, please check it.",
  package_ui_d5Import_btn_cancelText: "Cancel",
  package_ui_d5Import_btn_okText: "Start import",
  package_ui_d5Loading_context: "Loading...",
  package_ui_d5Loading_certification_left: "Copyright \xA9",
  package_ui_d5Loading_certification_right: "Silk Software Corp. All Rights Reserved",
  package_ui_d5Layout_layoutFrame_h2_title: "CommerceHub",
  package_ui_d5Layout_layoutFrame_title: "Dealer Management Portal"
};

// src/locales/en/product.ts
var product_default = {
  product_list_page_title: "Product Management",
  product_list_import_template_text_1: "Step 1 - Download Catalog Import Template",
  product_list_import_template_text_2: "We recommend you to",
  product_list_import_template_link_3: "download the template",
  product_list_import_template_text_4: "before import files and the CSV fields should be in following order: Image URL, Product Name, Price, Inventory, SKU,Categories, Description.",
  product_list_import_template_text_5: "Step 2 - Import products as CSV",
  product_list_action_click_validate: "Click too fast, please try again later.",
  product_list_action_pull_success: "Successfully pulled.",
  product_list_action_modal_pull_header: "Update Merchant Stores?",
  product_list_action_export_btn_text: "Export",
  product_list_action_push_selected_product: "Push Selected Products",
  product_list_action_push_all_product: "Push All Products",
  product_list_filter_status_enable: "Enable",
  product_list_filter_status_disable: "Disable",
  product_list_filter_label_search: "Search",
  product_list_filter_label_search_placeholder: "search",
  product_list_filter_label_status: "Status",
  product_list_filter_label_status_placeholder: "Select status",
  product_list_filter_label_category: "Category",
  product_list_filter_label_category_placeholder: "All catagories",
  product_list_filter_form_product_name: "Product Name",
  product_list_filter_form_product_name_placeholder: "type the product name",
  product_list_filter_form_product_sku: "SKU",
  product_list_filter_form_product_sku_placeholder: "type the SKU",
  product_list_filter_form_product_price: "Price",
  product_list_filter_form_product_price_placeholder: " (equals)",
  product_list_filter_form_product_price_validate: "Please enter number in the text field.",
  product_list_filter_form_product_inventory: "Inventory",
  product_list_filter_form_product_inventory_placeholder: " (equals)",
  product_list_table_form_product_image: "Image",
  product_list_table_form_product_name: "Product Name",
  product_list_table_form_product_price: "Product Price",
  product_list_table_form_product_inventory: "Inventory",
  product_list_table_form_product_sku: "SKU",
  product_list_table_form_product_status: "Status",
  product_list_table_form_product_action: "Action",
  product_list_table_form_action_remove: "Remove",
  product_list_table_form_action_detail: "View Detail",
  product_list_table_form_action_distributor_visibility: "Distributor Visibility",
  product_list_table_form_action_delete_permanently: "Delete Permanently",
  product_list_table_form_action_restore_product: "Restore Product",
  product_list_table_form_product_languages: "Language Types",
  product_push_page_title: "Push Products",
  product_push_page_description: "Add Selected Products to specific stores may affect order history, reports, and potentially other data.",
  product_push_page_form_product_name: "Product Name",
  product_push_page_form_product_name_validate: "Product Name is required",
  product_push_page_form_product_name_placeholder: 'All products"',
  product_push_page_form_select_store: "Select store",
  product_push_page_form_select_store_placeholder: "Select store",
  product_push_page_form_target_language: "Target Language",
  product_push_page_form_target_language_tooltip: "If the language of your store does not match the target language you have selected, the product may be pushed to your store as a translated version",
  product_push_page_form_confirm: "Confirm",
  product_push_page_form_confirm_validate: "Please type word 'CONFIRM'",
  product_push_page_form_confirm_placeholder: "Please type word 'CONFIRM'",
  product_push_page_message_success: `Add product successfully. 
     Please check your email for detailed results. 
     It will return to the previous page in three seconds.`,
  product_action_remove_message_success: "Remove product successfully",
  product_action_remove_text: "This product will be removed from Distributed Commerce Hub, it won&apos;t affect products in your stores.",
  product_action_remove_form_product_name: "Product Name",
  product_action_remove_form_product_name_placeholder: "Please type Product Name",
  product_action_remove_form_product_name_validate: "Product Name is required",
  product_action_remove_form_confirm: "SKU",
  product_action_remove_form_confirm_placeholder: "Please type word 'CONFIRM'",
  product_action_remove_form_confirm_validate: "Please type word 'CONFIRM'",
  product_detail_page_title: "Product Detail",
  product_detail_page_SKU: "SKU",
  product_detail_page_button_save: "Save Changes",
  product_detail_page_button_delete: "Delete",
  product_detail_page_button_edit: "Edit",
  product_detail_page_button_change_image: "Change Image",
  product_detail_page_product_information: "Product Information",
  product_detail_page_product_image: "Product Image",
  product_detail_page_product_no_image: "No Image",
  product_detail_page_dimensions_label: "Dimensions",
  product_detail_page_dimensions_label_tip: "Width x Height x Depth, eg.(2.5 x 2.5 x 6.5)",
  product_detail_page_form_category: "Category",
  product_detail_page_form_product_name: "Product Name",
  product_detail_page_form_sku: "SKU",
  product_detail_page_form_description: "Description",
  product_detail_page_form_brand: "Brand",
  product_detail_page_form_status: "Status",
  product_detail_page_form_regular_price: "Regular Price",
  product_detail_page_form_sale_price: "Sale Price",
  product_detail_page_form_inventory: "Inventory",
  product_detail_page_form_weight: "Weight",
  product_detail_page_form_dimension: "",
  product_detail_metafields_section: "metafields",
  product_detail_metafields_key: "Key",
  product_detail_metafields_type: "Type",
  product_detail_metafields_value: "Value",
  product_detail_page_tags_title: "Tags",
  product_detail_page_tags_add_button: "Add Tag",
  product_detail_page_tags_modal_title: "Select Tags",
  product_detail_page_tags_modal_close: "Close",
  product_detail_page_tags_search_placeholder: "Search by tag name or category...",
  product_detail_page_tags_selected_count: "{{count}} tags selected",
  product_detail_page_tags_not_found: 'No tags found matching "{{search}}"',
  product_detail_page_language_type: "Language Type",
  product_disabled_distributor_modal_title: "Distributor Visibility",
  product_disabled_distributor_modal_cancel: "Cancel",
  product_disabled_distributor_modal_save: "Save Changes",
  product_disabled_distributor_button_disable_all: "Disable All",
  product_disabled_distributor_checkbox_description: "disable this product in distributor portal",
  product_disabled_distributor_update_success: "Distributor visibility updated successfully",
  product_soft_delete_modal_title: "Delete Product",
  product_soft_delete_modal_confirm: "This product will be removed from the product list. If you wish to retrieve it, you can restore it in the 'Deleted' tab.",
  product_restore_modal_title: "Restore Product",
  product_restore_modal_button_restore: "Restore",
  product_action_restore_success: "Product restored successfully",
  product_restore_modal_confirm: "Restore: Confirm restoring this product? After restoration, it will be viewable and operable normally in the product list.",
  product_list_toggle_products: "Products",
  product_list_toggle_deletes: "Deleted",
  product_variants_modal_title: "Edit Product Variants",
  product_variants_modal_cancel: "Cancel",
  product_variants_modal_update: "Update Variants",
  product_variants_current_variants: "Current Variants",
  product_variants_generated_variants: "Generated variants:",
  product_variants_current_options: "Current options:",
  product_variants_modification_warning: "Modifying variants will replace all existing variants with the new configuration. Make sure to configure all desired variants before saving.",
  product_variants_options_title: "Variant Options",
  product_variants_add_option: "Add Option",
  product_variants_option_number: "Option {{number}}",
  product_variants_edit: "Edit",
  product_variants_option_name: "Option Name",
  product_variants_option_type: "Option Type",
  product_variants_not_set: "Not set",
  product_variants_values: "Values",
  product_variants_option_name_required: "Option Name *",
  product_variants_option_name_placeholder: "e.g., Size, Color, Material",
  product_variants_option_type_required: "Option Type*",
  product_variants_option_type_placeholder: "Select option type",
  product_variants_values_required: "Values *",
  product_variants_value_placeholder: "Enter value",
  product_variants_colors_label: "Colors:",
  product_variants_color_placeholder: "Color value (e.g., #ff0000)",
  product_variants_add_color: "Add Color",
  product_variants_max_colors: "Maximum 3 colors allowed",
  product_variants_add_first_value: "Add First Value",
  product_variants_add_value: "Add Value",
  product_variants_cancel: "Cancel",
  product_variants_done: "Done",
  product_variants_no_values: "No values added",
  product_variants_summary: "Summary",
  product_variants_options_count: "Options:",
  product_variants_total_combinations: "Total Combinations:",
  product_variants_bulk_price_title: "Set regular price for all variants:",
  product_variants_price_error: "The price must be greater than 0",
  product_variants_confirm: "Confirm",
  product_variants_type_swatch: "Swatch",
  product_variants_type_radio_buttons: "Radio Buttons",
  product_variants_type_rectangle_list: "Rectangle List",
  product_variants_type_dropdown: "Dropdown"
};

// src/locales/en/promotion.ts
var promotion_default = {
  promotion_list_tab_automatic: "Automatic",
  promotion_list_tab_coupon: "Coupon",
  promotion_list_automatic_create_promotion: "Create a Promotion",
  promotion_list_automatic_push_promotion: "Push Promotion",
  promotion_list_automatic_filter_promotion_name: "Promotion Name",
  promotion_list_automatic_filter_promotion_name_extra: " (contains)",
  promotion_list_automatic_filter_currency: "Currency",
  promotion_list_automatic_filter_currency_extra: " (contains)",
  promotion_list_automatic_filter_start_date: "Start",
  promotion_list_automatic_filter_end_date: "End",
  promotion_list_automatic_filter_date_extra: " (equals)",
  promotion_list_automatic_table_columns_promotion_name: "Promotion Name",
  promotion_list_automatic_table_columns_currency: "Currency",
  promotion_list_automatic_table_columns_start_date: "Start",
  promotion_list_automatic_table_columns_end_date: "End",
  promotion_list_automatic_table_columns_redemption_type: "Promotion Type",
  promotion_list_coupon_create_promotion: "Create a Promotion",
  promotion_list_coupon_push_promotion: "Push Promotion",
  promotion_list_coupon_filter_promotion_name: "Promotion Name",
  promotion_list_coupon_filter_promotion_name_extra: " (contains)",
  promotion_list_coupon_filter_coupon_code: " Coupon Code",
  promotion_list_coupon_filter_coupon_code_extra: " (contains)",
  promotion_list_coupon_filter_currency: "Currency",
  promotion_list_coupon_filter_currency_extra: " (contains)",
  promotion_list_coupon_filter_start_date: "Start",
  promotion_list_coupon_filter_end_date: "End",
  promotion_list_coupon_filter_date_extra: " (equals)",
  promotion_list_coupon_table_columns_promotion_name: "Promotion Name",
  promotion_list_coupon_table_columns_coupon_code: "Coupon Code",
  promotion_list_coupon_table_columns_currency: "Currency",
  promotion_list_coupon_table_columns_start_date: "Start",
  promotion_list_coupon_table_columns_end_date: "End",
  promotion_list_coupon_table_columns_redemption_type: "Promotion Type",
  promotion_list_table_action_edit: "Edit",
  promotion_list_table_action_stop: "Stop",
  promotion_list_table_action_duplicate: "Duplicate",
  promotion_list_pull_promotion_btn: "Pull Promotions from Master Store",
  promotion_list_pull_promotion_header: "Update Merchant Stores?",
  promotion_list_stop_promotion_description: "Stop the promotion will remove the discounts from stores.",
  promotion_list_stop_promotion_columns_promotion_name: "Promotion Name",
  promotion_list_stop_promotion_columns_promotion_name_required: "Promotion Name is required",
  promotion_list_stop_promotion_columns_promotion_name_placeholder: "Please type Promotion Name",
  promotion_list_stop_promotion_columns_confirm: "Confirm",
  promotion_list_stop_promotion_columns_confirm_required: "Please type word 'CONFIRM'",
  promotion_list_stop_promotion_columns_confirm_placeholder: "Please type word 'CONFIRM'",
  promotion_list_push_promotion_page_title: "Push Promotion",
  promotion_list_push_promotion_description: "Add Promotion to selected stores may affect order history, reports, and potentially other data.",
  promotion_list_push_promotion_submit_error: "Don't have permission to push promotions.",
  promotion_list_push_promotion_submit_success: "Add promotion successfully. It will return to the previous page in three seconds.",
  promotion_list_push_promotion_columns_promotion_name: "Promotion Name",
  promotion_list_push_promotion_columns_promotion_name_required: "Promotion Name is required",
  promotion_list_push_promotion_columns_promotion_name_placeholder: "Please type Promotion Name",
  promotion_list_push_promotion_columns_stores: "Stores",
  promotion_list_push_promotion_columns_stores_placeholder: "Select store",
  promotion_list_push_promotion_columns_confirm: "Confirm",
  promotion_list_push_promotion_columns_confirm_required: "Please type word 'CONFIRM'",
  promotion_list_push_promotion_columns_confirm_placeholder: "Please type word 'CONFIRM'",
  promotion_bc_add_page_title: "Create Promotion",
  promotion_bc_add_active_columns_ctive_now_title_text: "Activate Now?",
  promotion_bc_add_active_columns_is_active_text: "Yes, make this discount available to customers",
  promotion_bc_add_limits_columns_limits_title_text: "Use limits",
  promotion_bc_add_limits_columns_limits: "Limit total usage of this promotion",
  promotion_bc_add_limits_columns_limits_options_no_limit: "No limit for total usage of promotions",
  promotion_bc_add_limits_columns_limits_options_usage_limit: "Limited for total usage of promotions",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_header: "Allows other promotions",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_text: "This promotion",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_select_used: "can be used",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_select_not_used: "can not be used",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_other_text: "use with other promotions.",
  promotion_bc_add_rule_header: "Rule",
  promotion_bc_add_rule_text: "What conditions must a customer satisfy, to receive the discount you are offering?",
  promotion_bc_add_rule_columns_condition: "Condition",
  promotion_bc_add_rule_columns_condition_buy_products_render: "Buys {{minimum_quantity}} Products",
  promotion_bc_add_rule_columns_condition_reaches_subtotal_render: "Reaches an order sub-total of {{minimum_spend}}",
  promotion_bc_add_rule_columns_condition_order_qty_render: "Customer has placed at least {{minimum_order_count}} orders",
  promotion_bc_add_rule_columns_condition_no_render: "No condition",
  promotion_bc_add_rule_columns_reward: "Reward",
  promotion_bc_add_rule_columns_reward_gift_item_render: "A gift in their cart",
  promotion_bc_add_rule_columns_reward_free_shipping_render: "Free Shipping",
  promotion_bc_add_rule_columns_reward_discount_order_render: "Discount on order subtotal",
  promotion_bc_add_rule_columns_reward_discount_products_render: "Discount on products",
  promotion_bc_add_rule_columns_reward_fixed_price_render: "{{fixed_price}} price fixed on products",
  promotion_bc_add_search_products_add_button_text: "Click to add a product selector",
  promotion_bc_add_search_products_error_no_selection: "Need to add at least one product here.",
  promotion_bc_add_search_products_modal_title: "Select Products",
  promotion_bc_add_search_products_table_banner: "Banner",
  promotion_bc_add_search_products_table_name: "Product Name",
  promotion_bc_add_search_products_table_sku: "Sku",
  promotion_bc_add_search_products_table_price: "Product Price",
  promotion_bc_add_search_products_table_image_alt: "Loading failure",
  promotion_bc_add_search_products_table_item_name: "Products",
  promotion_bc_add_search_products_cancel_button: "Cancel",
  promotion_bc_add_search_products_save_button: "Save",
  promotion_bc_add_summary_title: "Summary",
  promotion_bc_add_promotion_name: "Promotion Name",
  promotion_bc_add_promotion_name_placeholder: "Please type your promotion name here",
  promotion_bc_add_promotion_type: "Promotion Type",
  promotion_bc_add_select_placeholder: "Selection",
  promotion_bc_add_coupon_code_label: "Coupon Code",
  promotion_bc_add_coupon_code_placeholder: "Enter your coupon code",
  promotion_bc_add_schedule_title: "Schedule",
  promotion_bc_add_start_at_label: "Start at",
  promotion_bc_add_end_at_label: "End at",
  promotion_bc_add_select_date_placeholder: "Select date",
  promotion_bc_add_schedule_toggle_button: "Specific Date / Time",
  promotion_bc_add_schedule_week_label: "Every week",
  promotion_bc_add_schedule_day_label: "Day",
  promotion_bc_add_schedule_day_placeholder: "Select day",
  promotion_bc_add_schedule_time_label: "Time",
  promotion_bc_add_schedule_to_label: "to",
  promotion_bc_add_clear_button: "Clear",
  promotion_bc_add_targeting_title: "Targeting",
  promotion_bc_add_targeting_sub_title: "Target customer if...",
  promotion_bc_add_currency_is: "Currency is",
  promotion_bc_add_customer_group: "Customer Group",
  promotion_bc_add_is: "is",
  promotion_bc_add_is_not: "isNot",
  promotion_bc_add_select_group: "Select Group",
  promotion_bc_add_shipping_destination: "Shipping Destination",
  promotion_bc_add_select_zone: "Select zones",
  promotion_bc_add_selection: "Selection",
  promotion_bc_add_template_rules_button: "Add Template Rules",
  promotion_bc_add_template_rules_modal_title: "Select a Template Rules",
  promotion_bc_add_rules_addition_reaching_label: "Reaching",
  promotion_bc_add_rules_addition_reaching_products_quantity: "Products Quantity",
  promotion_bc_add_rules_addition_reaching_order_total_value: "Order Total Value",
  promotion_bc_add_rules_addition_minimum_spend_label: "Minimize cost on the order",
  promotion_bc_add_rules_addition_minimum_order_count_label: "Qty of the order placed by the customer",
  promotion_bc_add_rules_addition_no_condition_text: "Any orders by the customer will trigger this reward.",
  promotion_bc_add_rules_addition_including_products_label: "Including products",
  promotion_bc_add_rules_addition_including_products_product: "Individual Products",
  promotion_bc_add_rules_addition_including_products_category: "In category",
  promotion_bc_add_rules_addition_including_products_brand: "In brand",
  promotion_bc_add_rules_addition_gift_title: "Product quantity in the customer\u2019s cart for free.",
  promotion_bc_add_rules_addition_gift_apply_once_once: "Once",
  promotion_bc_add_rules_addition_gift_apply_once_unlimited: "Unlimited times",
  promotion_bc_add_rules_addition_product_label: "Select Products",
  promotion_bc_add_rules_addition_shipping_zone_title: "Select Zones",
  promotion_bc_add_rules_addition_shipping_zone_placeholder: "Selection",
  promotion_bc_add_rules_addition_shipping_zone_option_all: "All zones",
  promotion_bc_add_rules_addition_shipping_zone_option_selected: "Selected zones",
  promotion_bc_add_rules_addition_cart_apply_once_once: "Once",
  promotion_bc_add_rules_addition_cart_apply_once_unlimited: "Unlimited times",
  promotion_bc_add_rules_addition_cart_fixed_type_label: "Product price",
  promotion_bc_add_rules_addition_cart_fixed_type_percentage: "Percentage",
  promotion_bc_add_rules_addition_cart_fixed_type_amount: "Amount",
  promotion_bc_add_rules_addition_cart_as_total_each: "Each product's price",
  promotion_bc_add_rules_addition_cart_as_total_total: "Total price of included products",
  promotion_bc_add_rules_addition_cart_quantity_type_label: "Product quantity applied on",
  promotion_bc_add_rules_addition_cart_quantity_type_all: "All",
  promotion_bc_add_rules_addition_cart_quantity_type_up_to: "Up to",
  promotion_bc_add_rules_addition_cart_checkbox_sale: "Including products already on sale",
  promotion_bc_add_rules_addition_cart_checkbox_condition: "Including products that satisfy the condition",
  promotion_bc_add_rules_addition_cart_include_type_label: "Including products",
  promotion_bc_add_rules_addition_cart_include_type_product: "Individual Products",
  promotion_bc_add_rules_addition_cart_include_type_category: "In category",
  promotion_bc_add_rules_addition_cart_include_type_brand: "In brand",
  promotion_bc_add_rules_addition_fixed_amount_label: "Discount from the order sub-total by",
  promotion_bc_add_rules_addition_fixed_apply_to: "Apply to products in cart",
  promotion_bc_add_rules_addition_fixed_apply_to_least: "Least_expensive",
  promotion_bc_add_rules_addition_fixed_apply_to_most: "Most_expensive",
  promotion_bc_add_rules_addition_fixed_quantity_label: "Quantity of products",
  promotion_bc_add_rules_addition_order_subtotal_title: "Discount from the order sub-total by",
  promotion_bc_add_rules_addition_order_subtotal_apply_once_once: "Once",
  promotion_bc_add_rules_addition_order_subtotal_apply_once_unlimited: "Unlimited times",
  promotion_bc_add_rules_addition_order_subtotal_type_value: "Value",
  promotion_bc_add_rules_addition_order_subtotal_type_percentage: "Percentage",
  promotion_bc_add_rules_addition_condition_buy_products: "Buy Products",
  promotion_bc_add_rules_addition_condition_customer_label: "If the customer",
  promotion_bc_add_rules_addition_condition_reaches_subtotal: "Reaches an order sub-total",
  promotion_bc_add_rules_addition_condition_order_qty: "Qty of the order placed by the customer",
  promotion_bc_add_rules_addition_condition_no_conditions: "No conditions",
  promotion_bc_add_rules_addition_action_gift_item: "A gift in their cart",
  promotion_bc_add_rules_addition_action_shipping: "Free Shipping",
  promotion_bc_add_rules_addition_action_cart_items: "Discount on products",
  promotion_bc_add_rules_addition_action_cart_value: "Discount on order subtotal",
  promotion_bc_add_rules_addition_action_fixed_price_set: "Fixed price for # of products",
  promotion_shopify_discount_type_selector_header: "Select discount type",
  promotion_shopify_discount_type_selector_type_product_title: "Amount off products",
  promotion_shopify_discount_type_selector_type_product_description: "Discount specific products or collections of products",
  promotion_shopify_discount_type_selector_type_buyxgety_title: "Buy X get Y",
  promotion_shopify_discount_type_selector_type_buyxgety_description: "Discount specific products or collections of products",
  promotion_shopify_discount_type_selector_type_order_title: "Amount off order",
  promotion_shopify_discount_type_selector_type_order_description: "Discount the total order amount",
  promotion_shopify_discount_type_selector_type_shipping_title: "Free shipping",
  promotion_shopify_discount_type_selector_type_shipping_description: "Offer free shipping on an order",
  promotion_shopify_discount_type_selector_cancel: "Cancel",
  promotion_shopify_add_page_edit_title: "Edit Promotion",
  promotion_shopify_add_page_create_title: "Create Promotion",
  promotion_shopify_buy_x_get_y_form_title: "Buy X get Y",
  promotion_shopify_buy_x_get_y_form_customer_buys: "Customer buys",
  promotion_shopify_buy_x_get_y_form_customer_buys_lists_quantity: "Minimum quantity of items",
  promotion_shopify_buy_x_get_y_form_customer_buys_lists_purchase: "Minimum purchase amount",
  promotion_shopify_buy_x_get_y_form_quantity: "Quantity",
  promotion_shopify_buy_x_get_y_form_quantity_validate: "Specify a quantity of products the customer must buy",
  promotion_shopify_buy_x_get_y_form_amount: "Amount",
  promotion_shopify_buy_x_get_y_form_amount_validate: "Specify an amount the customer must spend",
  promotion_shopify_buy_x_get_y_form_customer_gets: "Customer gets",
  promotion_shopify_buy_x_get_y_form_customer_gets_description: "Customers must add the quantity of items specified below to their cart.",
  promotion_shopify_buy_x_get_y_form_gets_quantity: "Quantity",
  promotion_shopify_buy_x_get_y_form_gets_quantity_validate: "Specify a quantity of products the customer will get",
  promotion_shopify_buy_x_get_y_form_gets_specific_products_label: "Any items from",
  promotion_shopify_buy_x_get_y_form_gets_specific_products_option_product: "Specific products",
  promotion_shopify_buy_x_get_y_form_gets_specific_products_validate: "Specify a product the customer will get",
  promotion_shopify_buy_x_get_y_form_gets_discount_type_percentage: "Percentage",
  promotion_shopify_buy_x_get_y_form_gets_discount_type_amount: "Amount off each",
  promotion_shopify_buy_x_get_y_form_gets_discount_type_free: "Free",
  promotion_shopify_buy_x_get_y_form_gets_percentage_value_validate: "Discount value can't be blank",
  promotion_shopify_buy_x_get_y_form_gets_amount_off_each_description: "For multiple quantities, the discount amount will be taken off each Y item.",
  promotion_shopify_buy_x_get_y_form_gets_amount_off_each_value_validate: "Discount value can't be blank",
  promotion_shopify_buy_x_get_y_form_max_uses_label: "Set a maximum number of uses per order",
  promotion_shopify_buy_x_get_y_form_max_uses_value_validate: "Maximum number of uses per order can't be blank",
  promotion_shopify_free_form_countries: "Countries",
  promotion_shopify_free_form_country_type_all: "All countries",
  promotion_shopify_free_form_country_type_specific: "Selected countries",
  promotion_shopify_free_form_selected_country_description: "Search countries",
  promotion_shopify_free_form_selected_country_validate: "Specific countries must be added",
  promotion_shopify_free_form_shipping_rate_exclude_label: "Exclude shipping rates over a certain amount",
  promotion_shopify_free_form_shipping_rate_exclude_description: "Shipping rates",
  promotion_shopify_product_form_applies_to_label: "Applies to",
  promotion_shopify_product_form_applies_to_validate: "Specific products must be added",
  promotion_shopify_product_form_applies_to_option_product: "Specific products",
  promotion_shopify_discount_method_label: "Method",
  promotion_shopify_discount_method_method_label: "Discount Code",
  promotion_shopify_discount_method_method_code: "Discount Code",
  promotion_shopify_discount_method_method_automatic: "Automatic discount",
  promotion_shopify_discount_method_discount_code_label: "Discount Code",
  promotion_shopify_discount_method_discount_code_link: "Generate random code",
  promotion_shopify_discount_method_discount_code_description: "Customers must enter this code at checkout.",
  promotion_shopify_discount_method_discount_title_label: "Title",
  promotion_shopify_discount_method_discount_title_description: "Customers will see this in their cart and at checkout.",
  promotion_shopify_discount_value_label: "Discount Value",
  promotion_shopify_discount_value_type_percentage: "Percentage",
  promotion_shopify_discount_value_type_fixed: "Fixed amount",
  promotion_shopify_discount_value_validate_required: "Discount value can't be blank",
  promotion_shopify_availability_label: "Availability",
  promotion_shopify_availability_description: "Automatically applied on all sales channels you have set up except Point of Sale (POS)",
  promotion_shopify_availability_pos_label: "Apply on POS (Pro locations only)",
  promotion_shopify_minimum_purchase_requirements_label: "Minimum purchase requirements",
  promotion_shopify_minimum_purchase_requirements_lists_selectedType_option_none: "No minimum requirements",
  promotion_shopify_minimum_purchase_requirements_lists_selectedType_option_subtotal: "Minimum purchase amount ($)",
  promotion_shopify_minimum_purchase_requirements_lists_selectedType_option_quantity: "Minimum quantity of items",
  promotion_shopify_minimum_purchase_requirements_lists_amountValue_description: "Applies only to selected products.",
  promotion_shopify_minimum_purchase_requirements_lists_amountValue_validate: "Minimum purchase can't be blank",
  promotion_shopify_minimum_purchase_requirements_lists_quantityValue_description: "Applies only to selected products.",
  promotion_shopify_minimum_purchase_requirements_lists_quantityValue_validate: "Minimum quantity can't be blank",
  promotion_shopify_eligibility_label: "Eligibility",
  promotion_shopify_eligibility_description: "Redeemable on all sales channels you have set up",
  promotion_shopify_eligibility_lists_selectedEligibilityType_option_all: "All customers",
  promotion_shopify_eligibility_lists_selectedEligibilityType_option_specificCustomerSegments: "Specific customer segments",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_description: "Search customer segments",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_1: "Customers who haven't purchased",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_2: "Customers who have purchased more than once",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_3: "Abandoned checkouts in the last 30 days",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_4: "Email subscribers",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_5: "Customers who have purchased at least once",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_validate: "Customer selection a minimum of one prerequisite segment or prerequisite customer must be provided",
  promotion_shopify_maximum_discount_label: "Maximum discount uses",
  promotion_shopify_maximum_discount_lists_discountTotalNumber_label: "Limit number of times this discount can be used in total",
  promotion_shopify_maximum_discount_lists_limitOneUsePerCustomer_label: "Limit to one use per customer",
  promotion_shopify_maximum_discount_lists_discountTotalNumberValue_validate: "Total usage limit can't be blank",
  promotion_shopify_combinations_label: "Combinations",
  promotion_shopify_combinations_othersText_noCombineOtherDiscount: "This discount won't combine with any other discount at checkout",
  promotion_shopify_combinations_lists_product_label: "Product discounts",
  promotion_shopify_combinations_lists_product_description: "Each eligible item in the cart may receive up to one product discount",
  promotion_shopify_combinations_lists_order_label: "Order discounts",
  promotion_shopify_combinations_lists_order_description: "All eligible order discounts will apply in addition to eligible product discounts",
  promotion_shopify_combinations_lists_shipping_label: "Shipping discounts",
  promotion_shopify_combinations_lists_shipping_description: "The largest eligible shipping discount will apply in addition to eligible product discounts",
  promotion_shopify_active_dates_label: "Active Dates",
  promotion_shopify_active_dates_lists_startDate_label: "Start Date",
  promotion_shopify_active_dates_lists_startTime_label: "Start time",
  promotion_shopify_active_dates_lists_hasEndDate_label: "Set end date",
  promotion_shopify_active_dates_lists_endDate_label: "End date",
  promotion_shopify_active_dates_lists_endTime_label: "End time",
  promotion_shopify_product_discount_applies_to: "Applies to",
  promotion_shopify_product_discount_specific_products_must_be_added: "Specific products must be added",
  promotion_shopify_product_discount_specific_products: "Specific products",
  promotion_shopify_component_add_product_placeholder: "Search products",
  promotion_shopify_component_add_product_table_header: "Add products",
  promotion_shopify_component_add_product_table_th_products: "Products",
  promotion_shopify_component_add_product_table_th_total_available: "Total available",
  promotion_shopify_component_add_product_table_th_price: "Price",
  promotion_shopify_component_add_product_table_variants_selectd: "{{selectedVariantsCount}} variants selected",
  promotion_shopify_component_submit_button: "Save discard",
  promotion_shopify_component_submit_Discard: "Discard",
  promotion_shopify_add_country_placeholder: "Search countries",
  promotion_shopify_add_country_table_header: "Add countries",
  promotion_shopify_add_country_table_no_country: "No countries found",
  promotion_shopify_add_country_table_country_selectd: "{{selectedCountries}} countries selected"
};

// src/locales/en/provisioningProfiles.ts
var provisioningProfiles_default = {
  "provisioningProfiles.pageTitle": "Provisioning Profiles",
  "provisioningProfiles.addProfileToStores": "Add Profile to Stores",
  "provisioningProfiles.createProfile": "Create a Profile",
  "provisioningProfiles.noPermission": "Don't have permission.",
  "provisioningProfiles.shopify.addProfileToStores": "Add Profile to Stores",
  "provisioningProfiles.shopify.createSuccess": "Create provisioning profile success",
  "provisioningProfiles.shopify.editSuccess": "Edit provisioning profile success",
  "provisioningProfiles.shopify.addProductsBySKU": "Add Products by SKU",
  "provisioningProfiles.shopify.skuList": "SKU List",
  "provisioningProfiles.shopify.skuPlaceholder": "Paste SKU list here (one per line or comma separated) Example: SKU001, SKU002, SKU003, SKU004",
  "provisioningProfiles.shopify.apply": "Apply",
  "provisioningProfiles.shopify.cancel": "Cancel",
  "provisioningProfiles.shopify.notFound": "is not found",
  "provisioningProfiles.filter.search": "search",
  "provisioningProfiles.filter.expand": "Expand",
  "provisioningProfiles.filter.profileName": "Profile Name",
  "provisioningProfiles.filter.profileNameContains": " (contains)",
  "provisioningProfiles.filter.themes": "Themes",
  "provisioningProfiles.filter.themesContains": " (contains)",
  "provisioningProfiles.filter.promotions": "Promotions",
  "provisioningProfiles.filter.promotionsEquals": " (equals)",
  "provisioningProfiles.filter.qtyOfProducts": "Qty of Products",
  "provisioningProfiles.filter.qtyOfProductsEquals": " (equals)",
  "provisioningProfiles.filter.utilization": "Utilization",
  "provisioningProfiles.filter.utilizationEquals": " (equals)",
  "provisioningProfiles.filter.clear": "Clear",
  "provisioningProfiles.filter.apply": "Apply",
  "provisioningProfiles.table.profileName": "Profile Name",
  "provisioningProfiles.table.utilization": "Utilization",
  "provisioningProfiles.table.qtyOfProducts": "Qty of Products",
  "provisioningProfiles.table.themes": "Themes",
  "provisioningProfiles.table.createdAt": "Created at",
  "provisioningProfiles.table.action": "Action",
  "provisioningProfiles.action.edit": "Edit",
  "provisioningProfiles.action.remove": "Remove",
  "provisioningProfiles.action.delete": "Delete",
  "provisioningProfiles.delete.shopify.title": "This profile will be removed from all products, and potentially other data.",
  "provisioningProfiles.delete.title": "This profile will be removed from all stores and may affect catalog, themes, order history, reports, and potentially other data.",
  "provisioningProfiles.delete.profileName": "Profiles Name",
  "provisioningProfiles.delete.profileNameRequired": "Profiles Name is required",
  "provisioningProfiles.delete.profileNamePlaceholder": "Please type Profiles Name",
  "provisioningProfiles.delete.confirm": "Confirm",
  "provisioningProfiles.delete.confirmRequired": "Please type word 'CONFIRM'",
  "provisioningProfiles.delete.confirmValidator": "Please type word 'CONFIRM'",
  "provisioningProfiles.delete.confirmPlaceholder": "Please type word 'CONFIRM'",
  "provisioningProfiles.delete.cancel": "Cancel",
  "provisioningProfiles.delete.ok": "OK",
  "provisioningProfiles.delete.success": "Delete profiles successfully",
  "provisioningProfiles.create.pageTitle": "Create Profile",
  "provisioningProfiles.create.success": "Create Success",
  "provisioningProfiles.edit.pageTitle": "Edit Profile",
  "provisioningProfiles.edit.success": "Edit Success",
  "provisioningProfiles.form.summary": "Summary",
  "provisioningProfiles.form.name": "Profile Name",
  "provisioningProfiles.form.namePlaceholder": "please type the profile name here",
  "provisioningProfiles.form.industry": "Industry",
  "provisioningProfiles.form.industryPlaceholder": "please type the industry here",
  "provisioningProfiles.form.description": "Description",
  "provisioningProfiles.form.descriptionPlaceholder": "please type the description here",
  "provisioningProfiles.form.categories": "Categories",
  "provisioningProfiles.form.products": "Products",
  "provisioningProfiles.form.themes": "Themes",
  "provisioningProfiles.form.currentTheme": "Current Theme",
  "provisioningProfiles.form.themeList": "Theme List",
  "provisioningProfiles.form.image": "Image",
  "provisioningProfiles.form.save": "Save",
  "provisioningProfiles.form.cancel": "Cancel",
  "provisioningProfiles.form.back": "Back",
  "provisioningProfiles.form.submit": "Submit",
  "provisioningProfiles.categories.name": "Name",
  "provisioningProfiles.categories.qtyOfItems": "Qty of Items",
  "provisioningProfiles.categories.status": "Status",
  "provisioningProfiles.categories.selectAll": "Select All",
  "provisioningProfiles.categories.deselectAll": "Deselect All",
  "provisioningProfiles.products.name": "Name",
  "provisioningProfiles.products.price": "Price",
  "provisioningProfiles.products.status": "Status",
  "provisioningProfiles.products.delete": "Delete",
  "provisioningProfiles.products.deleteSelected": "Delete Selected",
  "provisioningProfiles.products.deleteSuccess": "Successfully deleted.",
  "provisioningProfiles.products.noProducts": "No products selected",
  "provisioningProfiles.products.add": "Add",
  "provisioningProfiles.products.remove": "Remove",
  "provisioningProfiles.products.filter": "Filter",
  "provisioningProfiles.products.clear": "Clear",
  "provisioningProfiles.products.apply": "Apply",
  "provisioningProfiles.products.image": "Image",
  "provisioningProfiles.products.productName": "Product Name",
  "provisioningProfiles.products.inventory": "Inventory",
  "provisioningProfiles.products.sku": "SKU",
  "provisioningProfiles.themes.selectTheme": "Select Theme",
  "provisioningProfiles.themes.selectThemes": "Select Themes",
  "provisioningProfiles.themes.currentTheme": "Current Theme",
  "provisioningProfiles.themes.themeList": "Theme List",
  "provisioningProfiles.themes.addTheme": "Add Theme",
  "provisioningProfiles.themes.removeTheme": "Remove Theme",
  "provisioningProfiles.themes.version": "Version",
  "provisioningProfiles.themes.styles": "styles",
  "provisioningProfiles.themes.developedBy": "Developed by",
  "provisioningProfiles.apply.pageTitle": "Apply Profile to Stores",
  "provisioningProfiles.apply.confirmPageTitle": "Confirm Provisioning Profiles Apply",
  "provisioningProfiles.apply.confirmation": "Confirmation",
  "provisioningProfiles.apply.confirmationDescription": "We recommend you sending an email for confirmation before apply the profile to stores.",
  "provisioningProfiles.apply.targetStore": "Target Store*",
  "provisioningProfiles.apply.stores": "Stores",
  "provisioningProfiles.apply.selectStore": "Select store",
  "provisioningProfiles.apply.confirmType1": "Send a confirmation email to the store owner to authorize the profile application.",
  "provisioningProfiles.apply.confirmType2": "Set a mandatory implementation date and send a confirmation email to the store owner to authorize the profile application. If the store owner does not agree with the confirmation, the profile will be applied within specific days.",
  "provisioningProfiles.apply.confirmType3": "Apply the profile directly.",
  "provisioningProfiles.apply.forcingImplementationDate": "Forcing Implementation Date",
  "provisioningProfiles.apply.selectTime": "select time",
  "provisioningProfiles.apply.warning": "Warning",
  "provisioningProfiles.apply.profileName": "Profile Name*",
  "provisioningProfiles.apply.appliedStores": "Applied Stores*",
  "provisioningProfiles.apply.type": "Type",
  "provisioningProfiles.apply.inTextField": "in the text field",
  "provisioningProfiles.apply.apply": "Apply",
  "provisioningProfiles.apply.processingSuccess": "Processing profiles for application. This may take a few minutes.",
  "provisioningProfiles.apply.selectStores": "Select Stores",
  "provisioningProfiles.apply.applyToStores": "Apply to Stores",
  "provisioningProfiles.apply.success": "Profile applied successfully",
  "provisioningProfiles.apply.error": "Failed to apply profile",
  "provisioningProfiles.details.pageTitle": "Profile Details",
  "provisioningProfiles.details.basicInfo": "Basic Information",
  "provisioningProfiles.details.categories": "Categories",
  "provisioningProfiles.details.products": "Products",
  "provisioningProfiles.details.themes": "Themes",
  "provisioningProfiles.details.stores": "Applied Stores",
  "provisioningProfiles.details.orders": "Orders",
  "provisioningProfiles.details.totalSale": "Total Sale",
  "provisioningProfiles.details.updateSuccess": "update success",
  "provisioningProfiles.changeStyle.changeStyle": "Change Style",
  "provisioningProfiles.changeStyle.success": "Success",
  "provisioningProfiles.changeStyle.selectThemeStyle": "Select a theme style to current profile",
  "provisioningProfiles.changeStyle.style": "Style",
  "provisioningProfiles.changeStyle.selectStyleName": "Please select style name",
  "provisioningProfiles.changeStyle.ok": "OK",
  "provisioningProfiles.changeStyle.setAsCurrentTheme": "Set as current theme",
  "provisioningProfiles.changeStyle.selectedStyle": "Selected Style",
  "provisioningProfiles.changeStyle.notice": "Notice",
  "provisioningProfiles.changeStyle.unexpectedWarning": "Unexpected bad things will happen if you don't read this!",
  "provisioningProfiles.changeStyle.applyThemeWarning": "Apply this theme to stores and may affect fonts, colors and other store features.",
  "provisioningProfiles.changeStyle.themeName": "Theme Name",
  "provisioningProfiles.changeStyle.storesToBeApplied": "Stores to be applied",
  "provisioningProfiles.changeStyle.typeConfirmSentence": "Type the below sentence to CONFIRM*",
  "provisioningProfiles.currentTheme.defaultTheme": "Default Theme",
  "provisioningProfiles.currentTheme.version": "Version",
  "provisioningProfiles.currentTheme.styles": "Styles",
  "provisioningProfiles.currentTheme.developedBy": "Developed by",
  "provisioningProfiles.addProducts.addProducts": "Add Products",
  "provisioningProfiles.addProducts.selectProducts": "Select Products",
  "provisioningProfiles.addProducts.cancel": "Cancel",
  "provisioningProfiles.addProducts.save": "Save",
  "provisioningProfiles.addProducts.banner": "Banner",
  "provisioningProfiles.addProducts.productName": "Product Name",
  "provisioningProfiles.addProducts.sku": "Sku",
  "provisioningProfiles.addProducts.productPrice": "Product Price",
  "provisioningProfiles.addProducts.products": "Products",
  "provisioningProfiles.addProducts.successfullyAdded": "Successfully added.",
  "provisioningProfiles.removeTheme.remove": "Remove",
  "provisioningProfiles.removeTheme.cancel": "Cancel",
  "provisioningProfiles.removeTheme.themeWillBeRemoved": "This theme will be removed from the current profile.",
  "provisioningProfiles.removeTheme.themeName": "Theme Name",
  "provisioningProfiles.removeTheme.confirm": "Confirm",
  "provisioningProfiles.removeTheme.confirmRequired": "Please type word 'CONFIRM'",
  "provisioningProfiles.removeTheme.confirmValidator": "Please type word 'CONFIRM'",
  "provisioningProfiles.removeTheme.confirmPlaceholder": "Please type word 'CONFIRM'",
  "provisioningProfiles.removeTheme.removeAppliedTheme": "Remove applied theme",
  "provisioningProfiles.removeTheme.selectedTheme": "Selected Theme",
  "provisioningProfiles.removeTheme.notice": "Notice",
  "provisioningProfiles.removeTheme.unexpectedWarning": "Unexpected bad things will happen if you don't read this!",
  "provisioningProfiles.removeTheme.removeThemeWarning": "Remove this theme applied to stores may affect fonts, colors and other store features.",
  "provisioningProfiles.removeTheme.iveReadTheseEffects": "I've read these effects",
  "provisioningProfiles.removeTheme.themeWillBeRemovedFromAllStores": "This theme will be removed from all stores and may affect fonts, colors and other store features.",
  "provisioningProfiles.removeTheme.storesToBeApplied": "Stores to be applied",
  "provisioningProfiles.removeTheme.typeConfirmSentence": "Type the below sentence to CONFIRM*",
  "provisioningProfiles.removeTheme.confirmTextTemplate": "I understand that APPLY this theme to target stores may affect future release updates.",
  "provisioningProfiles.themeItemList.themes": "Themes",
  "provisioningProfiles.themeItemList.addThemes": "Add Themes",
  "provisioningProfiles.themeItemList.setAsCurrentTheme": "Set as current theme",
  "provisioningProfiles.themeItemList.styles": "styles",
  "provisioningProfiles.themeItemList.utilization": "Utilization"
};

// src/locales/en/reports.ts
var reports_default = {
  reports_page_title: "Reports",
  reports_store_overview_title: "Store Overview",
  reports_plan_revenue_title: "Plan Revenue",
  reports_plan_revenue_text: "Overview of Stores and Revenue",
  reports_latest_plan_changes_title: "Latest Plan Changes",
  reports_latest_plan_changes_text: "History and status of plan changes",
  reports_logs_title: "Logs",
  reports_portal_logs_title: "Portal Logs",
  reports_portal_logs_text: "Show historical user activity",
  reports_store_logs_title: "Store Logs",
  reports_store_logs_text: "Show audit log of store activity",
  reports_orders_title: "Orders",
  reports_orders_revenue_title: "Orders Revenue",
  reports_orders_revenue_text: "Orders data associated with stores",
  reports_promotion_utilization_title: "Promotion Utilization",
  reports_promotion_utilization_text: "Data associated with stores",
  reports_system_logs_title: "System Logs",
  reports_plan_revenue_page_title: "Plan Revenue",
  reports_plan_revenue_order_number: "Order Number",
  reports_plan_revenue_store_hash: "Store Hash",
  reports_plan_revenue_store_id: "Store ID",
  reports_plan_revenue_store_name: "Store Name",
  reports_plan_revenue_net: "Net",
  reports_plan_revenue_gross: "Gross",
  reports_plan_revenue_plan_code: "Plan Code",
  reports_plan_revenue_date: "Date",
  reports_plan_revenue_status: "Status",
  reports_plan_revenue_view_details: "View Details",
  reports_plan_revenue_more: "More",
  reports_plan_revenue_account_info: "Account Info",
  reports_plan_revenue_store_info: "Store Info",
  reports_plan_revenue_total_order_count: "(total order count)",
  reports_plan_revenue_total_order_amount: "(total order amount)",
  reports_plan_revenue_search_placeholder: "search",
  reports_plan_revenue_export: "Export",
  reports_plan_revenue_filter: "Filter",
  reports_plan_revenue_equals: " (equals)",
  reports_plan_revenue_clear: "Clear",
  reports_plan_revenue_apply: "Apply",
  reports_portal_logs_page_title: "Portal logs",
  reports_portal_logs_date: "Date",
  reports_portal_logs_user: "User",
  reports_portal_logs_ip: "IP",
  reports_portal_logs_module: "Module",
  reports_portal_logs_details: "Details",
  reports_portal_logs_search_placeholder: "search",
  reports_portal_logs_export: "Export",
  reports_portal_logs_filter: "Filter",
  reports_portal_logs_user_label: "User",
  reports_portal_logs_module_label: "Module",
  reports_portal_logs_ip_label: "Ip",
  reports_portal_logs_date_label: "Date",
  reports_portal_logs_details_label: "Details",
  reports_portal_logs_contains: " (contains)",
  reports_portal_logs_equals: " (equals)",
  reports_portal_logs_clear: "Clear",
  reports_portal_logs_apply: "Apply",
  reports_portal_logs_ip_validation: "Please enter number and dot in the text field.",
  reports_latest_plan_changes_page_title: "Latest Plan Changes",
  reports_latest_plan_changes_company: "Company",
  reports_latest_plan_changes_store_name: "Store Name",
  reports_latest_plan_changes_account_id: "Account ID",
  reports_latest_plan_changes_current_type: "Current Type",
  reports_latest_plan_changes_previous_type: "Previous Type",
  reports_latest_plan_changes_effective_date: "Effective Date",
  reports_latest_plan_changes_amount: "Amount",
  reports_latest_plan_changes_status: "Status",
  reports_latest_plan_changes_last_modified: "Last Modified",
  reports_latest_plan_changes_created_on: "Created On",
  reports_latest_plan_changes_modified_by: "Modified By",
  reports_latest_plan_changes_status_available: "Available",
  reports_latest_plan_changes_status_using: "Using",
  reports_latest_plan_changes_status_suspended: "Suspended",
  reports_latest_plan_changes_status_cancelled: "Cancelled",
  reports_latest_plan_changes_search_placeholder: "search",
  reports_latest_plan_changes_export: "Export",
  reports_latest_plan_changes_filter: "Filter",
  reports_latest_plan_changes_company_label: "Company",
  reports_latest_plan_changes_store_name_label: "Store Name",
  reports_latest_plan_changes_account_id_label: "Account ID",
  reports_latest_plan_changes_current_type_label: "Current Type",
  reports_latest_plan_changes_amount_label: "Amount",
  reports_latest_plan_changes_status_label: "Status",
  reports_latest_plan_changes_last_modified_label: "Last Modified",
  reports_latest_plan_changes_contains: " (contains)",
  reports_latest_plan_changes_equals: " (equals)",
  reports_latest_plan_changes_clear: "Clear",
  reports_latest_plan_changes_apply: "Apply",
  reports_store_logs_page_title: "Store logs",
  reports_store_logs_store_id: "Store ID",
  reports_store_logs_store_name: "Store Name",
  reports_store_logs_type: "Type",
  reports_store_logs_module: "Module",
  reports_store_logs_severity: "Severity",
  reports_store_logs_summary: "Summary",
  reports_store_logs_created_time: "Created Time",
  reports_store_logs_message: "Message",
  reports_store_logs_search_placeholder: "search",
  reports_store_logs_export: "Export",
  reports_store_logs_filter: "Filter",
  reports_store_logs_type_label: "Type",
  reports_store_logs_severity_label: "Severity",
  reports_store_logs_module_label: "Module",
  reports_store_logs_summary_label: "Summary",
  reports_store_logs_store_name_label: "Store Name",
  reports_store_logs_store_id_label: "Store ID",
  reports_store_logs_created_date_label: "Created Date",
  reports_store_logs_clear: "Clear",
  reports_store_logs_apply: "Apply",
  reports_store_logs_store_id_validation: "Please enter number in the text field.",
  reports_store_logs_show_details: "show details",
  reports_store_logs_message_title: "Message",
  reports_store_logs_ok: "OK",
  reports_promotion_utilization_page_title: "Promotion Utilization",
  reports_promotion_utilization_stores: "Stores",
  reports_promotion_utilization_customers: "Customers",
  reports_promotion_utilization_campaigns: "Campaigns",
  reports_promotion_utilization_period: "Period",
  reports_promotion_utilization_search_placeholder: "Search",
  reports_promotion_utilization_clear: "Clear",
  reports_promotion_utilization_apply: "Apply",
  reports_promotion_utilization_total_revenue: "Total Revenue",
  reports_promotion_utilization_from: "from",
  reports_promotion_utilization_stores_title: "Stores",
  reports_promotion_utilization_store_name: "Store Name",
  reports_promotion_utilization_store_hash: "Store Hash",
  reports_promotion_utilization_promotion_name: "Promotion Name",
  reports_promotion_utilization_coupon: "Coupon",
  reports_promotion_utilization_usage: "Usage",
  reports_promotion_utilization_chart_title: "Promotion Utilization",
  reports_order_revenue_page_title: "Orders Revenue",
  reports_order_revenue_period: "Period",
  reports_order_revenue_search_placeholder: "Search",
  reports_order_revenue_clear: "Clear",
  reports_order_revenue_apply: "Apply",
  reports_order_revenue_store_hash: "Store Hash:",
  reports_order_revenue_account_id: "Account ID:",
  reports_order_revenue_total_revenue: "Total Revenue",
  reports_order_revenue_from: "from",
  reports_order_revenue_orders_title: "Orders",
  reports_order_revenue_order_id: "Order ID",
  reports_order_revenue_date: "Date",
  reports_order_revenue_source: "Source",
  reports_order_revenue_subtotal: "Subtotal",
  reports_order_revenue_line_item_discounts: "Line item discounts",
  reports_order_revenue_shipping: "Shipping",
  reports_order_revenue_tax: "Tax",
  reports_order_revenue_total: "Total",
  reports_order_revenue_chart_title: "Orders Revenue",
  reports_order_revenue_chart_unit: "unit: $",
  reports_order_revenue_gross: "Gross",
  reports_system_logs_page_title: "System Logs",
  reports_all_stores: "All Stores",
  reports_dont_have_permission: "Don't have permission.",
  reports_export: "Export",
  reports_search: "Search",
  reports_refresh: "Refresh",
  reports_back: "Back"
};

// src/locales/en/resetPassword.ts
var resetPassword_default = {
  resetPassword_page_title: "Reset Password",
  resetPassword_form_submit_button: "Reset Password",
  resetPassword_form_have_account: "Already have an account?",
  resetPassword_form_have_login: "Log in",
  resetPassword_password_validation_error: "The password must contain at least one capital letter, one lowercase letter, one number and one special character, and its length should be between 8 and 12 characters",
  resetPassword_reset_success: "Reset password successfully",
  resetPassword_reset_failed: "Reset password failed",
  resetPassword_password_not_match: "Please make sure that the two passwords are the same",
  resetPassword_new_password_label: "New Password",
  resetPassword_new_password_placeholder: "Please enter your new password.",
  resetPassword_confirm_password_label: "Confirm the New Password",
  resetPassword_confirm_password_required: "Confirm Password is a required field.",
  resetPassword_confirm_password_placeholder: "Please confirm your new password.",
  resetPassword_password_at_most: "Password must be at most 12 characters",
  resetPassword_password_at_least: "Password must be at least 8 characters",
  resetPassword_password_requirements: "Password Requirements:",
  resetPassword_password_length: "Length: 8-12 characters",
  resetPassword_password_uppercase: "At least one uppercase letter",
  resetPassword_password_lowercase: "At least one lowercase letter",
  resetPassword_password_number: "At least one number",
  resetPassword_password_special: "At least one special character"
};

// src/locales/en/settings.ts
var settings_default = {
  "settings.pageTitle": "Settings",
  "settings.noPermission": "Don't have permission.",
  "settings.home.userAdministration": "User Administration",
  "settings.home.plan": "Plan",
  "settings.home.scheduleManagement": "Schedule Management",
  "settings.home.storeSetting": "Store Setting",
  "settings.home.smsConfiguration": "SMS Configuration",
  "settings.home.mailConfiguration": "Mail Configuration",
  "settings.portalUser.pageTitle": "Portal User Management",
  "settings.portalUser.addUser": "Add User",
  "settings.portalUser.editUser": "Edit User",
  "settings.portalUser.addNewUser": "Add a new user",
  "settings.portalUser.deleteUser": "Delete User",
  "settings.portalUser.export": "Export",
  "settings.portalUser.filter": "Filter",
  "settings.portalUser.clear": "Clear",
  "settings.portalUser.apply": "Apply",
  "settings.portalUser.action": "Action",
  "settings.portalUser.edit": "Edit",
  "settings.portalUser.delete": "Delete",
  "settings.portalUser.table.email": "Email",
  "settings.portalUser.table.lastLogin": "Last Login",
  "settings.portalUser.table.name": "Name",
  "settings.portalUser.table.group": "Group",
  "settings.portalUser.table.status": "Status",
  "settings.portalUser.filter.email": "Email",
  "settings.portalUser.filter.emailContains": " (contains)",
  "settings.portalUser.filter.phone": "Phone",
  "settings.portalUser.filter.phoneEquals": " (equals)",
  "settings.portalUser.filter.lastLogin": "Last Login",
  "settings.portalUser.filter.lastLoginEquals": " (equals)",
  "settings.portalUser.filter.name": "Name",
  "settings.portalUser.filter.nameContains": " (contains)",
  "settings.portalUser.filter.group": "Group",
  "settings.portalUser.filter.groupContains": " (contains)",
  "settings.portalUser.filter.status": "Status",
  "settings.portalUser.filter.statusEquals": " (equals)",
  "settings.portalUser.filter.valid": "Valid",
  "settings.portalUser.filter.disabled": "Disabled",
  "settings.portalUser.form.email": "Email (Login ID)",
  "settings.portalUser.form.emailPlaceholder": "Please enter the email.",
  "settings.portalUser.form.firstName": "First Name",
  "settings.portalUser.form.firstNamePlaceholder": "Please enter the first name.",
  "settings.portalUser.form.firstNameRequired": "First Name is a required field.",
  "settings.portalUser.form.lastName": "Last Name",
  "settings.portalUser.form.lastNamePlaceholder": "Please enter the last name.",
  "settings.portalUser.form.lastNameRequired": "Last Name is a required field.",
  "settings.portalUser.form.group": "Group",
  "settings.portalUser.form.groupPlaceholder": "Please select the group.",
  "settings.portalUser.form.selectShopifyAccounts": "Select Shopify accounts",
  "settings.portalUser.form.selectShopifyAccountsPlaceholder": "Please select the shopify accounts",
  "settings.portalUser.form.selectBigcommerceAccounts": "Select BigCommerce accounts",
  "settings.portalUser.form.selectBigcommerceAccountsPlaceholder": "Please select the BigCommerce accounts",
  "settings.portalUser.delete.title": "Disabling a User will cause all associated message to be deleted and is irreversible.",
  "settings.portalUser.delete.userEmail": "User Email",
  "settings.portalUser.delete.userEmailPlaceholder": "Please type Email",
  "settings.portalUser.delete.confirm": "Confirm",
  "settings.portalUser.delete.confirmPlaceholder": "Please type word 'CONFIRM'",
  "settings.portalUser.delete.confirmRequired": "Please type word 'CONFIRM'",
  "settings.portalUser.delete.confirmValidator": "Please type word 'CONFIRM'",
  "settings.portalUser.delete.enterCorrectEmail": "Please enter the correct Email",
  "settings.portalUser.delete.cancel": "Cancel",
  "settings.portalUser.delete.delete": "Delete",
  "settings.portalUser.delete.success": "Delete user successfully",
  "settings.portalUser.messages.createSuccess": "Create user successfully",
  "settings.portalUser.messages.editSuccess": "Edit user successfully",
  "settings.portalUser.messages.userAlreadyExists": "User already exists.",
  "settings.portalUser.messages.userGroupDisable": "Disable user group.",
  "settings.portalUser.messages.failedToChangeUserStatus": "Failed to change the user status. Please try again later.",
  "settings.portalUser.messages.invalidGroups": "Invalid groups.",
  "settings.portalUser.messages.userNotFound": "User for {id} not found.",
  "settings.portalUser.messages.failedToRemoveUser": "Failed to remove user {id}.",
  "settings.plan.pageTitle": "Plan Management",
  "settings.plan.addPlan": "Add Plan",
  "settings.plan.editPlan": "Edit Plan",
  "settings.plan.deletePlan": "Delete Plan",
  "settings.plan.export": "Export",
  "settings.plan.filter": "Filter",
  "settings.plan.clear": "Clear",
  "settings.plan.apply": "Apply",
  "settings.plan.table.name": "Plan",
  "settings.plan.table.code": "Code",
  "settings.plan.table.sku": "Sku",
  "settings.plan.table.description": "Description",
  "settings.plan.table.price": "Price",
  "settings.plan.table.franchisePrice": "Franchise Price",
  "settings.plan.table.status": "Status",
  "settings.plan.action": "Action",
  "settings.plan.form.name": "Plan Name",
  "settings.plan.form.namePlaceholder": "Please enter the plan name.",
  "settings.plan.form.price": "Price",
  "settings.plan.form.pricePlaceholder": "Please enter the price.",
  "settings.plan.form.duration": "Duration",
  "settings.plan.form.durationPlaceholder": "Please select the duration.",
  "settings.plan.form.description": "Description",
  "settings.plan.form.descriptionPlaceholder": "Please enter the description.",
  "settings.group.pageTitle": "Group Management",
  "settings.group.add": "Add",
  "settings.group.addTitle": "Add a new group",
  "settings.group.save": "Save",
  "settings.group.addGroup": "Add Group",
  "settings.group.editGroup": "Edit Group",
  "settings.group.deleteGroup": "Delete Group",
  "settings.group.export": "Export",
  "settings.group.filter": "Filter",
  "settings.group.clear": "Clear",
  "settings.group.apply": "Apply",
  "settings.group.messages.addSuccess": "Add Group successfully",
  "settings.group.messages.deleteSuccess": "Delete Group successfully",
  "settings.group.messages.editSuccess": "Edit Group successfully",
  "settings.group.action": "Action",
  "settings.group.editTitle": "Edit group",
  "settings.group.deleteModal.header": "Disabling a Group will cause all associated settings to be deleted and is irreversible.",
  "settings.group.deleteModal.cancel": "Cancel",
  "settings.group.deleteModal.delete": "Delete",
  "settings.group.deleteModal.groupName": "Group Name",
  "settings.group.deleteModal.groupNameRequired": "Group Name is required",
  "settings.group.deleteModal.groupNamePlaceholder": "Please type the Group Name",
  "settings.group.deleteModal.confirm": "Confirm",
  "settings.group.deleteModal.confirmRequired": "Please type word 'CONFIRM'",
  "settings.group.deleteModal.confirmPlaceholder": "Please type word 'CONFIRM'",
  "settings.group.table.name": "Name",
  "settings.group.table.description": "Description",
  "settings.group.table.memberCount": "Member Count",
  "settings.group.table.status": "Status",
  "settings.group.table.action": "Action",
  "settings.group.table.activeAccount": "Active Account",
  "settings.group.edit": "Edit",
  "settings.group.delete": "Delete",
  "settings.group.messages.adminGroup": "Administrator group cannot be edited/added .",
  "settings.group.form.name": "Group Name",
  "settings.group.form.namePlaceholder": "Please enter the group name.",
  "settings.group.form.description": "Description",
  "settings.group.form.descriptionPlaceholder": "Please enter the description.",
  "settings.group.form.permissions": "Permissions",
  "settings.group.form.permissionsPlaceholder": "Please select the permissions.",
  "settings.group.form.users": "Users",
  "settings.mailTemplate.pageTitle": "Mail Template Management",
  "settings.mailTemplate.addTemplate": "Add Template",
  "settings.mailTemplate.editTemplate": "Edit Template",
  "settings.mailTemplate.deleteTemplate": "Delete Template",
  "settings.mailTemplate.export": "Export",
  "settings.mailTemplate.filter": "Filter",
  "settings.mailTemplate.clear": "Clear",
  "settings.mailTemplate.apply": "Apply",
  "settings.mailTemplate.messages.updateSuccess": "Successfully updated.",
  "settings.mailTemplate.table.name": "Name",
  "settings.mailTemplate.table.subject": "Subject",
  "settings.mailTemplate.table.type": "Type",
  "settings.mailTemplate.table.status": "Status",
  "settings.mailTemplate.table.action": "Action",
  "settings.mailTemplate.form.module": "Module",
  "settings.mailTemplate.form.topic": "Topic",
  "settings.mailTemplate.form.text": "Text",
  "settings.mailTemplate.form.name": "Template Name",
  "settings.mailTemplate.form.namePlaceholder": "Please enter the template name.",
  "settings.mailTemplate.form.subject": "Subject",
  "settings.mailTemplate.form.subjectPlaceholder": "Please enter the subject.",
  "settings.mailTemplate.form.content": "Content",
  "settings.mailTemplate.form.contentPlaceholder": "Please enter the content.",
  "settings.mailTemplate.form.type": "Type",
  "settings.mailTemplate.form.typePlaceholder": "Please select the type.",
  "settings.smtp.pageTitle": "SMTP Settings",
  "settings.smtp.save": "Save",
  "settings.smtp.test": "Test Connection",
  "settings.smtp.reset": "Reset",
  "settings.smtp.messages.noPermission": "Don't have permission.",
  "settings.smtp.form.useSSL": "Use SSL",
  "settings.smtp.form.senderName": "Sender Name",
  "settings.smtp.form.optional": "(optional)",
  "settings.smtp.form.host": "SMTP Host",
  "settings.smtp.form.hostPlaceholder": "Please enter the SMTP host.",
  "settings.smtp.form.port": "SMTP Port",
  "settings.smtp.form.portPlaceholder": "Please enter the SMTP port.",
  "settings.smtp.form.username": "Username",
  "settings.smtp.form.usernamePlaceholder": "Please enter the username.",
  "settings.smtp.form.password": "Password",
  "settings.smtp.form.passwordPlaceholder": "Please enter the password.",
  "settings.smtp.form.encryption": "Encryption",
  "settings.smtp.form.encryptionPlaceholder": "Please select the encryption type.",
  "settings.smsGateway.pageTitle": "SMS Gateway Configuration",
  "settings.smsGateway.save": "Save",
  "settings.smsGateway.test": "Test Connection",
  "settings.smsGateway.reset": "Reset",
  "settings.smsGateway.form.provider": "SMS Provider",
  "settings.smsGateway.form.providerPlaceholder": "Please select the SMS provider.",
  "settings.smsGateway.form.apiKey": "API Key",
  "settings.smsGateway.form.apiKeyPlaceholder": "Please enter the API key.",
  "settings.smsGateway.form.apiSecret": "API Secret",
  "settings.smsGateway.form.apiSecretPlaceholder": "Please enter the API secret.",
  "settings.smsGateway.form.fromNumber": "From Number",
  "settings.smsGateway.form.fromNumberPlaceholder": "Please enter the from number.",
  "settings.smsTemplate.pageTitle": "SMS Template Management",
  "settings.smsTemplate.addTemplate": "Add Template",
  "settings.smsTemplate.editTemplate": "Edit Template",
  "settings.smsTemplate.deleteTemplate": "Delete Template",
  "settings.smsTemplate.export": "Export",
  "settings.smsTemplate.filter": "Filter",
  "settings.smsTemplate.clear": "Clear",
  "settings.smsTemplate.apply": "Apply",
  "settings.smsTemplate.table.name": "Name",
  "settings.smsTemplate.table.content": "Content",
  "settings.smsTemplate.table.type": "Type",
  "settings.smsTemplate.table.status": "Status",
  "settings.smsTemplate.table.action": "Action",
  "settings.smsTemplate.form.name": "Template Name",
  "settings.smsTemplate.form.namePlaceholder": "Please enter the template name.",
  "settings.smsTemplate.form.content": "Content",
  "settings.smsTemplate.form.contentPlaceholder": "Please enter the content.",
  "settings.smsTemplate.form.type": "Type",
  "settings.smsTemplate.form.typePlaceholder": "Please select the type.",
  "settings.masterStore.pageTitle": "Manage Master Store",
  "settings.masterStore.messages.noPermission": "Don't have permission to set master store.",
  "settings.masterStore.messages.updateSuccess": "Successfully updated.",
  "settings.masterStore.modal.warning": "Set master store may affect catalog, promotions, themes and other features of all target stores.",
  "settings.masterStore.modal.notice": "Notice",
  "settings.masterStore.modal.noticeText": "Unexpected bad things will happen if you don't read this!",
  "settings.masterStore.modal.step1Button": "I'm sure to set the master store",
  "settings.masterStore.modal.step2Button": "I've read these effects",
  "settings.masterStore.modal.confirmTitle": "Type the below sentence to CONFIRM *",
  "settings.masterStore.modal.confirmText": "I understand that SET THE MASTER STORE may affect future release updates.",
  "settings.masterStore.modal.cancel": "Cancel",
  "settings.masterStore.modal.set": "Set",
  "settings.masterStore.selectTitle": "Select an existing store",
  "settings.masterStore.selectDescription": "Please select an existing store.",
  "settings.masterStore.clear": "Clear",
  "settings.masterStore.setButton": "Set Master Store",
  "settings.masterStore.form.storeName": "Store Name",
  "settings.masterStore.form.placeholder": "Please select a master store",
  "settings.masterStore.form.label": "Select a master",
  "settings.masterStore.table.name": "Store Name",
  "settings.masterStore.table.platform": "Platform",
  "settings.masterStore.table.url": "URL",
  "settings.masterStore.table.status": "Status",
  "settings.masterStore.table.action": "Action",
  "settings.masterStore.form.name": "Store Name",
  "settings.masterStore.form.namePlaceholder": "Please enter the store name.",
  "settings.masterStore.form.platform": "Platform",
  "settings.masterStore.form.platformPlaceholder": "Please select the platform.",
  "settings.masterStore.form.url": "Store URL",
  "settings.masterStore.form.urlPlaceholder": "Please enter the store URL.",
  "settings.masterStore.form.apiKey": "API Key",
  "settings.masterStore.form.apiKeyPlaceholder": "Please enter the API key.",
  "settings.apiToken.pageTitle": "API Franchise Token",
  "settings.apiToken.messages.noPermission": "Don't have permission.",
  "settings.apiToken.messages.updateSuccess": "Update success",
  "settings.apiToken.form.franchiseId": "Franchise ID",
  "settings.apiToken.form.franchiseIdRequired": "Franchise ID is required.",
  "settings.apiToken.form.clientId": "Client ID",
  "settings.apiToken.form.clientIdRequired": "Client ID is required.",
  "settings.apiToken.form.clientSecret": "Client Secret",
  "settings.apiToken.form.clientSecretRequired": "Client Secret is required.",
  "settings.apiToken.form.country": "Country",
  "settings.apiToken.form.countryRequired": "Country is required.",
  "settings.apiToken.form.countryUS": "US",
  "settings.apiToken.form.region": "Region",
  "settings.apiToken.form.regionRequired": "Region is required.",
  "settings.apiToken.form.regionUS": "US",
  "settings.apiToken.form.regionEU": "EU",
  "settings.apiToken.form.regionAU": "AU",
  "settings.apiToken.table.token": "Token",
  "settings.apiToken.table.name": "Name",
  "settings.apiToken.table.createdAt": "Created At",
  "settings.apiToken.table.expiresAt": "Expires At",
  "settings.apiToken.table.status": "Status",
  "settings.apiToken.table.action": "Action",
  "settings.apiToken.form.name": "Token Name",
  "settings.apiToken.form.namePlaceholder": "Please enter the token name.",
  "settings.apiToken.form.expiresAt": "Expires At",
  "settings.apiToken.form.expiresAtPlaceholder": "Please select the expiration date.",
  "settings.apiToken.form.permissions": "Permissions",
  "settings.apiToken.form.permissionsPlaceholder": "Please select the permissions.",
  "settings.automation.pageTitle": "Automation Notification Management",
  "settings.automation.addNotification": "Add Notification",
  "settings.automation.editNotification": "Edit Notification",
  "settings.automation.deleteNotification": "Delete Notification",
  "settings.automation.export": "Export",
  "settings.automation.filter": "Filter",
  "settings.automation.clear": "Clear",
  "settings.automation.apply": "Apply",
  "settings.automation.table.name": "Name",
  "settings.automation.table.type": "Type",
  "settings.automation.table.trigger": "Trigger",
  "settings.automation.table.status": "Status",
  "settings.automation.table.action": "Action",
  "settings.automation.form.name": "Notification Name",
  "settings.automation.form.namePlaceholder": "Please enter the notification name.",
  "settings.automation.form.type": "Type",
  "settings.automation.form.typePlaceholder": "Please select the type.",
  "settings.automation.form.trigger": "Trigger",
  "settings.automation.form.triggerPlaceholder": "Please select the trigger.",
  "settings.automation.form.status": "Status",
  "settings.automation.form.statusPlaceholder": "Please select the status.",
  "settings.automation.emailTitle": "Send customers Email when:",
  "settings.automation.smsTitle": "Send customers SMS when:",
  "settings.automation.createUsers": "Create Users",
  "settings.automation.resetPassword": "Reset Password",
  "settings.automation.createStores": "Create Stores",
  "settings.automation.changePlans": "Change Plans",
  "settings.automation.supportRequest": "Support Request",
  "settings.automation.ticketUpdates": "Ticket Updates",
  "settings.automation.createUsersEmailText": "An email will be sent to the new user with a link that they click to active account.",
  "settings.automation.resetPasswordEmailText": "An email will be sent to the user with a link to reset password.",
  "settings.automation.createStoresEmailText": "An email will be sent to the Primary Contact with confirmation.",
  "settings.automation.createStoresEmailText2": "BigCommerce will also send an email.",
  "settings.automation.changePlansEmailText": "An email will be sent to the customer when plan updates.",
  "settings.automation.supportRequestEmailText": "An email will be sent to the customer with a submitted request.",
  "settings.automation.ticketUpdatesEmailText": "An email will be sent to the customer when ticket updates.",
  "settings.automation.createUsersSMSText": "An SMS will be sent to the new user with a link that they click to active account.",
  "settings.automation.resetPasswordSMSText": "An SMS will be sent to the user with a link to reset password.",
  "settings.automation.createStoresSMSText": "An SMS will be sent to the Primary Contact with confirmation.",
  "settings.automation.createStoresSMSText2": "BigCommerce will also send an SMS.",
  "settings.automation.changePlansSMSText": "An SMS will be sent to the customer when plan updates.",
  "settings.automation.supportRequestSMSText": "An SMS will be sent to the customer with a submitted request.",
  "settings.automation.ticketUpdatesSMSText": "An SMS will be sent to the customer when ticket updates.",
  "settings.automation.save": "Save",
  "settings.automation.messages.updateSuccess": "Update success",
  "settings.automation.messages.noPermission": "Don't have permission.",
  "settings.status.active": "Active",
  "settings.status.inactive": "Inactive",
  "settings.status.enabled": "Enabled",
  "settings.status.disabled": "Disabled",
  "settings.status.valid": "Valid",
  "settings.status.expired": "Expired",
  "settings.action.view": "View",
  "settings.action.edit": "Edit",
  "settings.action.delete": "Delete",
  "settings.action.save": "Save",
  "settings.action.cancel": "Cancel",
  "settings.action.confirm": "Confirm",
  "settings.action.back": "Back",
  "settings.messages.createSuccess": "Successfully created.",
  "settings.messages.updateSuccess": "Successfully updated.",
  "settings.messages.deleteSuccess": "Successfully deleted.",
  "settings.messages.createFailed": "Create failed: {error}",
  "settings.messages.updateFailed": "Update failed: {error}",
  "settings.messages.deleteFailed": "Delete failed: {error}",
  "settings.messages.noPermission": "Don't have permission.",
  "settings.form.required": "This field is required.",
  "settings.form.invalidEmail": "Please enter a valid email address.",
  "settings.form.invalidPhone": "Please enter a valid phone number.",
  "settings.form.invalidUrl": "Please enter a valid URL.",
  "settings.form.invalidNumber": "Please enter a valid number.",
  "settings.form.minLength": "Minimum {min} characters required.",
  "settings.form.maxLength": "Maximum {max} characters allowed.",
  "settings.form.confirmPassword": "Passwords do not match.",
  "settings.form.uniqueName": "This name already exists.",
  "settings.form.uniqueEmail": "This email already exists.",
  "settings.home.portalUserManagement": "Portal User Management",
  "settings.home.groupManagement": "Group Management",
  "settings.home.planManagement": "Plan Management",
  "settings.home.automationNotification": "Automation Notification",
  "settings.home.apiFranchiseToken": "API Franchise Token",
  "settings.home.manageMasterStore": "Manage Master Store",
  "settings.home.catalogSetting": "Catalog Setting",
  "settings.home.smsGatewayConfig": "SMS Gateway Config",
  "settings.home.smsTemplate": "SMS Template",
  "settings.home.smtpSetting": "SMTP Setting",
  "settings.home.mailTemplate": "Mail Template",
  "settings.catalogSetting.pageTitle": "Catalog Setting",
  "settings.catalogSetting.save": "Save",
  "settings.catalogSetting.messages.updateSuccess": "Successfully updated.",
  "settings.catalogSetting.automaticallyPullProducts": "Automatically Pull Products from Master Store",
  "settings.catalogSetting.automaticallyPullProductsDescription": 'Turn "On" if you want to automatically pull products from Master Store once new products are created. If this feature is turned off, no products will be automatically pulled from Master Store into the Distributor CommerceHub.',
  "settings.messages.confirmDelete": "Are you sure you want to delete this item?",
  "settings.messages.confirmDeleteDescription": "This action cannot be undone."
};

// src/locales/en/stores.ts
var stores_default = {
  stores_list_page_title: "Store Management",
  stores_list_column_store_id: "Store ID",
  stores_list_column_store_hash: "Store Hash",
  stores_list_column_store_name: "Store Name",
  stores_list_column_plan: "Plan",
  stores_list_column_expire_time: "Exp. Date",
  stores_list_column_status: "Status",
  stores_list_column_company: "Company",
  stores_list_column_account: "Account",
  stores_list_column_provisioning_profile: "Provisioning Profile",
  stores_list_column_live_store: "Live Store",
  stores_list_column_action: "Action",
  stores_destroy_modal_title: "Deleting a connected store will permanently delete all associated orders in Distributed Commerce Hub.",
  stores_destroy_form_store_id_label: "Store ID",
  stores_destroy_form_store_id_placeholder: "Please type Store ID",
  stores_destroy_form_store_id_required: "id is required",
  stores_destroy_form_confirm_label: "Confirm",
  stores_destroy_form_confirm_placeholder: "Please type word 'CONFIRM'",
  stores_destroy_form_confirm_required: "Please type word 'CONFIRM'",
  stores_destroy_success: "Destroy store successfully",
  stores_new_order_drawer_title: "Change Plan",
  stores_new_order_form_store_id_label: "Store ID",
  stores_new_order_form_store_id_required: "id is required",
  stores_new_order_form_store_name_label: "Store Name",
  stores_new_order_form_store_name_required: "store name is required",
  stores_new_order_form_cur_plan_label: "Select Plan",
  stores_new_order_form_cur_plan_required: "plan is required",
  stores_new_order_form_effective_label: "Effective",
  stores_new_order_form_effective_required: "effective date is required",
  stores_new_order_form_effective_option_immediately: "Immediately",
  stores_new_order_form_effective_option_next_billing: "Next Billing Cycle",
  stores_new_order_success: "Update success",
  stores_new_store_open_button: "Create a store",
  stores_new_store_type_drawer_title: "Select Store Type",
  stores_new_store_type_new_button: "Create New Store",
  stores_new_store_type_existing_button: "Connect Existing Store",
  stores_new_store_add_drawer_title: "Add a new Store",
  stores_new_store_add_submit_button: "Save",
  stores_new_store_connect_drawer_title: "Connect Existing Store",
  stores_new_store_connect_submit_button: "Connect",
  stores_new_store_field_account_label: "Account",
  stores_new_store_field_account_required: "account is required",
  stores_new_store_field_name_label: "Store Name",
  stores_new_store_field_name_required: "store name is required",
  stores_new_store_field_plan_label: "Plan",
  stores_new_store_field_plan_required: "plan is required",
  stores_new_store_field_company_label: "Company",
  stores_new_store_field_desc_label: "Description",
  stores_new_store_field_profile_label: "Provisioning Profile",
  stores_new_store_field_store_hash_label: "Store Hash",
  stores_new_store_field_store_hash_required: "store hash is required",
  stores_new_store_field_client_id_label: "Client ID",
  stores_new_store_field_client_id_required: "client id is required",
  stores_new_store_field_client_secret_label: "Client Secret",
  stores_new_store_field_client_secret_required: "client secret is required",
  stores_new_store_field_access_token_label: "Access Token",
  stores_new_store_field_access_token_required: "access token is required",
  stores_new_store_add_success: "Add store successfully",
  stores_new_store_connect_success: "Connect store successfully",
  stores_shopify_create_button: "Connect Existing Store",
  stores_shopify_create_modal_header_method: "Connect Shopify Store",
  stores_shopify_create_modal_header_manual: "Connect Existing Store",
  stores_shopify_create_modal_header_auth: "Shopify Store Authorization",
  stores_shopify_create_method_tip: "Choose how you would like to connect your Shopify store to CommercialHub.",
  stores_shopify_create_manual_title: "Manual Connection",
  stores_shopify_create_manual_desc: "Enter your store credentials manually",
  stores_shopify_create_auth_title: "One-click Authorization",
  stores_shopify_create_auth_desc: "Authorize through Shopify App",
  stores_shopify_create_form_submit: "Connect",
  stores_shopify_create_form_back: "Back",
  stores_shopify_create_field_store_url_label: "Store URL",
  stores_shopify_create_field_store_url_required: "store url is required",
  stores_shopify_create_field_client_id_label: "API Key",
  stores_shopify_create_field_client_id_required: "API Key is required",
  stores_shopify_create_field_client_secret_label: "API Secret Key",
  stores_shopify_create_field_client_secret_required: "API Secret Key is required",
  stores_shopify_create_field_access_token_label: "Admin API Access Token",
  stores_shopify_create_field_access_token_required: "Admin API Access Token is required",
  stores_shopify_create_auth_tip: "To connect your Shopify store, you need to authorize CommercialHub to access your store data.",
  stores_shopify_create_auth_submit: "Go to authorize",
  stores_shopify_create_success: "Connect store successfully",
  stores_action_search_placeholder: "search",
  stores_action_export_button: "Export",
  stores_action_filter_button: "Filter",
  stores_action_store_id_label: "Store ID",
  stores_action_store_id_sublabel: "(equals)",
  stores_action_plan_label: "Plan",
  stores_action_plan_sublabel: "(equals)",
  stores_action_store_hash_label: "Store Hash",
  stores_action_store_hash_sublabel: "(equals)",
  stores_action_account_name_label: "Account",
  stores_action_account_name_sublabel: "(contains)",
  stores_action_status_label: "Status",
  stores_action_status_sublabel: "(equals)",
  stores_action_exp_date_label: "Exp. Date",
  stores_action_exp_date_sublabel: "(equals)",
  stores_management_action_change_plan: "Change Plan",
  stores_management_action_suspend: "Suspend",
  stores_management_action_cancel: "Cancel",
  stores_suspend_modal_title: "Suspending a Store will cause all associated orders to be suspended.",
  stores_suspend_modal_action_confirm: "Suspend",
  stores_suspend_form_label_store_id: "Store ID",
  stores_suspend_form_placeholder_store_id: "Please type Store ID",
  stores_suspend_form_label_confirm: "Confirm",
  stores_suspend_form_placeholder_confirm: "Please type word 'CONFIRM'",
  stores_suspend_form_validation_store_id_required: "Store ID is required",
  stores_suspend_form_validation_confirm_required: "Please type word 'CONFIRM'",
  stores_suspend_form_validation_confirm_match: "Please type word 'CONFIRM'",
  stores_suspend_success: "Suspend store successfully",
  stores_info_page_title: "View Store Information",
  stores_info_store_id: "Store ID",
  stores_info_store_hash: "Store Hash",
  stores_info_billing_cycle: "Billing Cycle",
  stores_info_expire_date: "Exp. Date",
  stores_info_status: "Status",
  stores_info_account_info_title: "Account Information",
  stores_info_account_name: "Account Name",
  stores_info_email: "Email",
  stores_info_company: "Company",
  stores_info_phone: "Phone",
  stores_info_address: "Address",
  stores_info_country: "Country",
  stores_info_city: "City"
};

// src/locales/en/theme.ts
var theme_default = {
  theme_list_page_title: "Themes",
  theme_list_set_default: "Set as Default",
  theme_list_upload: "Upload Themes",
  theme_list_apply_store: "Apply a theme to store",
  theme_list_default_title: "Default Theme",
  theme_list_default_name: "Theme Name",
  theme_list_default_style: "Style",
  theme_list_loading_failure: "Loading failure",
  theme_list_set_default_success: "Successfully set default theme.",
  theme_list_set_default_no_permission: "Don't have permission to change the default theme.",
  theme_list_set_default_title_shopify: "Select a theme style as default for new stores",
  theme_list_set_default_title_other: "Are you sure?",
  theme_list_set_default_style_placeholder: "Please select style name",
  theme_list_set_default_description: "This theme will be applied for the new stores.",
  theme_list_filter_search_placeholder: "search",
  theme_list_filter_expand: "Expand",
  theme_list_filter_clear: "Clear",
  theme_list_filter_apply: "Apply",
  theme_list_filter_equals: " (equals)",
  theme_list_filter_contains: " (contains)",
  theme_list_filter_theme_name: "Theme Name",
  theme_list_filter_upload_date: "Upload Date",
  theme_list_filter_utilization: "Utilization",
  theme_list_table_loading_failure: "Loading failure",
  theme_list_table_utilization: "Utilization",
  theme_list_table_styles: "styles",
  theme_list_table_style: "style",
  theme_list_table_download: "Download Theme",
  theme_list_table_remove: "Remove Theme",
  theme_remove_success: "Theme removed successfully",
  theme_remove_failed: "Failed to remove theme",
  theme_remove_confirm_title: "Remove Theme",
  theme_remove_confirm_message: "Are you sure you want to remove this theme? This action cannot be undone.",
  theme_download_success: "Theme downloaded successfully",
  theme_download_failed: "Failed to download theme",
  theme_upload_file_size_error: "File size should be less than 10MB.",
  theme_upload_no_permission: "Don't have permission to upload the theme.",
  theme_upload_success: "Upload successfully. Please check your email and it will return to the previous page in three seconds.",
  theme_upload_zip_required: "Please upload theme zip file.",
  theme_upload_picture_label: "Theme Picture",
  theme_upload_page_title: "Upload Theme",
  theme_upload_zip_title: "Upload ZIP",
  theme_upload_notice_header: "Notice",
  theme_upload_notice_text: "We do not provide any technical assistance for your custom theme, nor help with any custom features you have added.",
  theme_upload_description: "You can upload your custom theme as a zip file below.",
  theme_upload_cancel_text: "Cancel",
  theme_upload_save_text: "Save",
  theme_apply_no_permission: "Don't have permission to apply theme.",
  theme_apply_success: "Successfully apply. It will return to the previous page in three seconds.",
  theme_apply_page_title: "Confirm Theme Apply",
  theme_apply_select_stores_title: "Select stores",
  theme_apply_select_stores_desc: "We recommend you sending an email for confirmation before apply the theme to stores.",
  theme_apply_store_placeholder: "Select store",
  theme_apply_store_label: "Select store",
  theme_apply_select_style: "Select a style",
  theme_apply_loading_failure: "Loading failure",
  theme_apply_now_title: "Apply Now?",
  theme_apply_email_confirm: "Send a confirmation email to the store owner to authorize theme application.",
  theme_apply_mandatory_date: "Set a mandatory implementation date and send a confirmation email to the store owner to authorize the theme application. If the store owner does not agree with the confirmation, the theme will be applied within specific days.",
  theme_apply_force_date: "Forcing Implementation Date",
  theme_apply_direct: "Apply the theme directly.",
  theme_apply_cancel: "Cancel",
  theme_apply_save: "Save",
  theme_apply_modal_title_1: "Apply this theme to stores and may affect fonts, colors and storefront. We'll send a confirmation email to the store owner.",
  theme_apply_modal_title_2: "Apply this theme to stores and may affect fonts, colors and storefront. We'll send a confirmation email to the store owner. If the store owner do not agree with the confirmation, the theme will be applied within specific days.",
  theme_apply_modal_title_3: "Apply this theme to stores and may affect fonts, colors and storefront.",
  theme_apply_modal_cancel: "Cancel",
  theme_apply_modal_ok: "OK",
  theme_apply_modal_theme_name: "Theme Name",
  theme_apply_modal_selected_stores: "Selected Stores",
  theme_apply_modal_type: "Type",
  theme_apply_modal_confirm_text: "*CONFIRM* in the text field"
};

// src/locales/en/translation.ts
var translation_default = {
  ...common_default,
  ...orders_default,
  ...packages_default,
  ...resetPassword_default,
  ...settings_default,
  ...theme_default,
  ...promotion_default,
  ...layout_default,
  ...login_default,
  ...forgotPassword_default,
  ...product_default,
  ...stores_default,
  ...account_default,
  ...dashboard_default,
  ...content_default,
  ...customerProfile_default,
  ...reports_default,
  ...onboarding_default,
  ...provisioningProfiles_default
};

// src/locales/es/account.ts
var account_default2 = {
  account_management_page_title: "Cuentas",
  account_management_account_action: "Acci\xF3n",
  account_management_account_id: "ID de Cuenta",
  account_management_first_name: "Nombre",
  account_management_last_name: "Apellido",
  account_management_email: "Correo Electr\xF3nico",
  account_management_phone: "Tel\xE9fono",
  account_management_company: "Empresa",
  account_management_revenue: "Ingresos",
  account_management_status: "Estado",
  account_management_store_list_button: "Lista de Tiendas",
  account_actionbar_import_step1: "Paso 1 - Descargar plantilla de importaci\xF3n de cuentas",
  account_actionbar_import_download_link: "descargar la plantilla",
  account_actionbar_import_step2: "Paso 2 - Importar cuentas en formato CSV",
  account_action_bar_add: "Agregar",
  account_action_bar_search_placeholder: "buscar",
  account_action_bar_import: "Importar",
  account_action_bar_export: "Exportar",
  account_action_bar_filter: "Filtrar",
  account_action_bar_account_id: "ID de Cuenta",
  account_action_bar_account_id_sub: " (igual a)",
  account_action_bar_first_name: "Nombre",
  account_action_bar_first_name_sub: " (contiene)",
  account_action_bar_last_name: "Apellido",
  account_action_bar_last_name_sub: " (contiene)",
  account_action_bar_email: "Correo Electr\xF3nico",
  account_action_bar_email_sub: " (contiene)",
  account_action_bar_phone: "Tel\xE9fono",
  account_action_bar_phone_sub: " (igual a)",
  account_action_bar_company: "Empresa",
  account_action_bar_company_sub: " (contiene)",
  account_action_bar_revenue: "Ingresos",
  account_action_bar_revenue_sub: " (igual a)",
  account_info_page_title: "Informaci\xF3n de la Cuenta",
  account_info_primary_contact: "Contacto Principal",
  account_info_billing_contact: "Contacto de Facturaci\xF3n",
  account_info_account_name: "Nombre de la Cuenta",
  account_info_status: "Estado",
  account_info_email: "Correo Electr\xF3nico",
  account_info_company: "Empresa",
  account_info_phone: "Tel\xE9fono",
  account_info_address1: "Direcci\xF3n 1",
  account_info_address2: "Direcci\xF3n 2",
  account_info_country: "Pa\xEDs",
  account_info_city: "Ciudad",
  account_info_revenue: "Ingresos",
  account_info_country_us: "EE.UU.",
  account_info_theme_list_title: "Lista de Temas",
  account_info_theme_list_image_alt: "Error de carga",
  account_infomation_title: "Informaci\xF3n de la Tienda",
  account_infomation_column_store_id: "ID de Tienda",
  account_infomation_column_store_hash: "Hash de Tienda",
  account_infomation_column_store_name: "Nombre de Tienda",
  account_infomation_column_plan: "Plan",
  account_infomation_column_expire_date: "Fecha de Expiraci\xF3n",
  account_infomation_column_status: "Estado",
  account_logo_title_modal_header: "Aviso:",
  account_logo_title_modal_text: "Despu\xE9s de iniciar sesi\xF3n, por favor actualice la p\xE1gina y recon\xE9ctese para continuar.",
  account_logo_title_modal_login_btn: "ir a Iniciar Sesi\xF3n",
  account_logo_title_form_title: "Logo y T\xEDtulo",
  account_logo_title_form_account_title: "T\xEDtulo de la Cuenta",
  account_logo_title_form_account_logo: "Logo de la Cuenta",
  account_logo_title_error_upload_image: "Por favor cargue un archivo de imagen",
  account_management_action_view_detail: "Ver Detalle",
  account_management_action_new_store: "Nueva Tienda",
  account_management_action_edit: "Editar",
  account_management_action_edit_status: "Editar Estado",
  account_management_action_delete: "Eliminar",
  account_management_action_cancel_store: "Cancelar Tienda",
  account_management_action_delete_connect: "Eliminar Conexi\xF3n",
  account_add_page_title: "Agregar Nueva Cuenta",
  account_add_save: "Guardar",
  account_add_add_success: "Cuenta agregada con \xE9xito",
  account_add_primary_contact: "Contacto Principal",
  account_add_first_name: "Nombre",
  account_add_last_name: "Apellido",
  account_add_email: "Correo Electr\xF3nico",
  account_add_company: "Empresa",
  account_add_address_line1: "Direcci\xF3n (l\xEDnea 1)",
  account_add_phone_number: "N\xFAmero de Tel\xE9fono",
  account_add_address_line2: "Direcci\xF3n (l\xEDnea 2)",
  account_add_revenue: "Ingresos",
  account_add_country: "Pa\xEDs",
  account_add_state: "Estado",
  account_add_city: "Ciudad",
  account_add_zip: "C\xF3digo Postal",
  account_add_same_as_primary: "Rellenar con la misma informaci\xF3n que el Contacto Principal.",
  account_add_create_store: "Crear Tienda",
  account_add_store_title: "Crear una nueva tienda",
  account_add_store_name: "Nombre de Tienda",
  account_add_plan: "Plan",
  account_add_description: "Descripci\xF3n",
  account_add_provisioning_profile: "Perfil de Provisionamiento",
  account_add_billing_contact: "Contacto de Facturaci\xF3n",
  account_add_invalid_email: "Por favor ingrese un correo electr\xF3nico v\xE1lido.",
  account_cancel_store_modal_title: "Cancelar una Tienda eliminar\xE1 todas las \xF3rdenes asociadas y es irreversible",
  account_cancel_store_destroyed_success: "Destrucci\xF3n exitosa.",
  account_cancel_store_store_id: "ID de Tienda",
  account_cancel_store_store_id_required: "ID de Tienda es obligatorio",
  account_cancel_store_store_id_placeholder: "Por favor ingrese el ID de Tienda",
  account_cancel_store_confirm: "Confirmar",
  account_cancel_store_confirm_required: "Por favor escriba la palabra 'CONFIRMAR'",
  account_cancel_store_confirm_placeholder: "Por favor escriba la palabra 'CONFIRMAR'",
  account_disable_modal_title: "Deshabilitar una Cuenta eliminar\xE1 todas las tiendas asociadas y es irreversible",
  account_disable_cancel: "Cancelar",
  account_disable_delete: "Eliminar",
  account_disable_success: "Cuenta eliminada con \xE9xito",
  account_disable_account_id: "ID de Cuenta",
  account_disable_account_id_required: "ID de Cuenta es obligatorio",
  account_disable_account_id_placeholder: "Por favor ingrese el ID de Cuenta",
  account_disable_confirm: "Confirmar",
  account_disable_confirm_required: "Por favor escriba la palabra 'CONFIRMAR'",
  account_disable_confirm_placeholder: "Por favor escriba la palabra 'CONFIRMAR'",
  account_edit_page_title: "Editar Cuenta",
  account_edit_primary_contact: "Contacto Principal",
  account_edit_billing_contact: "Contacto de Facturaci\xF3n",
  account_edit_first_name: "Nombre",
  account_edit_last_name: "Apellido",
  account_edit_email: "Correo Electr\xF3nico",
  account_edit_email_invalid: "Por favor ingrese un correo electr\xF3nico v\xE1lido.",
  account_edit_company: "Empresa",
  account_edit_address_line1: "Direcci\xF3n (l\xEDnea 1)",
  account_edit_address_line2: "Direcci\xF3n (l\xEDnea 2)",
  account_edit_phone: "N\xFAmero de Tel\xE9fono",
  account_edit_country: "Pa\xEDs",
  account_edit_state: "Estado",
  account_edit_city: "Ciudad",
  account_edit_zip: "C\xF3digo Postal",
  account_edit_revenue: "Ingresos",
  account_edit_save: "Guardar",
  account_edit_success: "Cuenta actualizada con \xE9xito.",
  account_edit_status_title: "Configurar Estado de la Cuenta",
  account_edit_status_cancel: "Cancelar",
  account_edit_status_save: "Guardar",
  account_edit_status_success: "Estado editado con \xE9xito",
  account_edit_status_account_id: "ID de Cuenta",
  account_edit_status_account_id_required: "ID de Cuenta es obligatorio",
  account_edit_status_account_id_placeholder: "Por favor ingrese el ID de Cuenta",
  account_edit_status_select_label: "Seleccione el estado de la cuenta",
  account_edit_status_active: "Activo",
  account_edit_status_unless: "Inactivo",
  account_new_store_add_new_store: "Agregar una nueva Tienda",
  account_new_store_store_name: "Nombre de Tienda",
  account_new_store_store_name_required: "El nombre de la tienda es obligatorio",
  account_new_store_plan: "Plan",
  account_new_store_plan_required: "El plan es obligatorio",
  account_new_store_company: "Empresa",
  account_new_store_description: "Descripci\xF3n",
  account_new_store_provisioning_profile: "Perfil de Provisionamiento",
  account_new_store_add_store_success: "Tienda agregada con \xE9xito"
};

// src/locales/es/common.ts
var common_default2 = {
  common_filter_clear: "Limpiar",
  common_filter_apply: "Aplicar",
  common_filter_filter: "Filtro",
  common_filter_expand: "Expandir",
  common_filter_search: "Buscar",
  common_btn_text_ok: "Aceptar",
  common_btn_text_cancel: "Cancelar",
  common_btn_text_apply: "Aplicar",
  common_btn_text_save: "Guardar",
  common_btn_text_add: "Agregar",
  common_btn_text_remove: "Quitar",
  common_btn_text_delete: "Eliminar",
  common_permission_denied: "No tiene permiso.",
  common_message_success: "\xA1\xC9xito!",
  common_enabled: "Habilitado",
  common_disabled: "Deshabilitado",
  common_loadingFailure: "Error de carga"
};

// src/locales/es/content.ts
var content_default2 = {
  content_page_action: "Acci\xF3n",
  content_page_id: "ID de contenido",
  content_page_name: "Nombre",
  content_page_content_type: "Tipo de contenido",
  content_page_store: "Tienda",
  content_page_updated: "Actualizado",
  content_page_last_updated_by: "\xDAltima actualizaci\xF3n por",
  content_page_status: "Estado",
  content_page_title: "Contenido",
  content_page_current_status: "Estado actual",
  content_page_action_edit: "Editar",
  content_page_action_duplicate: "Duplicar",
  content_page_action_archive: "Archivar",
  content_page_action_delete: "Eliminar",
  content_page_store_description: "Seleccione la tienda",
  content_page_action_create_content: "Crear contenido",
  content_edit_tab_editor: "Editor",
  content_edit_save_button: "Guardar",
  content_edit_page_title: "Crear contenido",
  content_edit_name_required: "El nombre es obligatorio",
  content_edit_type_required: "El tipo es obligatorio",
  content_edit_headline_required: "El t\xEDtulo es obligatorio",
  content_edit_body_required: "El texto del cuerpo es obligatorio",
  content_edit_create_success: "Contenido creado con \xE9xito.",
  content_edit_update_success: "Contenido actualizado con \xE9xito.",
  content_edit_failed_to_update_locales: "No se pudo actualizar los locales",
  content_edit_max_media_files: "S\xF3lo se puede subir hasta 3 archivos de medios",
  content_edit_name_label: "Nombre",
  content_edit_name_description: "Ingrese el nombre",
  content_edit_type_label: "Tipo",
  content_edit_type_description: "Seleccione el tipo",
  content_edit_editor_headline_label: "T\xEDtulo",
  content_edit_editor_headline_description: "M\xE1ximo 256 caracteres",
  content_edit_editor_body_label: "Texto del cuerpo",
  content_delete_success: "Contenido eliminado exitosamente",
  content_delete_warning: "Este contenido ser\xE1 eliminado permanentemente. Esta acci\xF3n no se puede deshacer.",
  content_name: "Nombre del Contenido",
  content_name_required: "El nombre del contenido es requerido",
  content_name_placeholder: "Por favor ingrese el nombre del contenido",
  confirm: "Confirmar",
  confirm_required: "Por favor ingrese la confirmaci\xF3n",
  confirm_validation: "Por favor escriba 'CONFIRM' para confirmar",
  confirm_placeholder: "Por favor escriba 'CONFIRM' para confirmar",
  cancel: "Cancelar",
  ok: "Aceptar",
  content_page_toggle_approved: "Aprobado",
  content_page_toggle_pending: "Pendiente",
  content_page_toggle_archived: "Archivado",
  content_media_list_title: "Archivos de medios ({{count}}/3)",
  content_media_list_no_media_files: "No hay archivos de medios subidos",
  content_media_list_media_file: "Archivo de medios",
  content_file_upload_please_select_file_first: "Por favor seleccione un archivo primero",
  content_file_upload_failed_to_upload_file: "No se pudo subir el archivo",
  content_file_upload_success: "Archivo subido con \xE9xito",
  content_file_upload_uploading: "Subiendo...",
  content_file_upload_upload_file: "Subir archivo",
  content_file_upload_upload_media_files: "Subir archivos de medios (M\xE1ximo 3 archivos)",
  content_detail_versions_failed_to_fetch_content_versions: "No se pudo obtener las versiones del contenido",
  content_detail_versions_updated_time: "Tiempo de actualizaci\xF3n",
  content_detail_versions_review_status: "Estado de revisi\xF3n",
  content_detail_status_you_do_not_have_permission_to_update_review_status: "No tiene permiso para actualizar el estado de revisi\xF3n",
  content_detail_status_status_updated_successfully: "Estado actualizado con \xE9xito",
  content_detail_status_failed_to_update_status: "No se pudo actualizar el estado",
  content_detail_status_updating: "Actualizando...",
  content_detail_status_change_status: "Cambiar estado",
  content_page_last_saved: "\xDAltima actualizaci\xF3n",
  content_detail_rich_text_editor_loading: "Cargando editor...",
  content_detail_locales_failed_to_update_locales: "No se pudo actualizar los locales",
  content_detail_locales_locales_updated_successfully: "Locales actualizados con \xE9xito",
  content_detail_locales_title: "Locales",
  content_detail_locales_current_locales: "Locales actuales",
  content_detail_locales_change_locales: "Cambiar locales",
  content_edit_only_en_us_allowed: "El nombre debe ser consistente en todos los locales",
  content_edit_do_not_have_permission_to_update_review_status: "No tiene permiso para actualizar el estado de revisi\xF3n",
  content_filter_content_type: "Tipo de contenido",
  content_filter_update_date: "Fecha de actualizaci\xF3n",
  content_restore_modal_title: "Restaurar contenido",
  content_restore_modal_button: "Restaurar",
  content_restore_modal_message: "Restaurar: \xBFConfirma la restauraci\xF3n de este contenido? Despu\xE9s de la restauraci\xF3n, ser\xE1 visible y operable normalmente en la lista de contenido.",
  content_restore_success: "Contenido restaurado con \xE9xito",
  content_soft_delete_modal_title: "Eliminar contenido",
  content_soft_delete_modal_button: "Eliminar",
  content_soft_delete_modal_message: "Este producto ser\xE1 eliminado de la lista de contenido. Si desea recuperarlo, puede restaurarlo en la pesta\xF1a 'Eliminados'.",
  content_soft_delete_success: "Contenido eliminado con \xE9xito",
  content_action_delete_permanently: "Eliminar permanentemente",
  content_action_restore: "Restaurar",
  content_action_duplicate_success: "\xA1Duplicaci\xF3n exitosa!",
  content_action_archive_success: "Contenido archivado con \xE9xito",
  content_action_select_store_modal_title: "Seleccionar tienda para duplicar",
  content_action_cancel: "Cancelar",
  content_action_confirm: "Confirmar",
  content_action_un_archive: "Desarchivar"
};

// src/locales/es/customerProfile.ts
var customerProfile_default2 = {
  customerProfile_customer_management_first_name: "Nombre",
  customerProfile_customer_management_last_name: "Apellido",
  customerProfile_customer_management_email: "Correo electr\xF3nico",
  customerProfile_customer_management_phone: "Tel\xE9fono",
  customerProfile_customer_management_store_name: "Nombre de la tienda",
  customerProfile_customer_management_created_at: "Creado el",
  customerProfile_customer_profile_details_page_title: "Perfil de cliente",
  customerProfile_customer_profile_details_orders_revenue: "Ingresos de pedidos",
  customerProfile_customer_order_revenue_page_title: "Ingresos de pedidos (Cliente)",
  customerProfile_customer_order_revenue_action_bar_period_0: "Hoy",
  customerProfile_customer_order_revenue_action_bar_period_1: "Ayer",
  customerProfile_customer_order_revenue_action_bar_period_2: "\xDAltimos 7 d\xEDas",
  customerProfile_customer_order_revenue_action_bar_period_3: "\xDAltimos 14 d\xEDas",
  customerProfile_customer_order_revenue_action_bar_period_4: "\xDAltimos 30 d\xEDas",
  customerProfile_customer_order_revenue_action_bar_period_5: "\xDAltimos 90 d\xEDas",
  customerProfile_customer_order_revenue_action_bar_period_6: "Este trimestre",
  customerProfile_customer_order_revenue_action_bar_period_7: "\xDAltimo trimestre",
  customerProfile_customer_order_revenue_action_bar_period_8: "Este a\xF1o",
  customerProfile_customer_order_revenue_action_bar_period_9: "\xDAltimo a\xF1o",
  customerProfile_customer_order_revenue_overview_title: "Nombre del cliente",
  customerProfile_customer_order_revenue_chart_title: "Ingresos de pedidos",
  customerProfile_customer_order_revenue_chart_unit: "Unidad",
  customerProfile_customer_order_revenue_orders_table_title: "Pedidos",
  customerProfile_customer_order_revenue_orders_table_order_id: "ID de pedido",
  customerProfile_customer_order_revenue_orders_table_date: "Fecha",
  customerProfile_customer_order_revenue_orders_table_source: "Fuente",
  customerProfile_customer_order_revenue_orders_table_subtotal: "Subtotal",
  customerProfile_customer_order_revenue_orders_table_line_item_discounts: "Descuentos de art\xEDculos",
  customerProfile_customer_order_revenue_orders_table_shipping: "Env\xEDo",
  customerProfile_customer_order_revenue_orders_table_tax: "Impuestos",
  customerProfile_customer_order_revenue_orders_table_total: "Total",
  customerProfile_customer_information: "Informaci\xF3n del Cliente",
  customerProfile_first_name: "Nombre",
  customerProfile_last_name: "Apellido",
  customerProfile_company_name: "Nombre de la Empresa",
  customerProfile_phone_number: "N\xFAmero de Tel\xE9fono",
  customerProfile_email: "Correo Electr\xF3nico",
  customerProfile_address_line_1: "L\xEDnea de Direcci\xF3n 1",
  customerProfile_address_line_2: "L\xEDnea de Direcci\xF3n 2",
  customerProfile_suburb_city: "Ciudad",
  customerProfile_state_province: "Estado/Provincia",
  customerProfile_country: "Pa\xEDs",
  customerProfile_zip_postcode: "C\xF3digo Postal",
  customerProfile_store_name: "Nombre de la Tienda",
  customerProfile_created_at: "Creado En",
  customerProfile_customer_orders: "Lista de Pedidos"
};

// src/locales/es/dashboard.ts
var dashboard_default2 = {
  dashboard_customers_report_title: "Informe de Clientes",
  dashboard_customers_report_view_all: "Ver Todos los Informes",
  dashboard_action_bar_all_stores: "Todas las Tiendas",
  dashboard_action_bar_filter_by_store: "Filtrar por tienda",
  dashboard_action_bar_create_account: "Crear una Cuenta",
  dashboard_action_bar_create_store: "Crear una Tienda",
  dashboard_latest_orders_title: "\xDAltimos Pedidos",
  dashboard_latest_orders_view_all: "Ver Todos los Pedidos",
  dashboard_latest_orders_id: "ID",
  dashboard_latest_orders_platform_order_id: "ID de Pedido en Plataforma",
  dashboard_latest_orders_store_name: "Nombre de la Tienda",
  dashboard_latest_orders_date: "Fecha",
  dashboard_latest_orders_status: "Estado",
  dashboard_latest_orders_source: "Fuente",
  dashboard_latest_orders_total: "Total",
  dashboard_newest_accounts_title: "Cuentas M\xE1s Recientes",
  dashboard_newest_accounts_view_all: "Ver Todas las Cuentas",
  dashboard_newest_accounts_view_details: "Ver Detalles",
  dashboard_orders_revenue_title: "Ingresos por Pedidos",
  dashboard_orders_revenue_view_all: "Ver Todos los Ingresos",
  dashboard_orders_revenue_weekly: "Semanal",
  dashboard_orders_revenue_daily: "Diario",
  dashboard_over_view_store_revenue: "Ingresos de la Tienda",
  dashboard_over_view_store_revenue_total: "Ingresos Totales de la Tienda",
  dashboard_over_view_orders: "Pedidos",
  dashboard_over_view_orders_total: "Total de Pedidos",
  dashboard_over_view_items_sold: "Total de Art\xEDculos Vendidos",
  dashboard_over_view_products_total: "Total de Productos Vendidos",
  dashboard_over_view_order_revenue: "Ingresos por Pedido",
  dashboard_over_view_order_revenue_total: "Ingresos Totales por Pedido",
  dashboard_over_view_fulfilled_orders: "Pedidos Cumplidos",
  dashboard_over_view_fulfilled_orders_total: "Total de Pedidos Cumplidos",
  dashboard_product_orders_title: "Pedidos por Producto",
  dashboard_product_orders_view_all: "Ver Todos los Productos",
  dashboard_promotion_utilization_title: "Utilizaci\xF3n de Promociones",
  dashboard_promotion_utilization_view_all: "Ver Todas las Promociones",
  dashboard_promotion_utilization_store_name: "Nombre de la Tienda",
  dashboard_promotion_utilization_store_hash: "Hash de la Tienda",
  dashboard_promotion_utilization_promotion_name: "Nombre de la Promoci\xF3n",
  dashboard_promotion_utilization_coupon: "Cup\xF3n",
  dashboard_promotion_utilization_usage: "Uso"
};

// src/locales/es/forgotPassword.ts
var forgotPassword_default2 = {
  forgotPassword_page_title: "Olvid\xE9 mi contrase\xF1a",
  forgotPassword_form_submit_button: "Restablecer contrase\xF1a",
  forgotPassword_form_account_label: "Cuenta",
  forgotPassword_form_verify_code_label: "C\xF3digo de verificaci\xF3n",
  forgotPassword_form_email_placeholder: "Por favor, introduce tu direcci\xF3n de correo electr\xF3nico.",
  forgotPassword_form_verify_code_placeholder: "Por favor, introduce el c\xF3digo de verificaci\xF3n.",
  forgotPassword_form_email_validation: "Por favor, introduce tu direcci\xF3n de correo electr\xF3nico.",
  forgotPassword_form_verify_code_required: "El c\xF3digo de verificaci\xF3n es un campo obligatorio.",
  forgotPassword_form_have_account: "\xBFYa tienes una cuenta?",
  forgotPassword_form_login: "Iniciar sesi\xF3n",
  forgotPassword_captcha_loading_failure: "Error de carga",
  forgotPassword_success_message: "El c\xF3digo de verificaci\xF3n es correcto. Por favor, revisa el correo electr\xF3nico."
};

// src/locales/es/layout.ts
var layout_default2 = {
  layout_route_text_stores: "Tiendas",
  layout_route_text_dashboard: "Panel",
  layout_route_text_account: "Cuentas",
  layout_route_text_content: "Contenido",
  layout_route_text_products: "Cat\xE1logo",
  layout_route_text_orders: "Pedidos",
  layout_route_text_promotions: "Promociones",
  layout_route_text_themes: "Temas",
  layout_route_text_onboarding: "Incorporaci\xF3n",
  layout_route_text_provisioning_profiles: "Perfiles de Provisionamiento",
  layout_route_text_customer_profiles: "Perfiles de Clientes",
  layout_route_text_reports: "Informes",
  layout_route_text_settings: "Configuraci\xF3n",
  loyout_global_permission_denied: "\xA1Permiso denegado!",
  loyout_app_brand_title: "Portal de Gesti\xF3n de Distribuidores CommerceHub",
  loyout_app_platform_bigcommerce: "Plataforma BigCommerce",
  loyout_app_platform_shopify: "Plataforma Shopify",
  loyout_app_logout: "Cerrar sesi\xF3n",
  loyout_app_menu_copyright: "Copyright \xA9 {{fullYear}} Silk Software Corp. Todos los derechos reservados"
};

// src/locales/es/login.ts
var login_default2 = {
  login_page_title: "Iniciar sesi\xF3n",
  login_form_submit_button: "Iniciar sesi\xF3n",
  login_form_account_label: "Cuenta",
  login_form_password_label: "Contrase\xF1a",
  login_form_email_placeholder: "Por favor, introduce tu direcci\xF3n de correo electr\xF3nico.",
  login_form_password_placeholder: "Por favor, introduce tu contrase\xF1a.",
  login_form_email_validation: "Por favor, introduce tu direcci\xF3n de correo electr\xF3nico.",
  login_form_forgot_password: "\xBFOlvidaste tu contrase\xF1a?",
  login_recaptcha_loading: "reCAPTCHA se est\xE1 cargando. Por favor, espera un momento e int\xE9ntalo de nuevo"
};

// src/locales/es/onboarding.ts
var onboarding_default2 = {
  onboarding_page_title: "Configuraci\xF3n de Incorporaci\xF3n",
  onboarding_bounce_rate_title: "Tasa de Rebote",
  onboarding_bounce_rate_weekly: "Semanal",
  onboarding_bounce_rate_daily: "Diario",
  onboarding_wizard_title: "Asistente",
  onboarding_wizard_edit_forms: "Editar Formularios",
  onboarding_wizard_save: "Guardar",
  onboarding_wizard_success: "\xA1\xC9xito!",
  onboarding_wizard_error: "\xA1Error!",
  onboarding_wizard_form_customer_information: "Formulario de Informaci\xF3n del Cliente",
  onboarding_wizard_form_products: "Productos",
  onboarding_wizard_form_themes: "Temas",
  onboarding_wizard_form_gateway: "Puerta de Enlace",
  onboarding_wizard_form_billing: "Facturaci\xF3n",
  onboarding_wizard_form_description: "Descripci\xF3n",
  onboarding_wizard_form_description_placeholder: "Por favor ingrese una descripci\xF3n...",
  onboarding_wizard_form_description_optional: " (opcional)",
  onboarding_wizard_form_required_error: "El campo Formulario de Informaci\xF3n del Cliente es obligatorio.",
  onboarding_themes_title: "Temas",
  onboarding_themes_add_themes: "Agregar Temas",
  onboarding_themes_remove: "Eliminar",
  onboarding_themes_no_permission: "No tiene permiso.",
  onboarding_themes_success: "\xA1\xC9xito!",
  onboarding_themes_modal_select_themes: "Seleccionar Temas",
  onboarding_themes_modal_cancel: "Cancelar",
  onboarding_themes_modal_save: "Guardar",
  onboarding_themes_modal_success: "\xA1\xC9xito!",
  onboarding_themes_modal_styles: "estilos",
  onboarding_themes_modal_utilization: "Utilizaci\xF3n:",
  onboarding_themes_modal_search_placeholder: "Buscar temas...",
  onboarding_themes_loading_failure: "Error de carga",
  onboarding_themes_remove_modal_title: "El tema seleccionado ser\xE1 eliminado de la configuraci\xF3n de incorporaci\xF3n.",
  onboarding_themes_remove_modal_cancel: "Cancelar",
  onboarding_themes_remove_modal_delete: "Eliminar",
  onboarding_themes_remove_modal_success: "\xA1\xC9xito!",
  onboarding_themes_remove_modal_error: "Error al eliminar estilos.",
  onboarding_category_profiles_title: "Perfiles de Categor\xEDa",
  onboarding_category_profiles_add_profile: "Agregar Perfil",
  onboarding_category_profiles_remove: "Eliminar",
  onboarding_category_profiles_profiles: "Perfiles",
  onboarding_category_profiles_table_profile_name: "Nombre del Perfil",
  onboarding_category_profiles_table_utilization: "Utilizaci\xF3n",
  onboarding_category_profiles_table_products: "Productos",
  onboarding_category_profiles_table_created_at: "Creado en",
  onboarding_category_profiles_table_action: "Acci\xF3n",
  onboarding_category_profiles_select_modal_title: "Seleccionar Perfiles de Aprovisionamiento",
  onboarding_category_profiles_select_modal_cancel: "Cancelar",
  onboarding_category_profiles_select_modal_add_profile: "Agregar Perfil",
  onboarding_category_profiles_select_modal_success: "\xA1\xC9xito!",
  onboarding_category_profiles_select_modal_no_permission: "No tiene permiso.",
  onboarding_category_profiles_select_modal_qty_products: "Cantidad de Productos",
  onboarding_category_profiles_select_modal_themes: "Temas",
  onboarding_category_profiles_select_modal_search_placeholder: "Buscar perfiles..."
};

// src/locales/es/orders.ts
var orders_default2 = {
  orders_list_page_title: "Gesti\xF3n de Pedidos",
  orders_list_filter_export: "Exportar",
  orders_list_filter_dateRange: "Rango de Fechas",
  orders_list_filter_search: "Buscar Pedidos",
  orders_list_status_ALL: "Todos",
  orders_list_status_PENDING: "Pendiente",
  orders_list_status_UNFULFILLED: "No Cumplido",
  orders_list_status_IN_PROGRESS: "En Progreso",
  orders_list_status_PARTIALLY_FULFILLED: "Parcialmente Cumplido",
  orders_list_status_FULFILLED: "Cumplido",
  orders_list_status_CANCELLED: "Cancelado",
  orders_list_platform_ALL: "Todas las Fuentes",
  orders_list_platform_Shopify: "Shopify",
  orders_list_platform_Bigcommerce: "BigCommerce",
  orders_list_columns_OrderID: "ID de Pedido",
  orders_list_columns_OrderPlatformOrderID: "ID de Pedido en Plataforma",
  orders_list_columns_OrderName: "Nombre del Pedido",
  orders_list_columns_OrderStore: "Nombre de la Tienda",
  orders_list_columns_OrderDate: "Fecha",
  orders_list_columns_OrderStatus: "Estado",
  orders_list_columns_OrderPaymentStatus: "Estado de Pago",
  orders_list_columns_OrderSource: "Fuente",
  orders_list_columns_OrderCustomerName: "Nombre del Cliente",
  orders_list_columns_OrderTotal: "Total",
  orders_list_columns_OrderShipping: "Env\xEDo del Pedido",
  order_detail_page_title: "Detalle del Pedido",
  order_detail_info_OrderID: "ID de Pedido",
  order_detail_info_OrderProducts: "Productos",
  order_detail_info_OrderPrice: "Precio",
  order_detail_info_OrderStatus: "Estado",
  order_detail_info_OrderCustomer: "Cliente",
  order_detail_info_OrderDate: "Fecha",
  order_detail_info_OrderAddress: "Direcci\xF3n",
  order_detail_product_name: "Nombre del Producto",
  order_detail_product_quantity: "Cantidad",
  order_detail_product_totalprice: "Total",
  order_detail_shoppingAddress_firstName: "Nombre",
  order_detail_shoppingAddress_lastName: "Apellido",
  order_detail_shoppingAddress_email: "Correo Electr\xF3nico",
  order_detail_shoppingAddress_phone: "Tel\xE9fono",
  order_detail_shoppingAddress_zip: "C\xF3digo Postal",
  order_detail_shoppingAddress_country: "Pa\xEDs",
  order_detail_shoppingAddress_country_iso2: "C\xF3digo ISO2 del Pa\xEDs",
  order_detail_shoppingAddress_city: "Ciudad",
  order_detail_shoppingAddress_state: "Estado",
  order_detail_shoppingAddress_company: "Empresa",
  order_detail_shoppingAddress_address1: "Calle 1",
  order_export_radio_filtered: "Pedidos filtrados ({{count}} pedidos)",
  order_export_radio_all: "Todos los pedidos"
};

// src/locales/es/packages.ts
var packages_default2 = {
  package_ui_d5Form_required: "{{name}} es un campo obligatorio.",
  package_ui_d5Form_correctFormat: "Por favor, introduzca el formato correcto",
  package_ui_d5Form_maxLength: "{{name}} no puede tener m\xE1s de {{length}} caracteres",
  package_ui_d5Form_please: "Por favor ",
  package_ui_d5Form_fileInput_context: "Haga clic o arrastre el archivo a esta \xE1rea para subirlo",
  package_ui_d5Export_success: "Exportaci\xF3n exitosa, le enviaremos un correo electr\xF3nico m\xE1s tarde, por favor rev\xEDselo.",
  package_ui_d5Export_title: "\xBFEst\xE1 seguro?",
  package_ui_d5Export_btn_cancelText: "Cancelar",
  package_ui_d5Export_btn_okText: "Aceptar",
  package_ui_d5Export_context: "Exportar datos como archivo CSV puede tardar un tiempo. Una vez que se exporte correctamente, le enviaremos un correo electr\xF3nico para que pueda descargarlo.",
  package_ui_d5Export_order_range: "Rango de Exportaci\xF3n de Pedidos",
  package_ui_d5ImageUpload_alt: "Error de carga",
  package_ui_d5ImageUpload_upload: "Subir",
  package_ui_d5Import_success: "Importaci\xF3n exitosa, le enviaremos un correo electr\xF3nico m\xE1s tarde, por favor rev\xEDselo.",
  package_ui_d5Import_btn_cancelText: "Cancelar",
  package_ui_d5Import_btn_okText: "Iniciar importaci\xF3n",
  package_ui_d5Loading_context: "Cargando...",
  package_ui_d5Loading_certification_left: "Copyright \xA9",
  package_ui_d5Loading_certification_right: "Silk Software Corp. Todos los derechos reservados",
  package_ui_d5Layout_layoutFrame_h2_title: "CommerceHub",
  package_ui_d5Layout_layoutFrame_title: "Portal de Gesti\xF3n de Distribuidores"
};

// src/locales/es/product.ts
var product_default2 = {
  product_list_page_title: "Gesti\xF3n de productos",
  product_list_import_template_text_1: "Paso 1 - Descargar plantilla de importaci\xF3n de cat\xE1logo",
  product_list_import_template_text_2: "Le recomendamos que",
  product_list_import_template_link_3: "descargue la plantilla",
  product_list_import_template_text_4: "antes de importar archivos. Los campos CSV deben estar en el siguiente orden: URL de imagen, Nombre del producto, Precio, Inventario, SKU, Categor\xEDas, Descripci\xF3n.",
  product_list_import_template_text_5: "Paso 2 - Importar productos en formato CSV",
  product_list_action_click_validate: "Ha hecho clic muy r\xE1pido, por favor intente de nuevo m\xE1s tarde.",
  product_list_action_pull_success: "Extracci\xF3n exitosa.",
  product_list_action_modal_pull_header: "\xBFActualizar tiendas del comerciante?",
  product_list_action_export_btn_text: "Exportar",
  product_list_action_push_selected_product: "Enviar productos seleccionados",
  product_list_action_push_all_product: "Enviar todos los productos",
  product_list_filter_status_enable: "Habilitado",
  product_list_filter_status_disable: "Deshabilitado",
  product_list_filter_label_search: "Buscar",
  product_list_filter_label_search_placeholder: "buscar",
  product_list_filter_label_status: "Estado",
  product_list_filter_label_status_placeholder: "Seleccione estado",
  product_list_filter_label_category: "Categor\xEDa",
  product_list_filter_label_category_placeholder: "Todas las categor\xEDas",
  product_list_filter_form_product_name: "Nombre del producto",
  product_list_filter_form_product_name_placeholder: "escriba el nombre del producto",
  product_list_filter_form_product_sku: "SKU",
  product_list_filter_form_product_sku_placeholder: "escriba el SKU",
  product_list_filter_form_product_price: "Precio",
  product_list_filter_form_product_price_placeholder: " (igual a)",
  product_list_filter_form_product_price_validate: "Por favor ingrese un n\xFAmero en el campo de texto.",
  product_list_filter_form_product_inventory: "Inventario",
  product_list_filter_form_product_inventory_placeholder: " (igual a)",
  product_list_table_form_product_image: "Imagen",
  product_list_table_form_product_name: "Nombre del producto",
  product_list_table_form_product_price: "Precio del producto",
  product_list_table_form_product_inventory: "Inventario",
  product_list_table_form_product_sku: "SKU",
  product_list_table_form_product_status: "Estado",
  product_list_table_form_product_action: "Acci\xF3n",
  product_list_table_form_action_remove: "Eliminar",
  product_list_table_form_action_detail: "Ver detalles",
  product_list_table_form_action_distributor_visibility: "Visibilidad del distribuidor",
  product_list_table_form_action_delete_permanently: "Eliminar permanentemente",
  product_list_table_form_action_restore_product: "Restaurar producto",
  product_list_table_form_product_languages: "Tipos de idioma",
  product_push_page_title: "Enviar productos",
  product_push_page_description: "Agregar productos seleccionados a tiendas espec\xEDficas puede afectar el historial de pedidos, informes y otros datos potencialmente.",
  product_push_page_form_product_name: "Nombre del producto",
  product_push_page_form_product_name_validate: "El nombre del producto es obligatorio",
  product_push_page_form_product_name_placeholder: "Todos los productos",
  product_push_page_form_select_store: "Seleccionar tienda",
  product_push_page_form_target_language: "Idioma objetivo",
  product_push_page_form_target_language_tooltip: "Si el idioma de su tienda no coincide con el idioma objetivo que ha seleccionado, el producto puede ser enviado a su tienda como una versi\xF3n traducida",
  product_push_page_form_select_store_placeholder: "Seleccionar tienda",
  product_push_page_form_confirm: "Confirmar",
  product_push_page_form_confirm_validate: "Por favor escriba la palabra 'CONFIRMAR'",
  product_push_page_form_confirm_placeholder: "Por favor escriba la palabra 'CONFIRMAR'",
  product_push_page_message_success: `Empuje el producto con \xE9xito.
      Por favor revise su correo electr\xF3nico para obtener resultados detallados.
      En tres segundos volver\xE1 a la p\xE1gina anterior.`,
  product_action_remove_message_success: "Producto eliminado con \xE9xito",
  product_action_remove_text: "Este producto ser\xE1 eliminado de Distributed Commerce Hub, pero no afectar\xE1 los productos en sus tiendas.",
  product_action_remove_form_product_name: "Nombre del producto",
  product_action_remove_form_product_name_placeholder: "Por favor escriba el nombre del producto",
  product_action_remove_form_product_name_validate: "El nombre del producto es obligatorio",
  product_action_remove_form_confirm: "SKU",
  product_action_remove_form_confirm_placeholder: "Por favor escriba la palabra 'CONFIRMAR'",
  product_action_remove_form_confirm_validate: "Por favor escriba la palabra 'CONFIRMAR'",
  product_detail_page_title: "Detalles del producto",
  product_detail_page_SKU: "SKU",
  product_detail_page_button_save: "Guardar cambios",
  product_detail_page_button_delete: "Eliminar",
  product_detail_page_button_edit: "Editar",
  product_detail_page_button_change_image: "Cambiar imagen",
  product_detail_page_product_information: "Informaci\xF3n del producto",
  product_detail_page_product_image: "Imagen del producto",
  product_detail_page_product_no_image: "Sin imagen",
  product_detail_page_dimensions_label: "Dimensiones",
  product_detail_page_dimensions_label_tip: "Ancho x Alto x Profundidad, ej. (2.5 x 2.5 x 6.5)",
  product_detail_page_form_category: "Categor\xEDa",
  product_detail_page_form_product_name: "Nombre del producto",
  product_detail_page_form_sku: "SKU",
  product_detail_page_form_description: "Descripci\xF3n",
  product_detail_page_form_brand: "Marca",
  product_detail_page_form_status: "Estado",
  product_detail_page_form_regular_price: "Precio regular",
  product_detail_page_form_sale_price: "Precio de oferta",
  product_detail_page_form_inventory: "Inventario",
  product_detail_page_form_weight: "Peso",
  product_detail_page_form_dimension: "",
  product_detail_metafields_section: "Metacampos",
  product_detail_metafields_key: "Clave",
  product_detail_metafields_type: "Tipo",
  product_detail_metafields_value: "Valor",
  product_detail_page_tags_title: "Etiquetas",
  product_detail_page_tags_add_button: "Agregar etiqueta",
  product_detail_page_tags_modal_title: "Seleccionar etiquetas",
  product_detail_page_tags_modal_close: "Cerrar",
  product_detail_page_tags_search_placeholder: "Buscar por nombre de etiqueta o categor\xEDa...",
  product_detail_page_tags_selected_count: "{{count}} etiquetas seleccionadas",
  product_detail_page_tags_not_found: 'No se encontraron etiquetas que coincidan con "{{search}}"',
  product_detail_page_language_type: "Tipo de idioma",
  product_disabled_distributor_modal_title: "Visibilidad del distribuidor",
  product_disabled_distributor_modal_cancel: "Cancelar",
  product_disabled_distributor_modal_save: "Guardar cambios",
  product_disabled_distributor_button_disable_all: "Deshabilitar todo",
  product_disabled_distributor_checkbox_description: "deshabilitar este producto en el portal del distribuidor",
  product_disabled_distributor_update_success: "Visibilidad del distribuidor actualizada exitosamente",
  product_soft_delete_modal_title: "Eliminar producto",
  product_soft_delete_modal_confirm: "Este producto ser\xE1 eliminado de la lista de productos. Si desea recuperarlo, puede restaurarlo en la pesta\xF1a 'Eliminados'.",
  product_restore_modal_title: "Restaurar producto",
  product_restore_modal_button_restore: "Restaurar",
  product_action_restore_success: "Producto restaurado con \xE9xito",
  product_restore_modal_confirm: "Restaurar: \xBFConfirma restaurar este producto? Despu\xE9s de la restauraci\xF3n, se podr\xE1 ver y operar normalmente en la lista de productos.",
  product_list_toggle_products: "Productos",
  product_list_toggle_deletes: "Eliminado",
  product_variants_modal_title: "Editar variantes del producto",
  product_variants_modal_cancel: "Cancelar",
  product_variants_modal_update: "Actualizar variantes",
  product_variants_current_variants: "Variantes actuales",
  product_variants_generated_variants: "Variantes generadas:",
  product_variants_current_options: "Opciones actuales:",
  product_variants_modification_warning: "Modificar las variantes reemplazar\xE1 todas las variantes existentes con la nueva configuraci\xF3n. Aseg\xFArese de configurar todas las variantes deseadas antes de guardar.",
  product_variants_options_title: "Opciones de variantes",
  product_variants_add_option: "Agregar opci\xF3n",
  product_variants_option_number: "Opci\xF3n {{number}}",
  product_variants_edit: "Editar",
  product_variants_option_name: "Nombre de la opci\xF3n",
  product_variants_option_type: "Tipo de opci\xF3n",
  product_variants_not_set: "No establecido",
  product_variants_values: "Valores",
  product_variants_option_name_required: "Nombre de la opci\xF3n *",
  product_variants_option_name_placeholder: "ej., Tama\xF1o, Color, Material",
  product_variants_option_type_required: "Tipo de opci\xF3n*",
  product_variants_option_type_placeholder: "Seleccionar tipo de opci\xF3n",
  product_variants_values_required: "Valores *",
  product_variants_value_placeholder: "Ingrese el valor",
  product_variants_colors_label: "Colores:",
  product_variants_color_placeholder: "Valor de color (ej., #ff0000)",
  product_variants_add_color: "Agregar color",
  product_variants_max_colors: "M\xE1ximo 3 colores permitidos",
  product_variants_add_first_value: "Agregar primer valor",
  product_variants_add_value: "Agregar valor",
  product_variants_cancel: "Cancelar",
  product_variants_done: "Hecho",
  product_variants_no_values: "No se agregaron valores",
  product_variants_summary: "Resumen",
  product_variants_options_count: "Opciones:",
  product_variants_total_combinations: "Combinaciones totales:",
  product_variants_bulk_price_title: "Establecer precio regular para todas las variantes:",
  product_variants_price_error: "El precio debe ser mayor que 0",
  product_variants_confirm: "Confirmar",
  product_variants_type_swatch: "Muestra",
  product_variants_type_radio_buttons: "Botones de radio",
  product_variants_type_rectangle_list: "Lista rectangular",
  product_variants_type_dropdown: "Men\xFA desplegable"
};

// src/locales/es/promotion.ts
var promotion_default2 = {
  promotion_list_tab_automatic: "Autom\xE1tico",
  promotion_list_tab_coupon: "Cup\xF3n",
  promotion_list_automatic_create_promotion: "Crear una promoci\xF3n",
  promotion_list_automatic_push_promotion: "Enviar promoci\xF3n",
  promotion_list_automatic_filter_promotion_name: "Nombre de la promoci\xF3n",
  promotion_list_automatic_filter_promotion_name_extra: " (contiene)",
  promotion_list_automatic_filter_currency: "Moneda",
  promotion_list_automatic_filter_currency_extra: " (contiene)",
  promotion_list_automatic_filter_start_date: "Inicio",
  promotion_list_automatic_filter_end_date: "Fin",
  promotion_list_automatic_filter_date_extra: " (igual)",
  promotion_list_automatic_table_columns_promotion_name: "Nombre de la promoci\xF3n",
  promotion_list_automatic_table_columns_currency: "Moneda",
  promotion_list_automatic_table_columns_start_date: "Inicio",
  promotion_list_automatic_table_columns_end_date: "Fin",
  promotion_list_automatic_table_columns_redemption_type: "Tipo de promoci\xF3n",
  promotion_list_coupon_create_promotion: "Crear una promoci\xF3n",
  promotion_list_coupon_push_promotion: "Enviar promoci\xF3n",
  promotion_list_coupon_filter_promotion_name: "Nombre de la promoci\xF3n",
  promotion_list_coupon_filter_promotion_name_extra: " (contiene)",
  promotion_list_coupon_filter_coupon_code: "C\xF3digo de cup\xF3n",
  promotion_list_coupon_filter_coupon_code_extra: " (contiene)",
  promotion_list_coupon_filter_currency: "Moneda",
  promotion_list_coupon_filter_currency_extra: " (contiene)",
  promotion_list_coupon_filter_start_date: "Inicio",
  promotion_list_coupon_filter_end_date: "Fin",
  promotion_list_coupon_filter_date_extra: " (igual)",
  promotion_list_coupon_table_columns_promotion_name: "Nombre de la promoci\xF3n",
  promotion_list_coupon_table_columns_coupon_code: "C\xF3digo de cup\xF3n",
  promotion_list_coupon_table_columns_currency: "Moneda",
  promotion_list_coupon_table_columns_start_date: "Inicio",
  promotion_list_coupon_table_columns_end_date: "Fin",
  promotion_list_coupon_table_columns_redemption_type: "Tipo de promoci\xF3n",
  promotion_list_table_action_edit: "Editar",
  promotion_list_table_action_stop: "Detener",
  promotion_list_table_action_duplicate: "Duplicar",
  promotion_list_pull_promotion_btn: "Obtener promociones desde la tienda principal",
  promotion_list_pull_promotion_header: "\xBFActualizar tiendas del comerciante?",
  promotion_list_stop_promotion_description: "Detener la promoci\xF3n eliminar\xE1 los descuentos de las tiendas.",
  promotion_list_stop_promotion_columns_promotion_name: "Nombre de la promoci\xF3n",
  promotion_list_stop_promotion_columns_promotion_name_required: "El nombre de la promoci\xF3n es obligatorio",
  promotion_list_stop_promotion_columns_promotion_name_placeholder: "Por favor, escriba el nombre de la promoci\xF3n",
  promotion_list_stop_promotion_columns_confirm: "Confirmar",
  promotion_list_stop_promotion_columns_confirm_required: "Por favor, escriba la palabra 'CONFIRMAR'",
  promotion_list_stop_promotion_columns_confirm_placeholder: "Por favor, escriba la palabra 'CONFIRMAR'",
  promotion_list_push_promotion_page_title: "Enviar promoci\xF3n",
  promotion_list_push_promotion_description: "Agregar la promoci\xF3n a las tiendas seleccionadas puede afectar el historial de pedidos, informes y otros datos.",
  promotion_list_push_promotion_submit_error: "No tiene permiso para enviar promociones.",
  promotion_list_push_promotion_submit_success: "Promoci\xF3n agregada con \xE9xito. Se volver\xE1 a la p\xE1gina anterior en tres segundos.",
  promotion_list_push_promotion_columns_promotion_name: "Nombre de la promoci\xF3n",
  promotion_list_push_promotion_columns_promotion_name_required: "El nombre de la promoci\xF3n es obligatorio",
  promotion_list_push_promotion_columns_promotion_name_placeholder: "Por favor, escriba el nombre de la promoci\xF3n",
  promotion_list_push_promotion_columns_stores: "Tiendas",
  promotion_list_push_promotion_columns_stores_placeholder: "Seleccione tienda",
  promotion_list_push_promotion_columns_confirm: "Confirmar",
  promotion_list_push_promotion_columns_confirm_required: "Por favor, escriba la palabra 'CONFIRMAR'",
  promotion_list_push_promotion_columns_confirm_placeholder: "Por favor, escriba la palabra 'CONFIRMAR'",
  promotion_bc_add_page_title: "Crear promoci\xF3n",
  promotion_bc_add_active_columns_ctive_now_title_text: "\xBFActivar ahora?",
  promotion_bc_add_active_columns_is_active_text: "S\xED, hacer que este descuento est\xE9 disponible para los clientes",
  promotion_bc_add_limits_columns_limits_title_text: "Usar l\xEDmites",
  promotion_bc_add_limits_columns_limits: "Limitar uso total de esta promoci\xF3n",
  promotion_bc_add_limits_columns_limits_options_no_limit: "Sin l\xEDmite para el uso total de promociones",
  promotion_bc_add_limits_columns_limits_options_usage_limit: "Uso limitado para el total de promociones",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_header: "Permitir otras promociones",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_text: "Esta promoci\xF3n",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_select_used: "puede usarse",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_select_not_used: "no puede usarse",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_other_text: "junto con otras promociones.",
  promotion_bc_add_rule_header: "Regla",
  promotion_bc_add_rule_text: "\xBFQu\xE9 condiciones debe cumplir un cliente para recibir el descuento que ofrece?",
  promotion_bc_add_rule_columns_condition: "Condici\xF3n",
  promotion_bc_add_rule_columns_condition_buy_products_render: "Compra {{minimum_quantity}} productos",
  promotion_bc_add_rule_columns_condition_reaches_subtotal_render: "Alcanza un subtotal de pedido de {{minimum_spend}}",
  promotion_bc_add_rule_columns_condition_order_qty_render: "El cliente ha realizado al menos {{minimum_order_count}} pedidos",
  promotion_bc_add_rule_columns_condition_no_render: "Sin condici\xF3n",
  promotion_bc_add_rule_columns_reward: "Recompensa",
  promotion_bc_add_rule_columns_reward_gift_item_render: "Un regalo en su carrito",
  promotion_bc_add_rule_columns_reward_free_shipping_render: "Env\xEDo gratis",
  promotion_bc_add_rule_columns_reward_discount_order_render: "Descuento en subtotal del pedido",
  promotion_bc_add_rule_columns_reward_discount_products_render: "Descuento en productos",
  promotion_bc_add_rule_columns_reward_fixed_price_render: "Precio fijo de {{fixed_price}} en productos",
  promotion_bc_add_search_products_add_button_text: "Haga clic para agregar un selector de productos",
  promotion_bc_add_search_products_error_no_selection: "Debe agregar al menos un producto aqu\xED.",
  promotion_bc_add_search_products_modal_title: "Seleccionar productos",
  promotion_bc_add_search_products_table_banner: "Banner",
  promotion_bc_add_search_products_table_name: "Nombre del producto",
  promotion_bc_add_search_products_table_sku: "SKU",
  promotion_bc_add_search_products_table_price: "Precio del producto",
  promotion_bc_add_search_products_table_image_alt: "Error de carga",
  promotion_bc_add_search_products_table_item_name: "Productos",
  promotion_bc_add_search_products_cancel_button: "Cancelar",
  promotion_bc_add_search_products_save_button: "Guardar",
  promotion_bc_add_summary_title: "Resumen",
  promotion_bc_add_promotion_name: "Nombre de la promoci\xF3n",
  promotion_bc_add_promotion_name_placeholder: "Por favor, escriba el nombre de su promoci\xF3n aqu\xED",
  promotion_bc_add_promotion_type: "Tipo de promoci\xF3n",
  promotion_bc_add_select_placeholder: "Selecci\xF3n",
  promotion_bc_add_coupon_code_label: "C\xF3digo de cup\xF3n",
  promotion_bc_add_coupon_code_placeholder: "Ingrese su c\xF3digo de cup\xF3n",
  promotion_bc_add_schedule_title: "Horario",
  promotion_bc_add_start_at_label: "Inicio",
  promotion_bc_add_end_at_label: "Fin",
  promotion_bc_add_select_date_placeholder: "Seleccione fecha",
  promotion_bc_add_schedule_toggle_button: "Fecha / hora espec\xEDfica",
  promotion_bc_add_schedule_week_label: "Cada semana",
  promotion_bc_add_schedule_day_label: "D\xEDa",
  promotion_bc_add_schedule_day_placeholder: "Seleccione d\xEDa",
  promotion_bc_add_schedule_time_label: "Hora",
  promotion_bc_add_schedule_to_label: "a",
  promotion_bc_add_clear_button: "Limpiar",
  promotion_bc_add_targeting_title: "Segmentaci\xF3n",
  promotion_bc_add_targeting_sub_title: "Dirigir a clientes si...",
  promotion_bc_add_currency_is: "La moneda es",
  promotion_bc_add_customer_group: "Grupo de clientes",
  promotion_bc_add_is: "es",
  promotion_bc_add_is_not: "no es",
  promotion_bc_add_select_group: "Seleccione grupo",
  promotion_bc_add_shipping_destination: "Destino de env\xEDo",
  promotion_bc_add_select_zone: "Seleccione zonas",
  promotion_bc_add_selection: "Selecci\xF3n",
  promotion_bc_add_template_rules_button: "Agregar reglas de plantilla",
  promotion_bc_add_template_rules_modal_title: "Seleccione una regla de plantilla",
  promotion_bc_add_rules_addition_reaching_label: "Alcanzar",
  promotion_bc_add_rules_addition_reaching_products_quantity: "Cantidad de productos",
  promotion_bc_add_rules_addition_reaching_order_total_value: "Valor total del pedido",
  promotion_bc_add_rules_addition_minimum_spend_label: "Gasto m\xEDnimo en el pedido",
  promotion_bc_add_rules_addition_minimum_order_count_label: "Cantidad de pedidos realizados por el cliente",
  promotion_bc_add_rules_addition_no_condition_text: "Cualquier pedido del cliente activar\xE1 esta recompensa.",
  promotion_bc_add_rules_addition_including_products_label: "Incluyendo productos",
  promotion_bc_add_rules_addition_including_products_product: "Productos individuales",
  promotion_bc_add_rules_addition_including_products_category: "En categor\xEDa",
  promotion_bc_add_rules_addition_including_products_brand: "En marca",
  promotion_bc_add_rules_addition_gift_title: "Cantidad de producto en el carrito del cliente gratis.",
  promotion_bc_add_rules_addition_gift_apply_once_once: "Una vez",
  promotion_bc_add_rules_addition_gift_apply_once_unlimited: "N\xFAmero ilimitado de veces",
  promotion_bc_add_rules_addition_product_label: "Seleccione productos",
  promotion_bc_add_rules_addition_shipping_zone_title: "Seleccione zonas",
  promotion_bc_add_rules_addition_shipping_zone_placeholder: "Selecci\xF3n",
  promotion_bc_add_rules_addition_shipping_zone_option_all: "Todas las zonas",
  promotion_bc_add_rules_addition_shipping_zone_option_selected: "Zonas seleccionadas",
  promotion_bc_add_rules_addition_cart_apply_once_once: "Una vez",
  promotion_bc_add_rules_addition_cart_apply_once_unlimited: "N\xFAmero ilimitado de veces",
  promotion_bc_add_rules_addition_cart_fixed_type_label: "Precio del producto",
  promotion_bc_add_rules_addition_cart_fixed_type_percentage: "Porcentaje",
  promotion_bc_add_rules_addition_cart_fixed_type_amount: "Cantidad",
  promotion_bc_add_rules_addition_cart_as_total_each: "Precio de cada producto",
  promotion_bc_add_rules_addition_cart_as_total_total: "Precio total de los productos incluidos",
  promotion_bc_add_rules_addition_cart_quantity_type_label: "Cantidad de productos aplicados a",
  promotion_bc_add_rules_addition_cart_quantity_type_all: "Todos",
  promotion_bc_add_rules_addition_cart_quantity_type_up_to: "Hasta",
  promotion_bc_add_rules_addition_cart_checkbox_sale: "Incluye productos en oferta",
  promotion_bc_add_rules_addition_cart_checkbox_condition: "Incluye productos que cumplen la condici\xF3n",
  promotion_bc_add_rules_addition_cart_include_type_label: "Incluye productos",
  promotion_bc_add_rules_addition_cart_include_type_product: "Productos individuales",
  promotion_bc_add_rules_addition_cart_include_type_category: "En categor\xEDa",
  promotion_bc_add_rules_addition_cart_include_type_brand: "En marca",
  promotion_bc_add_rules_addition_fixed_amount_label: "Descuento del subtotal del pedido por",
  promotion_bc_add_rules_addition_fixed_apply_to: "Aplicar a productos en el carrito",
  promotion_bc_add_rules_addition_fixed_apply_to_least: "El m\xE1s barato",
  promotion_bc_add_rules_addition_fixed_apply_to_most: "El m\xE1s caro",
  promotion_bc_add_rules_addition_fixed_quantity_label: "Cantidad de productos",
  promotion_bc_add_rules_addition_order_subtotal_title: "Descuento del subtotal del pedido por",
  promotion_bc_add_rules_addition_order_subtotal_apply_once_once: "Una vez",
  promotion_bc_add_rules_addition_order_subtotal_apply_once_unlimited: "N\xFAmero ilimitado de veces",
  promotion_bc_add_rules_addition_order_subtotal_type_value: "Valor",
  promotion_bc_add_rules_addition_order_subtotal_type_percentage: "Porcentaje",
  promotion_bc_add_rules_addition_condition_buy_products: "Comprar productos",
  promotion_bc_add_rules_addition_condition_customer_label: "Si el cliente",
  promotion_bc_add_rules_addition_condition_reaches_subtotal: "Alcanza un subtotal de pedido",
  promotion_bc_add_rules_addition_condition_order_qty: "Cantidad de pedidos realizados por el cliente",
  promotion_bc_add_rules_addition_condition_no_conditions: "Sin condiciones",
  promotion_bc_add_rules_addition_action_gift_item: "Un regalo en su carrito",
  promotion_bc_add_rules_addition_action_shipping: "Env\xEDo gratis",
  promotion_bc_add_rules_addition_action_cart_items: "Descuento en productos",
  promotion_bc_add_rules_addition_action_cart_value: "Descuento en subtotal del pedido",
  promotion_bc_add_rules_addition_action_fixed_price_set: "Precio fijo para # de productos",
  promotion_shopify_discount_type_selector_header: "Seleccionar tipo de descuento",
  promotion_shopify_discount_type_selector_type_product_title: "Descuento en productos",
  promotion_shopify_discount_type_selector_type_product_description: "Descuento en productos espec\xEDficos o colecciones de productos",
  promotion_shopify_discount_type_selector_type_buyxgety_title: "Compra X y obt\xE9n Y",
  promotion_shopify_discount_type_selector_type_buyxgety_description: "Descuento en productos espec\xEDficos o colecciones de productos",
  promotion_shopify_discount_type_selector_type_order_title: "Descuento en el pedido",
  promotion_shopify_discount_type_selector_type_order_description: "Descuento en el monto total del pedido",
  promotion_shopify_discount_type_selector_type_shipping_title: "Env\xEDo gratuito",
  promotion_shopify_discount_type_selector_type_shipping_description: "Ofrecer env\xEDo gratuito en un pedido",
  promotion_shopify_discount_type_selector_cancel: "Cancelar",
  promotion_shopify_add_page_edit_title: "Editar promoci\xF3n",
  promotion_shopify_add_page_create_title: "Crear promoci\xF3n",
  promotion_shopify_buy_x_get_y_form_title: "Compra X y recibe Y",
  promotion_shopify_buy_x_get_y_form_customer_buys: "El cliente compra",
  promotion_shopify_buy_x_get_y_form_customer_buys_lists_quantity: "Cantidad m\xEDnima de art\xEDculos",
  promotion_shopify_buy_x_get_y_form_customer_buys_lists_purchase: "Monto m\xEDnimo de compra",
  promotion_shopify_buy_x_get_y_form_quantity: "Cantidad",
  promotion_shopify_buy_x_get_y_form_quantity_validate: "Especifique una cantidad de productos que el cliente debe comprar",
  promotion_shopify_buy_x_get_y_form_amount: "Monto",
  promotion_shopify_buy_x_get_y_form_amount_validate: "Especifique un monto que el cliente debe gastar",
  promotion_shopify_buy_x_get_y_form_customer_gets: "El cliente recibe",
  promotion_shopify_buy_x_get_y_form_customer_gets_description: "Los clientes deben agregar la cantidad especificada a su carrito.",
  promotion_shopify_buy_x_get_y_form_gets_quantity: "Cantidad",
  promotion_shopify_buy_x_get_y_form_gets_quantity_validate: "Especifique una cantidad de productos que el cliente recibir\xE1",
  promotion_shopify_buy_x_get_y_form_gets_specific_products_label: "Cualquier art\xEDculo de",
  promotion_shopify_buy_x_get_y_form_gets_specific_products_option_product: "Productos espec\xEDficos",
  promotion_shopify_buy_x_get_y_form_gets_specific_products_validate: "Especifique un producto que el cliente recibir\xE1",
  promotion_shopify_buy_x_get_y_form_gets_discount_type_percentage: "Porcentaje",
  promotion_shopify_buy_x_get_y_form_gets_discount_type_amount: "Monto descontado por cada uno",
  promotion_shopify_buy_x_get_y_form_gets_discount_type_free: "Gratis",
  promotion_shopify_buy_x_get_y_form_gets_percentage_value_validate: "El valor del descuento no puede estar vac\xEDo",
  promotion_shopify_buy_x_get_y_form_gets_amount_off_each_description: "Para m\xFAltiples cantidades, el monto del descuento se aplicar\xE1 a cada art\xEDculo Y.",
  promotion_shopify_buy_x_get_y_form_gets_amount_off_each_value_validate: "El valor del descuento no puede estar vac\xEDo",
  promotion_shopify_buy_x_get_y_form_max_uses_label: "Establecer un n\xFAmero m\xE1ximo de usos por pedido",
  promotion_shopify_buy_x_get_y_form_max_uses_value_validate: "El n\xFAmero m\xE1ximo de usos por pedido no puede estar vac\xEDo",
  promotion_shopify_free_form_countries: "Pa\xEDses",
  promotion_shopify_free_form_country_type_all: "Todos los pa\xEDses",
  promotion_shopify_free_form_country_type_specific: "Pa\xEDses seleccionados",
  promotion_shopify_free_form_selected_country_description: "Buscar pa\xEDses",
  promotion_shopify_free_form_selected_country_validate: "Debe agregar pa\xEDses espec\xEDficos",
  promotion_shopify_free_form_shipping_rate_exclude_label: "Excluir tarifas de env\xEDo superiores a cierta cantidad",
  promotion_shopify_free_form_shipping_rate_exclude_description: "Tarifas de env\xEDo",
  promotion_shopify_product_form_applies_to_label: "Aplica a",
  promotion_shopify_product_form_applies_to_validate: "Deben agregarse productos espec\xEDficos",
  promotion_shopify_product_form_applies_to_option_product: "Productos espec\xEDficos",
  promotion_shopify_discount_method_label: "M\xE9todo",
  promotion_shopify_discount_method_method_label: "C\xF3digo de descuento",
  promotion_shopify_discount_method_method_code: "C\xF3digo de descuento",
  promotion_shopify_discount_method_method_automatic: "Descuento autom\xE1tico",
  promotion_shopify_discount_method_discount_code_label: "C\xF3digo de descuento",
  promotion_shopify_discount_method_discount_code_link: "Generar c\xF3digo aleatorio",
  promotion_shopify_discount_method_discount_code_description: "Los clientes deben ingresar este c\xF3digo en la caja.",
  promotion_shopify_discount_method_discount_title_label: "T\xEDtulo",
  promotion_shopify_discount_method_discount_title_description: "Los clientes ver\xE1n esto en su carrito y en la caja.",
  promotion_shopify_discount_value_label: "Valor del descuento",
  promotion_shopify_discount_value_type_percentage: "Porcentaje",
  promotion_shopify_discount_value_type_fixed: "Cantidad fija",
  promotion_shopify_discount_value_validate_required: "El valor del descuento no puede estar vac\xEDo",
  promotion_shopify_availability_label: "Disponibilidad",
  promotion_shopify_availability_description: "Aplicado autom\xE1ticamente en todos los canales de venta configurados excepto Punto de Venta (POS)",
  promotion_shopify_availability_pos_label: "Aplicar en POS (solo ubicaciones Pro)",
  promotion_shopify_minimum_purchase_requirements_label: "Requisitos m\xEDnimos de compra",
  promotion_shopify_minimum_purchase_requirements_lists_selectedType_option_none: "Sin requisitos m\xEDnimos",
  promotion_shopify_minimum_purchase_requirements_lists_selectedType_option_subtotal: "Monto m\xEDnimo de compra ($)",
  promotion_shopify_minimum_purchase_requirements_lists_selectedType_option_quantity: "Cantidad m\xEDnima de art\xEDculos",
  promotion_shopify_minimum_purchase_requirements_lists_amountValue_description: "Aplica solo a productos seleccionados.",
  promotion_shopify_minimum_purchase_requirements_lists_amountValue_validate: "El m\xEDnimo de compra no puede estar vac\xEDo",
  promotion_shopify_minimum_purchase_requirements_lists_quantityValue_description: "Aplica solo a productos seleccionados.",
  promotion_shopify_minimum_purchase_requirements_lists_quantityValue_validate: "La cantidad m\xEDnima no puede estar vac\xEDa",
  promotion_shopify_eligibility_label: "Elegibilidad",
  promotion_shopify_eligibility_description: "Redimible en todos los canales de venta configurados",
  promotion_shopify_eligibility_lists_selectedEligibilityType_option_all: "Todos los clientes",
  promotion_shopify_eligibility_lists_selectedEligibilityType_option_specificCustomerSegments: "Segmentos espec\xEDficos de clientes",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_description: "Buscar segmentos de clientes",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_1: "Clientes que no han comprado",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_2: "Clientes que han comprado m\xE1s de una vez",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_3: "Carritos abandonados en los \xFAltimos 30 d\xEDas",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_4: "Suscriptores por correo electr\xF3nico",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_option_5: "Clientes que han comprado al menos una vez",
  promotion_shopify_eligibility_lists_selectedEligibilitySpecificCustomerSegments_validate: "Se debe seleccionar al menos un segmento o cliente requisito",
  promotion_shopify_maximum_discount_label: "Uso m\xE1ximo de descuento",
  promotion_shopify_maximum_discount_lists_discountTotalNumber_label: "Limitar n\xFAmero total de usos de este descuento",
  promotion_shopify_maximum_discount_lists_limitOneUsePerCustomer_label: "Limitar a un uso por cliente",
  promotion_shopify_maximum_discount_lists_discountTotalNumberValue_validate: "El l\xEDmite total de uso no puede estar vac\xEDo",
  promotion_shopify_combinations_label: "Combinaciones",
  promotion_shopify_combinations_othersText_noCombineOtherDiscount: "Este descuento no se combinar\xE1 con ning\xFAn otro descuento en la caja",
  promotion_shopify_combinations_lists_product_label: "Descuentos en productos",
  promotion_shopify_combinations_lists_product_description: "Cada art\xEDculo elegible en el carrito puede recibir hasta un descuento en producto",
  promotion_shopify_combinations_lists_order_label: "Descuentos en pedidos",
  promotion_shopify_combinations_lists_order_description: "Todos los descuentos elegibles en pedidos se aplicar\xE1n adem\xE1s de los descuentos en productos",
  promotion_shopify_combinations_lists_shipping_label: "Descuentos en env\xEDo",
  promotion_shopify_combinations_lists_shipping_description: "El mayor descuento elegible en env\xEDo se aplicar\xE1 adem\xE1s de los descuentos en productos",
  promotion_shopify_active_dates_label: "Fechas activas",
  promotion_shopify_active_dates_lists_startDate_label: "Fecha de inicio",
  promotion_shopify_active_dates_lists_startTime_label: "Hora de inicio",
  promotion_shopify_active_dates_lists_hasEndDate_label: "Establecer fecha de fin",
  promotion_shopify_active_dates_lists_endDate_label: "Fecha de fin",
  promotion_shopify_active_dates_lists_endTime_label: "Hora de fin",
  promotion_shopify_product_discount_applies_to: "Aplica a",
  promotion_shopify_product_discount_specific_products_must_be_added: "Deben agregarse productos espec\xEDficos",
  promotion_shopify_product_discount_specific_products: "Productos espec\xEDficos",
  promotion_shopify_component_add_product_placeholder: "Buscar productos",
  promotion_shopify_component_add_product_table_header: "Agregar productos",
  promotion_shopify_component_add_product_table_th_products: "Productos",
  promotion_shopify_component_add_product_table_th_total_available: "Total disponible",
  promotion_shopify_component_add_product_table_th_price: "Precio",
  promotion_shopify_component_add_product_table_variants_selectd: "{{selectedVariantsCount}} variantes seleccionadas",
  promotion_shopify_component_submit_button: "Guardar",
  promotion_shopify_component_submit_Discard: "Descartar",
  promotion_shopify_add_country_placeholder: "Buscar pa\xEDses",
  promotion_shopify_add_country_table_header: "Agregar pa\xEDses",
  promotion_shopify_add_country_table_no_country: "No se encontraron pa\xEDses",
  promotion_shopify_add_country_table_country_selectd: "{{selectedCountries}} pa\xEDses seleccionados"
};

// src/locales/es/provisioningProfiles.ts
var provisioningProfiles_default2 = {
  "provisioningProfiles.pageTitle": "Perfiles de Provisionamiento",
  "provisioningProfiles.addProfileToStores": "Agregar Perfil a Tiendas",
  "provisioningProfiles.createProfile": "Crear un Perfil",
  "provisioningProfiles.noPermission": "No tiene permisos.",
  "provisioningProfiles.shopify.addProfileToStores": "Agregar Perfil a Tiendas",
  "provisioningProfiles.shopify.createSuccess": "Perfil de aprovisionamiento creado con \xE9xito",
  "provisioningProfiles.shopify.editSuccess": "Perfil de aprovisionamiento editado con \xE9xito",
  "provisioningProfiles.shopify.addProductsBySKU": "Agregar Productos por SKU",
  "provisioningProfiles.shopify.skuList": "Lista de SKU",
  "provisioningProfiles.shopify.skuPlaceholder": "Pegue la lista de SKU aqu\xED (uno por l\xEDnea o separados por comas) Ejemplo: SKU001, SKU002, SKU003, SKU004",
  "provisioningProfiles.shopify.apply": "Aplicar",
  "provisioningProfiles.shopify.cancel": "Cancelar",
  "provisioningProfiles.shopify.notFound": "no se encuentra",
  "provisioningProfiles.filter.search": "buscar",
  "provisioningProfiles.filter.expand": "Expandir",
  "provisioningProfiles.filter.profileName": "Nombre del Perfil",
  "provisioningProfiles.filter.profileNameContains": " (contiene)",
  "provisioningProfiles.filter.themes": "Temas",
  "provisioningProfiles.filter.themesContains": " (contiene)",
  "provisioningProfiles.filter.promotions": "Promociones",
  "provisioningProfiles.filter.promotionsEquals": " (igual)",
  "provisioningProfiles.filter.qtyOfProducts": "Cantidad de Productos",
  "provisioningProfiles.filter.qtyOfProductsEquals": " (igual)",
  "provisioningProfiles.filter.utilization": "Utilizaci\xF3n",
  "provisioningProfiles.filter.utilizationEquals": " (igual)",
  "provisioningProfiles.filter.clear": "Limpiar",
  "provisioningProfiles.filter.apply": "Aplicar",
  "provisioningProfiles.table.profileName": "Nombre del Perfil",
  "provisioningProfiles.table.utilization": "Utilizaci\xF3n",
  "provisioningProfiles.table.qtyOfProducts": "Cantidad de Productos",
  "provisioningProfiles.table.themes": "Temas",
  "provisioningProfiles.table.createdAt": "Creado en",
  "provisioningProfiles.table.action": "Acci\xF3n",
  "provisioningProfiles.action.edit": "Editar",
  "provisioningProfiles.action.remove": "Eliminar",
  "provisioningProfiles.action.delete": "Borrar",
  "provisioningProfiles.delete.shopify.title": "Este perfil ser\xE1 eliminado de todos los productos y potencialmente otros datos.",
  "provisioningProfiles.delete.title": "Este perfil ser\xE1 eliminado de todas las tiendas y puede afectar el cat\xE1logo, temas, historial de pedidos, informes y potencialmente otros datos.",
  "provisioningProfiles.delete.profileName": "Nombre del Perfil",
  "provisioningProfiles.delete.profileNameRequired": "El nombre del perfil es obligatorio",
  "provisioningProfiles.delete.profileNamePlaceholder": "Por favor escriba el nombre del perfil",
  "provisioningProfiles.delete.confirm": "Confirmar",
  "provisioningProfiles.delete.confirmRequired": "Por favor escriba la palabra 'CONFIRMAR'",
  "provisioningProfiles.delete.confirmValidator": "Por favor escriba la palabra 'CONFIRMAR'",
  "provisioningProfiles.delete.confirmPlaceholder": "Por favor escriba la palabra 'CONFIRMAR'",
  "provisioningProfiles.delete.cancel": "Cancelar",
  "provisioningProfiles.delete.ok": "OK",
  "provisioningProfiles.delete.success": "Perfil eliminado exitosamente",
  "provisioningProfiles.create.pageTitle": "Crear Perfil",
  "provisioningProfiles.create.success": "Crear Exitoso",
  "provisioningProfiles.edit.pageTitle": "Editar Perfil",
  "provisioningProfiles.edit.success": "Editar Exitoso",
  "provisioningProfiles.form.summary": "Resumen",
  "provisioningProfiles.form.name": "Nombre del Perfil",
  "provisioningProfiles.form.namePlaceholder": "por favor escriba el nombre del perfil aqu\xED",
  "provisioningProfiles.form.industry": "Industria",
  "provisioningProfiles.form.industryPlaceholder": "por favor escriba la industria aqu\xED",
  "provisioningProfiles.form.description": "Descripci\xF3n",
  "provisioningProfiles.form.descriptionPlaceholder": "por favor escriba la descripci\xF3n aqu\xED",
  "provisioningProfiles.form.categories": "Categor\xEDas",
  "provisioningProfiles.form.products": "Productos",
  "provisioningProfiles.form.themes": "Temas",
  "provisioningProfiles.form.currentTheme": "Tema Actual",
  "provisioningProfiles.form.themeList": "Lista de Temas",
  "provisioningProfiles.form.image": "Imagen",
  "provisioningProfiles.form.save": "Guardar",
  "provisioningProfiles.form.cancel": "Cancelar",
  "provisioningProfiles.form.back": "Atr\xE1s",
  "provisioningProfiles.form.submit": "Enviar",
  "provisioningProfiles.categories.name": "Nombre",
  "provisioningProfiles.categories.qtyOfItems": "Cantidad de Elementos",
  "provisioningProfiles.categories.status": "Estado",
  "provisioningProfiles.categories.selectAll": "Seleccionar Todo",
  "provisioningProfiles.categories.deselectAll": "Deseleccionar Todo",
  "provisioningProfiles.products.name": "Nombre",
  "provisioningProfiles.products.price": "Precio",
  "provisioningProfiles.products.status": "Estado",
  "provisioningProfiles.products.delete": "Eliminar",
  "provisioningProfiles.products.deleteSelected": "Eliminar Seleccionados",
  "provisioningProfiles.products.deleteSuccess": "Eliminado exitosamente.",
  "provisioningProfiles.products.noProducts": "No hay productos seleccionados",
  "provisioningProfiles.products.add": "Agregar",
  "provisioningProfiles.products.remove": "Eliminar",
  "provisioningProfiles.products.filter": "Filtrar",
  "provisioningProfiles.products.clear": "Limpiar",
  "provisioningProfiles.products.apply": "Aplicar",
  "provisioningProfiles.products.image": "Imagen",
  "provisioningProfiles.products.productName": "Nombre del Producto",
  "provisioningProfiles.products.inventory": "Inventario",
  "provisioningProfiles.products.sku": "SKU",
  "provisioningProfiles.themes.selectTheme": "Seleccionar Tema",
  "provisioningProfiles.themes.selectThemes": "Seleccionar Temas",
  "provisioningProfiles.themes.currentTheme": "Tema Actual",
  "provisioningProfiles.themes.themeList": "Lista de Temas",
  "provisioningProfiles.themes.addTheme": "Agregar Tema",
  "provisioningProfiles.themes.removeTheme": "Eliminar Tema",
  "provisioningProfiles.themes.version": "Versi\xF3n",
  "provisioningProfiles.themes.styles": "estilos",
  "provisioningProfiles.themes.developedBy": "Desarrollado por",
  "provisioningProfiles.apply.pageTitle": "Aplicar Perfil a Tiendas",
  "provisioningProfiles.apply.confirmPageTitle": "Confirmar Aplicaci\xF3n de Perfiles de Provisionamiento",
  "provisioningProfiles.apply.confirmation": "Confirmaci\xF3n",
  "provisioningProfiles.apply.confirmationDescription": "Recomendamos enviar un correo electr\xF3nico de confirmaci\xF3n antes de aplicar el perfil a las tiendas.",
  "provisioningProfiles.apply.targetStore": "Tienda Objetivo*",
  "provisioningProfiles.apply.stores": "Tiendas",
  "provisioningProfiles.apply.selectStore": "Seleccionar tienda",
  "provisioningProfiles.apply.confirmType1": "Enviar un correo electr\xF3nico de confirmaci\xF3n al propietario de la tienda para autorizar la aplicaci\xF3n del perfil.",
  "provisioningProfiles.apply.confirmType2": "Establecer una fecha de implementaci\xF3n obligatoria y enviar un correo electr\xF3nico de confirmaci\xF3n al propietario de la tienda para autorizar la aplicaci\xF3n del perfil. Si el propietario de la tienda no est\xE1 de acuerdo con la confirmaci\xF3n, el perfil se aplicar\xE1 dentro de d\xEDas espec\xEDficos.",
  "provisioningProfiles.apply.confirmType3": "Aplicar el perfil directamente.",
  "provisioningProfiles.apply.forcingImplementationDate": "Fecha de Implementaci\xF3n Forzada",
  "provisioningProfiles.apply.selectTime": "seleccionar tiempo",
  "provisioningProfiles.apply.warning": "Advertencia",
  "provisioningProfiles.apply.profileName": "Nombre del Perfil*",
  "provisioningProfiles.apply.appliedStores": "Tiendas Aplicadas*",
  "provisioningProfiles.apply.type": "Tipo",
  "provisioningProfiles.apply.inTextField": "en el campo de texto",
  "provisioningProfiles.apply.apply": "Aplicar",
  "provisioningProfiles.apply.processingSuccess": "Procesando perfiles para aplicaci\xF3n. Esto puede tomar unos minutos.",
  "provisioningProfiles.apply.selectStores": "Seleccionar Tiendas",
  "provisioningProfiles.apply.applyToStores": "Aplicar a Tiendas",
  "provisioningProfiles.apply.success": "Perfil aplicado exitosamente",
  "provisioningProfiles.apply.error": "Error al aplicar perfil",
  "provisioningProfiles.details.pageTitle": "Detalles del Perfil",
  "provisioningProfiles.details.basicInfo": "Informaci\xF3n B\xE1sica",
  "provisioningProfiles.details.categories": "Categor\xEDas",
  "provisioningProfiles.details.products": "Productos",
  "provisioningProfiles.details.themes": "Temas",
  "provisioningProfiles.details.stores": "Tiendas Aplicadas",
  "provisioningProfiles.details.orders": "Pedidos",
  "provisioningProfiles.details.totalSale": "Venta Total",
  "provisioningProfiles.details.updateSuccess": "actualizaci\xF3n exitosa",
  "provisioningProfiles.changeStyle.changeStyle": "Cambiar Estilo",
  "provisioningProfiles.changeStyle.success": "\xC9xito",
  "provisioningProfiles.changeStyle.selectThemeStyle": "Selecciona un estilo de tema para el perfil actual",
  "provisioningProfiles.changeStyle.style": "Estilo",
  "provisioningProfiles.changeStyle.selectStyleName": "Por favor selecciona el nombre del estilo",
  "provisioningProfiles.changeStyle.ok": "OK",
  "provisioningProfiles.changeStyle.setAsCurrentTheme": "Establecer como tema actual",
  "provisioningProfiles.changeStyle.selectedStyle": "Estilo Seleccionado",
  "provisioningProfiles.changeStyle.notice": "Aviso",
  "provisioningProfiles.changeStyle.unexpectedWarning": "\xA1Cosas malas inesperadas suceder\xE1n si no lees esto!",
  "provisioningProfiles.changeStyle.applyThemeWarning": "Aplicar este tema a las tiendas puede afectar fuentes, colores y otras caracter\xEDsticas de la tienda.",
  "provisioningProfiles.changeStyle.themeName": "Nombre del Tema",
  "provisioningProfiles.changeStyle.storesToBeApplied": "Tiendas a aplicar",
  "provisioningProfiles.changeStyle.typeConfirmSentence": "Escribe la siguiente frase para CONFIRMAR*",
  "provisioningProfiles.currentTheme.defaultTheme": "Tema Predeterminado",
  "provisioningProfiles.currentTheme.version": "Versi\xF3n",
  "provisioningProfiles.currentTheme.styles": "Estilos",
  "provisioningProfiles.currentTheme.developedBy": "Desarrollado por",
  "provisioningProfiles.addProducts.addProducts": "Agregar Productos",
  "provisioningProfiles.addProducts.selectProducts": "Seleccionar Productos",
  "provisioningProfiles.addProducts.cancel": "Cancelar",
  "provisioningProfiles.addProducts.save": "Guardar",
  "provisioningProfiles.addProducts.banner": "Banner",
  "provisioningProfiles.addProducts.productName": "Nombre del Producto",
  "provisioningProfiles.addProducts.sku": "SKU",
  "provisioningProfiles.addProducts.productPrice": "Precio del Producto",
  "provisioningProfiles.addProducts.products": "Productos",
  "provisioningProfiles.addProducts.successfullyAdded": "Agregado exitosamente.",
  "provisioningProfiles.removeTheme.remove": "Eliminar",
  "provisioningProfiles.removeTheme.cancel": "Cancelar",
  "provisioningProfiles.removeTheme.themeWillBeRemoved": "Este tema ser\xE1 eliminado del perfil actual.",
  "provisioningProfiles.removeTheme.themeName": "Nombre del Tema",
  "provisioningProfiles.removeTheme.confirm": "Confirmar",
  "provisioningProfiles.removeTheme.confirmRequired": "Por favor escribe la palabra 'CONFIRM'",
  "provisioningProfiles.removeTheme.confirmValidator": "Por favor escribe la palabra 'CONFIRM'",
  "provisioningProfiles.removeTheme.confirmPlaceholder": "Por favor escribe la palabra 'CONFIRM'",
  "provisioningProfiles.removeTheme.removeAppliedTheme": "Eliminar tema aplicado",
  "provisioningProfiles.removeTheme.selectedTheme": "Tema Seleccionado",
  "provisioningProfiles.removeTheme.notice": "Aviso",
  "provisioningProfiles.removeTheme.unexpectedWarning": "\xA1Cosas malas inesperadas suceder\xE1n si no lees esto!",
  "provisioningProfiles.removeTheme.removeThemeWarning": "Eliminar este tema aplicado a las tiendas puede afectar fuentes, colores y otras caracter\xEDsticas de la tienda.",
  "provisioningProfiles.removeTheme.iveReadTheseEffects": "He le\xEDdo estos efectos",
  "provisioningProfiles.removeTheme.themeWillBeRemovedFromAllStores": "Este tema ser\xE1 eliminado de todas las tiendas y puede afectar fuentes, colores y otras caracter\xEDsticas de la tienda.",
  "provisioningProfiles.removeTheme.storesToBeApplied": "Tiendas a aplicar",
  "provisioningProfiles.removeTheme.typeConfirmSentence": "Escribe la siguiente frase para CONFIRMAR*",
  "provisioningProfiles.removeTheme.confirmTextTemplate": "Entiendo que APLICAR este tema a las tiendas objetivo puede afectar las actualizaciones futuras de lanzamiento.",
  "provisioningProfiles.themeItemList.themes": "Temas",
  "provisioningProfiles.themeItemList.addThemes": "Agregar Temas",
  "provisioningProfiles.themeItemList.setAsCurrentTheme": "Establecer como tema actual",
  "provisioningProfiles.themeItemList.styles": "estilos",
  "provisioningProfiles.themeItemList.utilization": "Utilizaci\xF3n"
};

// src/locales/es/reports.ts
var reports_default2 = {
  reports_page_title: "Informes",
  reports_store_overview_title: "Resumen de Tienda",
  reports_plan_revenue_title: "Ingresos del Plan",
  reports_plan_revenue_text: "Resumen de tiendas e ingresos",
  reports_latest_plan_changes_title: "\xDAltimos Cambios de Plan",
  reports_latest_plan_changes_text: "Historial y estado de los cambios de plan",
  reports_logs_title: "Registros",
  reports_portal_logs_title: "Registros del Portal",
  reports_portal_logs_text: "Mostrar actividad hist\xF3rica del usuario",
  reports_store_logs_title: "Registros de Tienda",
  reports_store_logs_text: "Mostrar registro de auditor\xEDa de actividad de tienda",
  reports_orders_title: "Pedidos",
  reports_orders_revenue_title: "Ingresos de Pedidos",
  reports_orders_revenue_text: "Datos de pedidos asociados con tiendas",
  reports_promotion_utilization_title: "Utilizaci\xF3n de Promociones",
  reports_promotion_utilization_text: "Datos asociados con tiendas",
  reports_system_logs_title: "Registros del Sistema",
  reports_plan_revenue_page_title: "Ingresos del Plan",
  reports_plan_revenue_order_number: "N\xFAmero de Pedido",
  reports_plan_revenue_store_hash: "Hash de Tienda",
  reports_plan_revenue_store_id: "ID de Tienda",
  reports_plan_revenue_store_name: "Nombre de Tienda",
  reports_plan_revenue_net: "Neto",
  reports_plan_revenue_gross: "Bruto",
  reports_plan_revenue_plan_code: "C\xF3digo de Plan",
  reports_plan_revenue_date: "Fecha",
  reports_plan_revenue_status: "Estado",
  reports_plan_revenue_view_details: "Ver Detalles",
  reports_plan_revenue_more: "M\xE1s",
  reports_plan_revenue_account_info: "Informaci\xF3n de Cuenta",
  reports_plan_revenue_store_info: "Informaci\xF3n de Tienda",
  reports_plan_revenue_total_order_count: "(total de pedidos)",
  reports_plan_revenue_total_order_amount: "(monto total de pedidos)",
  reports_plan_revenue_search_placeholder: "buscar",
  reports_plan_revenue_export: "Exportar",
  reports_plan_revenue_filter: "Filtrar",
  reports_plan_revenue_equals: " (igual)",
  reports_plan_revenue_clear: "Limpiar",
  reports_plan_revenue_apply: "Aplicar",
  reports_portal_logs_page_title: "Registros del portal",
  reports_portal_logs_date: "Fecha",
  reports_portal_logs_user: "Usuario",
  reports_portal_logs_ip: "IP",
  reports_portal_logs_module: "M\xF3dulo",
  reports_portal_logs_details: "Detalles",
  reports_portal_logs_search_placeholder: "buscar",
  reports_portal_logs_export: "Exportar",
  reports_portal_logs_filter: "Filtrar",
  reports_portal_logs_user_label: "Usuario",
  reports_portal_logs_module_label: "M\xF3dulo",
  reports_portal_logs_ip_label: "Ip",
  reports_portal_logs_date_label: "Fecha",
  reports_portal_logs_details_label: "Detalles",
  reports_portal_logs_contains: " (contiene)",
  reports_portal_logs_equals: " (igual)",
  reports_portal_logs_clear: "Limpiar",
  reports_portal_logs_apply: "Aplicar",
  reports_portal_logs_ip_validation: "Por favor, introduzca n\xFAmeros y puntos en el campo de texto.",
  reports_latest_plan_changes_page_title: "\xDAltimos Cambios de Plan",
  reports_latest_plan_changes_company: "Empresa",
  reports_latest_plan_changes_store_name: "Nombre de Tienda",
  reports_latest_plan_changes_account_id: "ID de Cuenta",
  reports_latest_plan_changes_current_type: "Tipo Actual",
  reports_latest_plan_changes_previous_type: "Tipo Anterior",
  reports_latest_plan_changes_effective_date: "Fecha Efectiva",
  reports_latest_plan_changes_amount: "Monto",
  reports_latest_plan_changes_status: "Estado",
  reports_latest_plan_changes_last_modified: "\xDAltima Modificaci\xF3n",
  reports_latest_plan_changes_created_on: "Creado en",
  reports_latest_plan_changes_modified_by: "Modificado por",
  reports_latest_plan_changes_status_available: "Disponible",
  reports_latest_plan_changes_status_using: "En Uso",
  reports_latest_plan_changes_status_suspended: "Suspendido",
  reports_latest_plan_changes_status_cancelled: "Cancelado",
  reports_latest_plan_changes_search_placeholder: "buscar",
  reports_latest_plan_changes_export: "Exportar",
  reports_latest_plan_changes_filter: "Filtrar",
  reports_latest_plan_changes_company_label: "Empresa",
  reports_latest_plan_changes_store_name_label: "Nombre de Tienda",
  reports_latest_plan_changes_account_id_label: "ID de Cuenta",
  reports_latest_plan_changes_current_type_label: "Tipo Actual",
  reports_latest_plan_changes_amount_label: "Monto",
  reports_latest_plan_changes_status_label: "Estado",
  reports_latest_plan_changes_last_modified_label: "\xDAltima Modificaci\xF3n",
  reports_latest_plan_changes_contains: " (contiene)",
  reports_latest_plan_changes_equals: " (igual)",
  reports_latest_plan_changes_clear: "Limpiar",
  reports_latest_plan_changes_apply: "Aplicar",
  reports_store_logs_page_title: "Registros de tienda",
  reports_store_logs_store_id: "ID de Tienda",
  reports_store_logs_store_name: "Nombre de Tienda",
  reports_store_logs_type: "Tipo",
  reports_store_logs_module: "M\xF3dulo",
  reports_store_logs_severity: "Severidad",
  reports_store_logs_summary: "Resumen",
  reports_store_logs_created_time: "Hora de Creaci\xF3n",
  reports_store_logs_message: "Mensaje",
  reports_store_logs_search_placeholder: "buscar",
  reports_store_logs_export: "Exportar",
  reports_store_logs_filter: "Filtrar",
  reports_store_logs_type_label: "Tipo",
  reports_store_logs_severity_label: "Severidad",
  reports_store_logs_module_label: "M\xF3dulo",
  reports_store_logs_summary_label: "Resumen",
  reports_store_logs_store_name_label: "Nombre de Tienda",
  reports_store_logs_store_id_label: "ID de Tienda",
  reports_store_logs_created_date_label: "Fecha de Creaci\xF3n",
  reports_store_logs_clear: "Limpiar",
  reports_store_logs_apply: "Aplicar",
  reports_store_logs_store_id_validation: "Por favor, introduce un n\xFAmero en el campo de texto.",
  reports_store_logs_show_details: "mostrar detalles",
  reports_store_logs_message_title: "Mensaje",
  reports_store_logs_ok: "OK",
  reports_promotion_utilization_page_title: "Utilizaci\xF3n de Promociones",
  reports_promotion_utilization_stores: "Tiendas",
  reports_promotion_utilization_customers: "Clientes",
  reports_promotion_utilization_campaigns: "Campa\xF1as",
  reports_promotion_utilization_period: "Per\xEDodo",
  reports_promotion_utilization_search_placeholder: "Buscar",
  reports_promotion_utilization_clear: "Limpiar",
  reports_promotion_utilization_apply: "Aplicar",
  reports_promotion_utilization_total_revenue: "Ingresos Totales",
  reports_promotion_utilization_from: "desde",
  reports_promotion_utilization_stores_title: "Tiendas",
  reports_promotion_utilization_store_name: "Nombre de Tienda",
  reports_promotion_utilization_store_hash: "Hash de Tienda",
  reports_promotion_utilization_promotion_name: "Nombre de Promoci\xF3n",
  reports_promotion_utilization_coupon: "Cup\xF3n",
  reports_promotion_utilization_usage: "Uso",
  reports_promotion_utilization_chart_title: "Utilizaci\xF3n de Promociones",
  reports_order_revenue_page_title: "Ingresos de Pedidos",
  reports_order_revenue_period: "Per\xEDodo",
  reports_order_revenue_search_placeholder: "Buscar",
  reports_order_revenue_clear: "Limpiar",
  reports_order_revenue_apply: "Aplicar",
  reports_order_revenue_store_hash: "Hash de Tienda:",
  reports_order_revenue_account_id: "ID de Cuenta:",
  reports_order_revenue_total_revenue: "Ingresos Totales",
  reports_order_revenue_from: "desde",
  reports_order_revenue_orders_title: "Pedidos",
  reports_order_revenue_order_id: "ID de Pedido",
  reports_order_revenue_date: "Fecha",
  reports_order_revenue_source: "Fuente",
  reports_order_revenue_subtotal: "Subtotal",
  reports_order_revenue_line_item_discounts: "Descuentos de art\xEDculo",
  reports_order_revenue_shipping: "Env\xEDo",
  reports_order_revenue_tax: "Impuesto",
  reports_order_revenue_total: "Total",
  reports_order_revenue_chart_title: "Ingresos de Pedidos",
  reports_order_revenue_chart_unit: "unidad: $",
  reports_order_revenue_gross: "Bruto",
  reports_system_logs_page_title: "Registros del Sistema",
  reports_all_stores: "Todas las Tiendas",
  reports_dont_have_permission: "No tienes permisos.",
  reports_export: "Exportar",
  reports_search: "Buscar",
  reports_refresh: "Actualizar",
  reports_back: "Atr\xE1s"
};

// src/locales/es/resetPassword.ts
var resetPassword_default2 = {
  resetPassword_page_title: "Restablecer contrase\xF1a",
  resetPassword_form_submit_button: "Restablecer contrase\xF1a",
  resetPassword_form_have_account: "\xBFYa tienes una cuenta?",
  resetPassword_form_have_login: "Iniciar sesi\xF3n",
  resetPassword_password_validation_error: "La contrase\xF1a debe contener al menos una letra may\xFAscula, una letra min\xFAscula, un n\xFAmero y un car\xE1cter especial, y su longitud debe estar entre 8 y 12 caracteres",
  resetPassword_reset_success: "Contrase\xF1a restablecida con \xE9xito",
  resetPassword_reset_failed: "Error al restablecer la contrase\xF1a",
  resetPassword_password_not_match: "Por favor, aseg\xFArate de que las dos contrase\xF1as coincidan",
  resetPassword_new_password_label: "Nueva contrase\xF1a",
  resetPassword_new_password_placeholder: "Por favor ingresa tu nueva contrase\xF1a.",
  resetPassword_confirm_password_label: "Confirmar nueva contrase\xF1a",
  resetPassword_confirm_password_required: "El campo Confirmar contrase\xF1a es obligatorio.",
  resetPassword_confirm_password_placeholder: "Por favor confirma tu nueva contrase\xF1a.",
  resetPassword_password_at_most: "La contrase\xF1a debe tener como m\xE1ximo 12 caracteres",
  resetPassword_password_at_least: "La contrase\xF1a debe tener al menos 8 caracteres",
  resetPassword_password_requirements: "Requisitos de la contrase\xF1a:",
  resetPassword_password_length: "Longitud: 8-12 caracteres",
  resetPassword_password_uppercase: "Al menos una letra may\xFAscula",
  resetPassword_password_lowercase: "Al menos una letra min\xFAscula",
  resetPassword_password_number: "Al menos un n\xFAmero",
  resetPassword_password_special: "Al menos un car\xE1cter especial"
};

// src/locales/es/settings.ts
var settings_default2 = {
  "settings.pageTitle": "Configuraci\xF3n",
  "settings.noPermission": "No tiene permisos.",
  "settings.home.userAdministration": "Administraci\xF3n de Usuarios",
  "settings.home.plan": "Plan",
  "settings.home.scheduleManagement": "Gesti\xF3n de Programaci\xF3n",
  "settings.home.storeSetting": "Configuraci\xF3n de Tienda",
  "settings.home.smsConfiguration": "Configuraci\xF3n SMS",
  "settings.home.mailConfiguration": "Configuraci\xF3n de Correo",
  "settings.portalUser.pageTitle": "Gesti\xF3n de Usuarios del Portal",
  "settings.portalUser.addUser": "Agregar Usuario",
  "settings.portalUser.editUser": "Editar Usuario",
  "settings.portalUser.addNewUser": "Agregar un nuevo usuario",
  "settings.portalUser.deleteUser": "Eliminar Usuario",
  "settings.portalUser.export": "Exportar",
  "settings.portalUser.filter": "Filtrar",
  "settings.portalUser.clear": "Limpiar",
  "settings.portalUser.apply": "Aplicar",
  "settings.portalUser.action": "Acci\xF3n",
  "settings.portalUser.edit": "Editar",
  "settings.portalUser.delete": "Eliminar",
  "settings.portalUser.table.email": "Correo Electr\xF3nico",
  "settings.portalUser.table.lastLogin": "\xDAltimo Inicio de Sesi\xF3n",
  "settings.portalUser.table.name": "Nombre",
  "settings.portalUser.table.group": "Grupo",
  "settings.portalUser.table.status": "Estado",
  "settings.group.messages.adminGroup": "El grupo de administrador no puede ser editado/agregado .",
  "settings.portalUser.filter.email": "Correo Electr\xF3nico",
  "settings.portalUser.filter.emailContains": " (contiene)",
  "settings.portalUser.filter.phone": "Tel\xE9fono",
  "settings.portalUser.filter.phoneEquals": " (igual)",
  "settings.portalUser.filter.lastLogin": "\xDAltimo Inicio de Sesi\xF3n",
  "settings.portalUser.filter.lastLoginEquals": " (igual)",
  "settings.portalUser.filter.name": "Nombre",
  "settings.portalUser.filter.nameContains": " (contiene)",
  "settings.portalUser.filter.group": "Grupo",
  "settings.portalUser.filter.groupContains": " (contiene)",
  "settings.portalUser.filter.status": "Estado",
  "settings.portalUser.filter.statusEquals": " (igual)",
  "settings.portalUser.filter.valid": "V\xE1lido",
  "settings.portalUser.filter.disabled": "Deshabilitado",
  "settings.portalUser.form.email": "Correo Electr\xF3nico (ID de Inicio de Sesi\xF3n)",
  "settings.portalUser.form.emailPlaceholder": "Por favor ingrese el correo electr\xF3nico.",
  "settings.portalUser.form.firstName": "Nombre",
  "settings.portalUser.form.firstNamePlaceholder": "Por favor ingrese el nombre.",
  "settings.portalUser.form.firstNameRequired": "El nombre es un campo obligatorio.",
  "settings.portalUser.form.lastName": "Apellido",
  "settings.portalUser.form.lastNamePlaceholder": "Por favor ingrese el apellido.",
  "settings.portalUser.form.lastNameRequired": "El apellido es un campo obligatorio.",
  "settings.portalUser.form.group": "Grupo",
  "settings.portalUser.form.groupPlaceholder": "Por favor seleccione el grupo.",
  "settings.portalUser.form.selectShopifyAccounts": "Seleccionar cuentas de Shopify",
  "settings.portalUser.form.selectShopifyAccountsPlaceholder": "Por favor seleccione las cuentas de Shopify",
  "settings.portalUser.form.selectBigcommerceAccounts": "Seleccionar cuentas de BigCommerce",
  "settings.portalUser.form.selectBigcommerceAccountsPlaceholder": "Por favor seleccione las cuentas de BigCommerce",
  "settings.portalUser.delete.title": "Deshabilitar un Usuario causar\xE1 que todos los mensajes asociados sean eliminados y es irreversible.",
  "settings.portalUser.delete.userEmail": "Correo Electr\xF3nico del Usuario",
  "settings.portalUser.delete.userEmailPlaceholder": "Por favor escriba el correo electr\xF3nico",
  "settings.portalUser.delete.confirm": "Confirmar",
  "settings.portalUser.delete.confirmPlaceholder": "Por favor escriba la palabra 'CONFIRMAR'",
  "settings.portalUser.delete.confirmRequired": "Por favor escriba la palabra 'CONFIRMAR'",
  "settings.portalUser.delete.confirmValidator": "Por favor escriba la palabra 'CONFIRMAR'",
  "settings.portalUser.delete.enterCorrectEmail": "Por favor ingrese el correo electr\xF3nico correcto",
  "settings.portalUser.delete.cancel": "Cancelar",
  "settings.portalUser.delete.delete": "Eliminar",
  "settings.portalUser.delete.success": "Usuario eliminado exitosamente",
  "settings.portalUser.messages.createSuccess": "Usuario creado exitosamente",
  "settings.portalUser.messages.editSuccess": "Usuario editado exitosamente",
  "settings.portalUser.messages.userAlreadyExists": "El usuario ya existe.",
  "settings.portalUser.messages.userGroupDisable": "Deshabilitar grupo de usuario.",
  "settings.portalUser.messages.failedToChangeUserStatus": "Error al cambiar el estado del usuario. Por favor intente nuevamente m\xE1s tarde.",
  "settings.portalUser.messages.invalidGroups": "Grupos inv\xE1lidos.",
  "settings.portalUser.messages.userNotFound": "Usuario para {id} no encontrado.",
  "settings.portalUser.messages.failedToRemoveUser": "Error al eliminar usuario {id}.",
  "settings.plan.pageTitle": "Gesti\xF3n de Planes",
  "settings.plan.addPlan": "Agregar Plan",
  "settings.plan.editPlan": "Editar Plan",
  "settings.plan.deletePlan": "Eliminar Plan",
  "settings.plan.export": "Exportar",
  "settings.plan.filter": "Filtrar",
  "settings.plan.clear": "Limpiar",
  "settings.plan.apply": "Aplicar",
  "settings.plan.table.name": "Plan",
  "settings.plan.table.code": "C\xF3digo",
  "settings.plan.table.sku": "SKU",
  "settings.plan.table.description": "Descripci\xF3n",
  "settings.plan.table.price": "Precio",
  "settings.plan.table.franchisePrice": "Precio de Franquicia",
  "settings.plan.table.status": "Estado",
  "settings.plan.action": "Acci\xF3n",
  "settings.plan.form.name": "Nombre del Plan",
  "settings.plan.form.namePlaceholder": "Por favor ingrese el nombre del plan.",
  "settings.plan.form.price": "Precio",
  "settings.plan.form.pricePlaceholder": "Por favor ingrese el precio.",
  "settings.plan.form.duration": "Duraci\xF3n",
  "settings.plan.form.durationPlaceholder": "Por favor seleccione la duraci\xF3n.",
  "settings.plan.form.description": "Descripci\xF3n",
  "settings.plan.form.descriptionPlaceholder": "Por favor ingrese la descripci\xF3n.",
  "settings.group.pageTitle": "Gesti\xF3n de Grupos",
  "settings.group.add": "Agregar",
  "settings.group.addTitle": "Agregar un nuevo grupo",
  "settings.group.save": "Guardar",
  "settings.group.addGroup": "Agregar Grupo",
  "settings.group.editGroup": "Editar Grupo",
  "settings.group.deleteGroup": "Eliminar Grupo",
  "settings.group.export": "Exportar",
  "settings.group.filter": "Filtrar",
  "settings.group.clear": "Limpiar",
  "settings.group.apply": "Aplicar",
  "settings.group.messages.addSuccess": "Grupo agregado exitosamente",
  "settings.group.messages.deleteSuccess": "Grupo eliminado exitosamente",
  "settings.group.messages.editSuccess": "Grupo editado exitosamente",
  "settings.group.action": "Acci\xF3n",
  "settings.group.editTitle": "Editar grupo",
  "settings.group.deleteModal.header": "Deshabilitar un Grupo causar\xE1 que todas las configuraciones asociadas sean eliminadas y es irreversible.",
  "settings.group.deleteModal.cancel": "Cancelar",
  "settings.group.deleteModal.delete": "Eliminar",
  "settings.group.deleteModal.groupName": "Nombre del Grupo",
  "settings.group.deleteModal.groupNameRequired": "El nombre del grupo es requerido",
  "settings.group.deleteModal.groupNamePlaceholder": "Por favor escriba el nombre del grupo",
  "settings.group.deleteModal.confirm": "Confirmar",
  "settings.group.deleteModal.confirmRequired": "Por favor escriba la palabra 'CONFIRM'",
  "settings.group.deleteModal.confirmPlaceholder": "Por favor escriba la palabra 'CONFIRM'",
  "settings.group.table.name": "Nombre",
  "settings.group.table.description": "Descripci\xF3n",
  "settings.group.table.memberCount": "Cantidad de Miembros",
  "settings.group.table.status": "Estado",
  "settings.group.table.action": "Acci\xF3n",
  "settings.group.table.activeAccount": "Cuenta Activa",
  "settings.group.edit": "Editar",
  "settings.group.delete": "Eliminar",
  "settings.group.form.name": "Nombre del Grupo",
  "settings.group.form.namePlaceholder": "Por favor ingrese el nombre del grupo.",
  "settings.group.form.description": "Descripci\xF3n",
  "settings.group.form.descriptionPlaceholder": "Por favor ingrese la descripci\xF3n.",
  "settings.group.form.permissions": "Permisos",
  "settings.group.form.permissionsPlaceholder": "Por favor seleccione los permisos.",
  "settings.group.form.users": "Usuarios",
  "settings.mailTemplate.pageTitle": "Gesti\xF3n de Plantillas de Correo",
  "settings.mailTemplate.addTemplate": "Agregar Plantilla",
  "settings.mailTemplate.editTemplate": "Editar Plantilla",
  "settings.mailTemplate.deleteTemplate": "Eliminar Plantilla",
  "settings.mailTemplate.export": "Exportar",
  "settings.mailTemplate.filter": "Filtrar",
  "settings.mailTemplate.clear": "Limpiar",
  "settings.mailTemplate.apply": "Aplicar",
  "settings.mailTemplate.table.name": "Nombre",
  "settings.mailTemplate.table.subject": "Asunto",
  "settings.mailTemplate.table.type": "Tipo",
  "settings.mailTemplate.table.status": "Estado",
  "settings.mailTemplate.table.action": "Acci\xF3n",
  "settings.mailTemplate.form.module": "M\xF3dulo",
  "settings.mailTemplate.form.topic": "Tema",
  "settings.mailTemplate.form.text": "Texto",
  "settings.mailTemplate.form.name": "Nombre de la Plantilla",
  "settings.mailTemplate.form.namePlaceholder": "Por favor ingrese el nombre de la plantilla.",
  "settings.mailTemplate.form.subject": "Asunto",
  "settings.mailTemplate.form.subjectPlaceholder": "Por favor ingrese el asunto.",
  "settings.mailTemplate.form.content": "Contenido",
  "settings.mailTemplate.form.contentPlaceholder": "Por favor ingrese el contenido.",
  "settings.mailTemplate.form.type": "Tipo",
  "settings.mailTemplate.form.typePlaceholder": "Por favor seleccione el tipo.",
  "settings.smtp.pageTitle": "Configuraci\xF3n SMTP",
  "settings.smtp.save": "Guardar",
  "settings.smtp.test": "Probar Conexi\xF3n",
  "settings.smtp.reset": "Restablecer",
  "settings.smtp.form.host": "Host SMTP",
  "settings.smtp.form.hostPlaceholder": "Por favor ingrese el host SMTP.",
  "settings.smtp.form.port": "Puerto SMTP",
  "settings.smtp.form.portPlaceholder": "Por favor ingrese el puerto SMTP.",
  "settings.smtp.form.username": "Nombre de Usuario",
  "settings.smtp.form.usernamePlaceholder": "Por favor ingrese el nombre de usuario.",
  "settings.smtp.form.password": "Contrase\xF1a",
  "settings.smtp.form.passwordPlaceholder": "Por favor ingrese la contrase\xF1a.",
  "settings.smtp.form.encryption": "Cifrado",
  "settings.smtp.form.encryptionPlaceholder": "Por favor seleccione el tipo de cifrado.",
  "settings.smtp.form.useSSL": "Usar SSL",
  "settings.smtp.form.senderName": "Nombre del Remitente",
  "settings.smtp.form.optional": "(opcional)",
  "settings.smsGateway.pageTitle": "Configuraci\xF3n de Gateway SMS",
  "settings.smsGateway.save": "Guardar",
  "settings.smsGateway.test": "Probar Conexi\xF3n",
  "settings.smsGateway.reset": "Restablecer",
  "settings.smsGateway.form.provider": "Proveedor SMS",
  "settings.smsGateway.form.providerPlaceholder": "Por favor seleccione el proveedor SMS.",
  "settings.smsGateway.form.apiKey": "Clave API",
  "settings.smsGateway.form.apiKeyPlaceholder": "Por favor ingrese la clave API.",
  "settings.smsGateway.form.apiSecret": "Secreto API",
  "settings.smsGateway.form.apiSecretPlaceholder": "Por favor ingrese el secreto API.",
  "settings.smsGateway.form.fromNumber": "N\xFAmero de Origen",
  "settings.smsGateway.form.fromNumberPlaceholder": "Por favor ingrese el n\xFAmero de origen.",
  "settings.smsTemplate.pageTitle": "Gesti\xF3n de Plantillas SMS",
  "settings.smsTemplate.addTemplate": "Agregar Plantilla",
  "settings.smsTemplate.editTemplate": "Editar Plantilla",
  "settings.smsTemplate.deleteTemplate": "Eliminar Plantilla",
  "settings.smsTemplate.export": "Exportar",
  "settings.smsTemplate.filter": "Filtrar",
  "settings.smsTemplate.clear": "Limpiar",
  "settings.smsTemplate.apply": "Aplicar",
  "settings.smsTemplate.table.name": "Nombre",
  "settings.smsTemplate.table.content": "Contenido",
  "settings.smsTemplate.table.type": "Tipo",
  "settings.smsTemplate.table.status": "Estado",
  "settings.smsTemplate.table.action": "Acci\xF3n",
  "settings.smsTemplate.form.name": "Nombre de la Plantilla",
  "settings.smsTemplate.form.namePlaceholder": "Por favor ingrese el nombre de la plantilla.",
  "settings.smsTemplate.form.content": "Contenido",
  "settings.smsTemplate.form.contentPlaceholder": "Por favor ingrese el contenido.",
  "settings.smsTemplate.form.type": "Tipo",
  "settings.smsTemplate.form.typePlaceholder": "Por favor seleccione el tipo.",
  "settings.masterStore.pageTitle": "Gestionar Tienda Maestra",
  "settings.masterStore.messages.noPermission": "No tiene permisos para establecer la tienda maestra.",
  "settings.masterStore.messages.updateSuccess": "Actualizado exitosamente.",
  "settings.masterStore.modal.warning": "Establecer la tienda maestra puede afectar el cat\xE1logo, promociones, temas y otras funciones de todas las tiendas objetivo.",
  "settings.masterStore.modal.notice": "Aviso",
  "settings.masterStore.modal.noticeText": "\xA1Suceder\xE1n cosas malas inesperadas si no lees esto!",
  "settings.masterStore.modal.step1Button": "Estoy seguro de establecer la tienda maestra",
  "settings.masterStore.modal.step2Button": "He le\xEDdo estos efectos",
  "settings.masterStore.modal.confirmTitle": "Escribe la siguiente frase para CONFIRMAR *",
  "settings.masterStore.modal.confirmText": "Entiendo que ESTABLECER LA TIENDA MAESTRA puede afectar las actualizaciones futuras de lanzamiento.",
  "settings.masterStore.modal.cancel": "Cancelar",
  "settings.masterStore.modal.set": "Establecer",
  "settings.masterStore.selectTitle": "Selecciona una tienda existente",
  "settings.masterStore.selectDescription": "Por favor selecciona una tienda existente.",
  "settings.masterStore.clear": "Limpiar",
  "settings.masterStore.setButton": "Establecer Tienda Maestra",
  "settings.masterStore.form.storeName": "Nombre de la Tienda",
  "settings.masterStore.form.placeholder": "Por favor selecciona una tienda maestra",
  "settings.masterStore.form.label": "Selecciona una maestra",
  "settings.masterStore.table.name": "Nombre de la Tienda",
  "settings.masterStore.table.platform": "Plataforma",
  "settings.masterStore.table.url": "URL",
  "settings.masterStore.table.status": "Estado",
  "settings.masterStore.table.action": "Acci\xF3n",
  "settings.masterStore.form.name": "Nombre de la Tienda",
  "settings.masterStore.form.namePlaceholder": "Por favor ingrese el nombre de la tienda.",
  "settings.masterStore.form.platform": "Plataforma",
  "settings.masterStore.form.platformPlaceholder": "Por favor seleccione la plataforma.",
  "settings.masterStore.form.url": "URL de la Tienda",
  "settings.masterStore.form.urlPlaceholder": "Por favor ingrese la URL de la tienda.",
  "settings.masterStore.form.apiKey": "Clave API",
  "settings.masterStore.form.apiKeyPlaceholder": "Por favor ingrese la clave API.",
  "settings.apiToken.pageTitle": "Token API de Franquicia",
  "settings.apiToken.messages.noPermission": "No tiene permisos.",
  "settings.apiToken.messages.updateSuccess": "Actualizaci\xF3n exitosa",
  "settings.apiToken.form.franchiseId": "ID de Franquicia",
  "settings.apiToken.form.franchiseIdRequired": "El ID de Franquicia es obligatorio.",
  "settings.apiToken.form.clientId": "ID de Cliente",
  "settings.apiToken.form.clientIdRequired": "El ID de Cliente es obligatorio.",
  "settings.apiToken.form.clientSecret": "Secreto de Cliente",
  "settings.apiToken.form.clientSecretRequired": "El Secreto de Cliente es obligatorio.",
  "settings.apiToken.form.country": "Pa\xEDs",
  "settings.apiToken.form.countryRequired": "El pa\xEDs es obligatorio.",
  "settings.apiToken.form.countryUS": "EE.UU.",
  "settings.apiToken.form.region": "Regi\xF3n",
  "settings.apiToken.form.regionRequired": "La regi\xF3n es obligatoria.",
  "settings.apiToken.form.regionUS": "EE.UU.",
  "settings.apiToken.form.regionEU": "UE",
  "settings.apiToken.form.regionAU": "AU",
  "settings.apiToken.generateToken": "Generar Token",
  "settings.apiToken.revokeToken": "Revocar Token",
  "settings.apiToken.export": "Exportar",
  "settings.apiToken.filter": "Filtrar",
  "settings.apiToken.clear": "Limpiar",
  "settings.apiToken.apply": "Aplicar",
  "settings.apiToken.table.token": "Token",
  "settings.apiToken.table.name": "Nombre",
  "settings.apiToken.table.createdAt": "Creado En",
  "settings.apiToken.table.expiresAt": "Expira En",
  "settings.apiToken.table.status": "Estado",
  "settings.apiToken.table.action": "Acci\xF3n",
  "settings.apiToken.form.name": "Nombre del Token",
  "settings.apiToken.form.namePlaceholder": "Por favor ingrese el nombre del token.",
  "settings.apiToken.form.expiresAt": "Expira En",
  "settings.apiToken.form.expiresAtPlaceholder": "Por favor seleccione la fecha de expiraci\xF3n.",
  "settings.apiToken.form.permissions": "Permisos",
  "settings.apiToken.form.permissionsPlaceholder": "Por favor seleccione los permisos.",
  "settings.automation.pageTitle": "Gesti\xF3n de Notificaciones Automatizadas",
  "settings.automation.addNotification": "Agregar Notificaci\xF3n",
  "settings.automation.editNotification": "Editar Notificaci\xF3n",
  "settings.automation.deleteNotification": "Eliminar Notificaci\xF3n",
  "settings.automation.export": "Exportar",
  "settings.automation.filter": "Filtrar",
  "settings.automation.clear": "Limpiar",
  "settings.automation.apply": "Aplicar",
  "settings.automation.table.name": "Nombre",
  "settings.automation.table.type": "Tipo",
  "settings.automation.table.trigger": "Disparador",
  "settings.automation.table.status": "Estado",
  "settings.automation.table.action": "Acci\xF3n",
  "settings.automation.form.name": "Nombre de la Notificaci\xF3n",
  "settings.automation.form.namePlaceholder": "Por favor ingrese el nombre de la notificaci\xF3n.",
  "settings.automation.form.type": "Tipo",
  "settings.automation.form.typePlaceholder": "Por favor seleccione el tipo de notificaci\xF3n.",
  "settings.automation.form.trigger": "Disparador",
  "settings.automation.form.triggerPlaceholder": "Por favor seleccione la condici\xF3n del disparador.",
  "settings.automation.form.recipients": "Destinatarios",
  "settings.automation.form.recipientsPlaceholder": "Por favor ingrese los destinatarios.",
  "settings.automation.emailTitle": "Enviar correo electr\xF3nico a los clientes cuando:",
  "settings.automation.smsTitle": "Enviar SMS a los clientes cuando:",
  "settings.automation.createUsers": "Crear Usuarios",
  "settings.automation.resetPassword": "Restablecer Contrase\xF1a",
  "settings.automation.createStores": "Crear Tiendas",
  "settings.automation.changePlans": "Cambiar Planes",
  "settings.automation.supportRequest": "Solicitud de Soporte",
  "settings.automation.ticketUpdates": "Actualizaciones de Ticket",
  "settings.automation.createUsersEmailText": "Se enviar\xE1 un correo electr\xF3nico al nuevo usuario con un enlace para activar la cuenta.",
  "settings.automation.resetPasswordEmailText": "Se enviar\xE1 un correo electr\xF3nico al usuario con un enlace para restablecer la contrase\xF1a.",
  "settings.automation.createStoresEmailText": "Se enviar\xE1 un correo electr\xF3nico al Contacto Principal con confirmaci\xF3n.",
  "settings.automation.createStoresEmailText2": "BigCommerce tambi\xE9n enviar\xE1 un correo electr\xF3nico.",
  "settings.automation.changePlansEmailText": "Se enviar\xE1 un correo electr\xF3nico al cliente cuando se actualicen los planes.",
  "settings.automation.supportRequestEmailText": "Se enviar\xE1 un correo electr\xF3nico al cliente con una solicitud enviada.",
  "settings.automation.ticketUpdatesEmailText": "Se enviar\xE1 un correo electr\xF3nico al cliente cuando se actualicen los tickets.",
  "settings.automation.createUsersSMSText": "Se enviar\xE1 un SMS al nuevo usuario con un enlace para activar la cuenta.",
  "settings.automation.resetPasswordSMSText": "Se enviar\xE1 un SMS al usuario con un enlace para restablecer la contrase\xF1a.",
  "settings.automation.createStoresSMSText": "Se enviar\xE1 un SMS al Contacto Principal con confirmaci\xF3n.",
  "settings.automation.createStoresSMSText2": "BigCommerce tambi\xE9n enviar\xE1 un SMS.",
  "settings.automation.changePlansSMSText": "Se enviar\xE1 un SMS al cliente cuando se actualicen los planes.",
  "settings.automation.supportRequestSMSText": "Se enviar\xE1 un SMS al cliente con una solicitud enviada.",
  "settings.automation.ticketUpdatesSMSText": "Se enviar\xE1 un SMS al cliente cuando se actualicen los tickets.",
  "settings.automation.save": "Guardar",
  "settings.automation.messages.updateSuccess": "Actualizaci\xF3n exitosa",
  "settings.automation.messages.noPermission": "No tiene permisos.",
  "settings.status.active": "Activo",
  "settings.status.inactive": "Inactivo",
  "settings.status.enabled": "Habilitado",
  "settings.status.disabled": "Deshabilitado",
  "settings.status.valid": "V\xE1lido",
  "settings.status.expired": "Expirado",
  "settings.action.view": "Ver",
  "settings.action.edit": "Editar",
  "settings.action.delete": "Eliminar",
  "settings.action.save": "Guardar",
  "settings.action.cancel": "Cancelar",
  "settings.action.confirm": "Confirmar",
  "settings.action.back": "Atr\xE1s",
  "settings.messages.createSuccess": "Creado exitosamente.",
  "settings.messages.updateSuccess": "Actualizado exitosamente.",
  "settings.messages.deleteSuccess": "Eliminado exitosamente.",
  "settings.messages.createFailed": "Error al crear: {error}",
  "settings.messages.updateFailed": "Error al actualizar: {error}",
  "settings.messages.deleteFailed": "Error al eliminar: {error}",
  "settings.messages.noPermission": "No tiene permisos.",
  "settings.form.required": "Este campo es obligatorio.",
  "settings.form.invalidEmail": "Por favor ingrese una direcci\xF3n de correo v\xE1lida.",
  "settings.form.invalidPhone": "Por favor ingrese un n\xFAmero de tel\xE9fono v\xE1lido.",
  "settings.form.invalidUrl": "Por favor ingrese una URL v\xE1lida.",
  "settings.form.invalidNumber": "Por favor ingrese un n\xFAmero v\xE1lido.",
  "settings.form.minLength": "Se requieren m\xEDnimo {min} caracteres.",
  "settings.form.maxLength": "Se permiten m\xE1ximo {max} caracteres.",
  "settings.form.confirmPassword": "Las contrase\xF1as no coinciden.",
  "settings.form.uniqueName": "Este nombre ya existe.",
  "settings.form.uniqueEmail": "Este correo ya existe.",
  "settings.home.portalUserManagement": "Gesti\xF3n de Usuarios del Portal",
  "settings.home.groupManagement": "Gesti\xF3n de Grupos",
  "settings.home.planManagement": "Gesti\xF3n de Planes",
  "settings.home.automationNotification": "Notificaci\xF3n Automatizada",
  "settings.home.apiFranchiseToken": "Token de API de Franquicia",
  "settings.home.manageMasterStore": "Gestionar Tienda Principal",
  "settings.home.catalogSetting": "Configuraci\xF3n de Cat\xE1logo",
  "settings.home.smsGatewayConfig": "Configuraci\xF3n de Gateway SMS",
  "settings.home.smsTemplate": "Plantilla SMS",
  "settings.home.smtpSetting": "Configuraci\xF3n SMTP",
  "settings.home.mailTemplate": "Plantilla de Correo",
  "settings.catalogSetting.pageTitle": "Configuraci\xF3n de Cat\xE1logo",
  "settings.catalogSetting.save": "Guardar",
  "settings.catalogSetting.messages.updateSuccess": "Actualizado exitosamente.",
  "settings.catalogSetting.automaticallyPullProducts": "Sincronizar Autom\xE1ticamente Productos desde la Tienda Principal",
  "settings.catalogSetting.automaticallyPullProductsDescription": "Active esta opci\xF3n si desea sincronizar autom\xE1ticamente los productos desde la Tienda Principal cuando se crean nuevos productos. Si esta funci\xF3n est\xE1 desactivada, no se sincronizar\xE1n autom\xE1ticamente productos desde la Tienda Principal al Hub Comercial Distribuidor.",
  "settings.messages.confirmDelete": "\xBFEst\xE1 seguro de que desea eliminar este elemento?",
  "settings.messages.confirmDeleteDescription": "Esta acci\xF3n no se puede deshacer."
};

// src/locales/es/stores.ts
var stores_default2 = {
  stores_list_page_title: "Gesti\xF3n de tiendas",
  stores_list_column_store_id: "ID de tienda",
  stores_list_column_store_hash: "Hash de tienda",
  stores_list_column_store_name: "Nombre de tienda",
  stores_list_column_plan: "Plan",
  stores_list_column_expire_time: "Fecha de expiraci\xF3n",
  stores_list_column_status: "Estado",
  stores_list_column_company: "Empresa",
  stores_list_column_account: "Cuenta",
  stores_list_column_provisioning_profile: "Perfil de aprovisionamiento",
  stores_list_column_live_store: "Tienda en vivo",
  stores_list_column_action: "Acci\xF3n",
  stores_destroy_modal_title: "Eliminar una tienda conectada eliminar\xE1 permanentemente todos los pedidos asociados en Distributed Commerce Hub.",
  stores_destroy_form_store_id_label: "ID de tienda",
  stores_destroy_form_store_id_placeholder: "Escribe el ID de la tienda",
  stores_destroy_form_store_id_required: "El ID es obligatorio",
  stores_destroy_form_confirm_label: "Confirmar",
  stores_destroy_form_confirm_placeholder: "Escribe la palabra 'CONFIRMAR'",
  stores_destroy_form_confirm_required: "Escribe la palabra 'CONFIRMAR'",
  stores_destroy_success: "Tienda eliminada exitosamente",
  stores_new_order_drawer_title: "Cambiar plan",
  stores_new_order_form_store_id_label: "ID de tienda",
  stores_new_order_form_store_id_required: "El ID es obligatorio",
  stores_new_order_form_store_name_label: "Nombre de tienda",
  stores_new_order_form_store_name_required: "El nombre de la tienda es obligatorio",
  stores_new_order_form_cur_plan_label: "Seleccionar plan",
  stores_new_order_form_cur_plan_required: "El plan es obligatorio",
  stores_new_order_form_effective_label: "Efectivo desde",
  stores_new_order_form_effective_required: "La fecha efectiva es obligatoria",
  stores_new_order_form_effective_option_immediately: "Inmediatamente",
  stores_new_order_form_effective_option_next_billing: "Pr\xF3ximo ciclo de facturaci\xF3n",
  stores_new_order_success: "Actualizaci\xF3n exitosa",
  stores_new_store_open_button: "Crear una tienda",
  stores_new_store_type_drawer_title: "Seleccionar tipo de tienda",
  stores_new_store_type_new_button: "Crear nueva tienda",
  stores_new_store_type_existing_button: "Conectar tienda existente",
  stores_new_store_add_drawer_title: "Agregar una nueva tienda",
  stores_new_store_add_submit_button: "Guardar",
  stores_new_store_connect_drawer_title: "Conectar tienda existente",
  stores_new_store_connect_submit_button: "Conectar",
  stores_new_store_field_account_label: "Cuenta",
  stores_new_store_field_account_required: "La cuenta es obligatoria",
  stores_new_store_field_name_label: "Nombre de tienda",
  stores_new_store_field_name_required: "El nombre de la tienda es obligatorio",
  stores_new_store_field_plan_label: "Plan",
  stores_new_store_field_plan_required: "El plan es obligatorio",
  stores_new_store_field_company_label: "Empresa",
  stores_new_store_field_desc_label: "Descripci\xF3n",
  stores_new_store_field_profile_label: "Perfil de aprovisionamiento",
  stores_new_store_field_store_hash_label: "Hash de tienda",
  stores_new_store_field_store_hash_required: "El hash de la tienda es obligatorio",
  stores_new_store_field_client_id_label: "ID de cliente",
  stores_new_store_field_client_id_required: "El ID de cliente es obligatorio",
  stores_new_store_field_client_secret_label: "Secreto de cliente",
  stores_new_store_field_client_secret_required: "El secreto de cliente es obligatorio",
  stores_new_store_field_access_token_label: "Token de acceso",
  stores_new_store_field_access_token_required: "El token de acceso es obligatorio",
  stores_new_store_add_success: "Tienda agregada exitosamente",
  stores_new_store_connect_success: "Tienda conectada exitosamente",
  stores_shopify_create_button: "Conectar tienda existente",
  stores_shopify_create_modal_header_method: "Conectar tienda de Shopify",
  stores_shopify_create_modal_header_manual: "Conectar tienda existente",
  stores_shopify_create_modal_header_auth: "Autorizaci\xF3n de tienda Shopify",
  stores_shopify_create_method_tip: "Elige c\xF3mo deseas conectar tu tienda de Shopify a CommercialHub.",
  stores_shopify_create_manual_title: "Conexi\xF3n manual",
  stores_shopify_create_manual_desc: "Ingresa tus credenciales manualmente",
  stores_shopify_create_auth_title: "Autorizaci\xF3n con un clic",
  stores_shopify_create_auth_desc: "Autorizar a trav\xE9s de la app de Shopify",
  stores_shopify_create_form_submit: "Conectar",
  stores_shopify_create_form_back: "Atr\xE1s",
  stores_shopify_create_field_store_url_label: "URL de la tienda",
  stores_shopify_create_field_store_url_required: "La URL de la tienda es obligatoria",
  stores_shopify_create_field_client_id_label: "Clave API",
  stores_shopify_create_field_client_id_required: "La clave API es obligatoria",
  stores_shopify_create_field_client_secret_label: "Clave secreta API",
  stores_shopify_create_field_client_secret_required: "La clave secreta API es obligatoria",
  stores_shopify_create_field_access_token_label: "Token de acceso de la API de administrador",
  stores_shopify_create_field_access_token_required: "El token de acceso de la API de administrador es obligatorio",
  stores_shopify_create_auth_tip: "Para conectar tu tienda de Shopify, debes autorizar a CommercialHub a acceder a los datos de tu tienda.",
  stores_shopify_create_auth_submit: "Ir a autorizar",
  stores_shopify_create_success: "Tienda conectada exitosamente",
  stores_action_search_placeholder: "buscar",
  stores_action_export_button: "Exportar",
  stores_action_filter_button: "Filtrar",
  stores_action_store_id_label: "ID de tienda",
  stores_action_store_id_sublabel: "(igual a)",
  stores_action_plan_label: "Plan",
  stores_action_plan_sublabel: "(igual a)",
  stores_action_store_hash_label: "Hash de tienda",
  stores_action_store_hash_sublabel: "(igual a)",
  stores_action_account_name_label: "Cuenta",
  stores_action_account_name_sublabel: "(contiene)",
  stores_action_status_label: "Estado",
  stores_action_status_sublabel: "(igual a)",
  stores_action_exp_date_label: "Fecha de expiraci\xF3n",
  stores_action_exp_date_sublabel: "(igual a)",
  stores_management_action_change_plan: "Cambiar plan",
  stores_management_action_suspend: "Suspender",
  stores_management_action_cancel: "Cancelar",
  stores_suspend_modal_title: "Suspender una tienda har\xE1 que todos los pedidos asociados sean suspendidos.",
  stores_suspend_modal_action_confirm: "Suspender",
  stores_suspend_form_label_store_id: "ID de tienda",
  stores_suspend_form_placeholder_store_id: "Escribe el ID de la tienda",
  stores_suspend_form_label_confirm: "Confirmar",
  stores_suspend_form_placeholder_confirm: "Escribe la palabra 'CONFIRMAR'",
  stores_suspend_form_validation_store_id_required: "El ID de la tienda es obligatorio",
  stores_suspend_form_validation_confirm_required: "Escribe la palabra 'CONFIRMAR'",
  stores_suspend_form_validation_confirm_match: "Escribe la palabra 'CONFIRMAR'",
  stores_suspend_success: "Tienda suspendida exitosamente",
  stores_info_page_title: "Ver informaci\xF3n de la tienda",
  stores_info_store_id: "ID de tienda",
  stores_info_store_hash: "Hash de tienda",
  stores_info_billing_cycle: "Ciclo de facturaci\xF3n",
  stores_info_expire_date: "Fecha de expiraci\xF3n",
  stores_info_status: "Estado",
  stores_info_account_info_title: "Informaci\xF3n de la cuenta",
  stores_info_account_name: "Nombre de cuenta",
  stores_info_email: "Correo electr\xF3nico",
  stores_info_company: "Empresa",
  stores_info_phone: "Tel\xE9fono",
  stores_info_address: "Direcci\xF3n",
  stores_info_country: "Pa\xEDs",
  stores_info_city: "Ciudad"
};

// src/locales/es/theme.ts
var theme_default2 = {
  theme_list_page_title: "Temas",
  theme_list_set_default: "Establecer como predeterminado",
  theme_list_upload: "Subir temas",
  theme_list_apply_store: "Aplicar un tema a la tienda",
  theme_list_default_title: "Tema predeterminado",
  theme_list_default_name: "Nombre del tema",
  theme_list_default_style: "Estilo",
  theme_list_loading_failure: "Error al cargar",
  theme_list_set_default_success: "Tema predeterminado establecido con \xE9xito.",
  theme_list_set_default_no_permission: "No tienes permiso para cambiar el tema predeterminado.",
  theme_list_set_default_title_shopify: "Selecciona un estilo de tema predeterminado para nuevas tiendas",
  theme_list_set_default_title_other: "\xBFEst\xE1s seguro?",
  theme_list_set_default_style_placeholder: "Por favor selecciona el nombre del estilo",
  theme_list_set_default_description: "Este tema se aplicar\xE1 a las nuevas tiendas.",
  theme_list_filter_search_placeholder: "buscar",
  theme_list_filter_expand: "Expandir",
  theme_list_filter_clear: "Limpiar",
  theme_list_filter_apply: "Aplicar",
  theme_list_filter_equals: " (igual a)",
  theme_list_filter_contains: " (contiene)",
  theme_list_filter_theme_name: "Nombre del tema",
  theme_list_filter_upload_date: "Fecha de subida",
  theme_list_filter_utilization: "Utilizaci\xF3n",
  theme_list_table_loading_failure: "Error al cargar",
  theme_list_table_utilization: "Utilizaci\xF3n",
  theme_list_table_styles: "estilos",
  theme_list_table_style: "estilo",
  theme_list_table_download: "Descargar tema",
  theme_list_table_remove: "Eliminar tema",
  theme_remove_success: "Tema eliminado correctamente",
  theme_remove_failed: "Error al eliminar el tema",
  theme_remove_confirm_title: "Eliminar tema",
  theme_remove_confirm_message: "\xBFEst\xE1 seguro de que desea eliminar este tema? Esta acci\xF3n no se puede deshacer.",
  theme_download_success: "Tema descargado correctamente",
  theme_download_failed: "Error al descargar el tema",
  theme_upload_file_size_error: "El tama\xF1o del archivo debe ser menor de 10MB.",
  theme_upload_no_permission: "No tienes permiso para subir el tema.",
  theme_upload_success: "Subido con \xE9xito. Por favor revisa tu correo y volver\xE1s a la p\xE1gina anterior en tres segundos.",
  theme_upload_zip_required: "Por favor sube un archivo ZIP del tema.",
  theme_upload_picture_label: "Imagen del tema",
  theme_upload_page_title: "Subir tema",
  theme_upload_zip_title: "Subir ZIP",
  theme_upload_notice_header: "Aviso",
  theme_upload_notice_text: "No proporcionamos asistencia t\xE9cnica para tu tema personalizado, ni ayudamos con funcionalidades personalizadas a\xF1adidas.",
  theme_upload_description: "Puedes subir tu tema personalizado como un archivo ZIP abajo.",
  theme_upload_cancel_text: "Cancelar",
  theme_upload_save_text: "Guardar",
  theme_apply_no_permission: "No tienes permiso para aplicar el tema.",
  theme_apply_success: "Aplicado con \xE9xito. Volver\xE1s a la p\xE1gina anterior en tres segundos.",
  theme_apply_page_title: "Confirmar aplicaci\xF3n del tema",
  theme_apply_select_stores_title: "Seleccionar tiendas",
  theme_apply_select_stores_desc: "Recomendamos enviar un correo electr\xF3nico de confirmaci\xF3n antes de aplicar el tema a las tiendas.",
  theme_apply_store_placeholder: "Seleccionar tienda",
  theme_apply_store_label: "Seleccionar tienda",
  theme_apply_select_style: "Seleccionar un estilo",
  theme_apply_loading_failure: "Error al cargar",
  theme_apply_now_title: "\xBFAplicar ahora?",
  theme_apply_email_confirm: "Enviar un correo electr\xF3nico de confirmaci\xF3n al propietario de la tienda para autorizar la aplicaci\xF3n del tema.",
  theme_apply_mandatory_date: "Establece una fecha de implementaci\xF3n obligatoria y env\xEDa un correo electr\xF3nico de confirmaci\xF3n al propietario de la tienda. Si no acepta, el tema se aplicar\xE1 dentro de unos d\xEDas.",
  theme_apply_force_date: "Fecha de implementaci\xF3n forzada",
  theme_apply_direct: "Aplicar el tema directamente.",
  theme_apply_cancel: "Cancelar",
  theme_apply_save: "Guardar",
  theme_apply_modal_title_1: "Aplicar este tema a las tiendas puede afectar fuentes, colores y escaparate. Enviaremos un correo de confirmaci\xF3n al propietario de la tienda.",
  theme_apply_modal_title_2: "Aplicar este tema a las tiendas puede afectar fuentes, colores y escaparate. Enviaremos un correo de confirmaci\xF3n al propietario de la tienda. Si no acepta, el tema se aplicar\xE1 dentro de unos d\xEDas.",
  theme_apply_modal_title_3: "Aplicar este tema a las tiendas puede afectar fuentes, colores y escaparate.",
  theme_apply_modal_cancel: "Cancelar",
  theme_apply_modal_ok: "Aceptar",
  theme_apply_modal_theme_name: "Nombre del tema",
  theme_apply_modal_selected_stores: "Tiendas seleccionadas",
  theme_apply_modal_type: "Tipo",
  theme_apply_modal_confirm_text: "*CONFIRMAR* en el campo de texto"
};

// src/locales/es/translation.ts
var translation_default2 = {
  ...common_default2,
  ...orders_default2,
  ...packages_default2,
  ...resetPassword_default2,
  ...settings_default2,
  ...theme_default2,
  ...promotion_default2,
  ...layout_default2,
  ...login_default2,
  ...forgotPassword_default2,
  ...product_default2,
  ...stores_default2,
  ...account_default2,
  ...dashboard_default2,
  ...content_default2,
  ...customerProfile_default2,
  ...reports_default2,
  ...onboarding_default2,
  ...provisioningProfiles_default2
};

// src/locales/fr/account.ts
var account_default3 = {
  account_management_page_title: "Comptes",
  account_management_account_action: "Action",
  account_management_account_id: "ID du compte",
  account_management_first_name: "Pr\xE9nom",
  account_management_last_name: "Nom de famille",
  account_management_email: "E-mail",
  account_management_phone: "T\xE9l\xE9phone",
  account_management_company: "Entreprise",
  account_management_revenue: "Revenus",
  account_management_status: "Statut",
  account_management_store_list_button: "Liste des magasins",
  account_actionbar_import_step1: "\xC9tape 1 - T\xE9l\xE9charger le mod\xE8le d'importation de comptes",
  account_actionbar_import_download_link: "t\xE9l\xE9charger le mod\xE8le",
  account_actionbar_import_step2: "\xC9tape 2 - Importer les comptes en CSV",
  account_action_bar_add: "Ajouter",
  account_action_bar_search_placeholder: "rechercher",
  account_action_bar_import: "Importer",
  account_action_bar_export: "Exporter",
  account_action_bar_filter: "Filtrer",
  account_action_bar_account_id: "ID du compte",
  account_action_bar_account_id_sub: " (\xE9gal)",
  account_action_bar_first_name: "Pr\xE9nom",
  account_action_bar_first_name_sub: " (contient)",
  account_action_bar_last_name: "Nom de famille",
  account_action_bar_last_name_sub: " (contient)",
  account_action_bar_email: "E-mail",
  account_action_bar_email_sub: " (contient)",
  account_action_bar_phone: "T\xE9l\xE9phone",
  account_action_bar_phone_sub: " (\xE9gal)",
  account_action_bar_company: "Entreprise",
  account_action_bar_company_sub: " (contient)",
  account_action_bar_revenue: "Revenus",
  account_action_bar_revenue_sub: " (\xE9gal)",
  account_info_page_title: "Informations du compte",
  account_info_primary_contact: "Contact principal",
  account_info_billing_contact: "Contact de facturation",
  account_info_account_name: "Nom du compte",
  account_info_status: "Statut",
  account_info_email: "E-mail",
  account_info_company: "Entreprise",
  account_info_phone: "T\xE9l\xE9phone",
  account_info_address1: "Adresse 1",
  account_info_address2: "Adresse 2",
  account_info_country: "Pays",
  account_info_city: "Ville",
  account_info_revenue: "Revenus",
  account_info_country_us: "\xC9tats-Unis",
  account_info_theme_list_title: "Liste des th\xE8mes",
  account_info_theme_list_image_alt: "\xC9chec du chargement",
  account_infomation_title: "Informations du magasin",
  account_infomation_column_store_id: "ID du magasin",
  account_infomation_column_store_hash: "Hash du magasin",
  account_infomation_column_store_name: "Nom du magasin",
  account_infomation_column_plan: "Plan",
  account_infomation_column_expire_date: "Date d'expiration",
  account_infomation_column_status: "Statut",
  account_logo_title_modal_header: "Avis :",
  account_logo_title_modal_text: "Apr\xE8s vous \xEAtre connect\xE9, veuillez actualiser la page et vous reconnecter pour continuer.",
  account_logo_title_modal_login_btn: "aller \xE0 la connexion",
  account_logo_title_form_title: "Logo et titre",
  account_logo_title_form_account_title: "Titre du compte",
  account_logo_title_form_account_logo: "Logo du compte",
  account_logo_title_error_upload_image: "Veuillez t\xE9l\xE9charger le fichier image",
  account_management_action_view_detail: "Voir les d\xE9tails",
  account_management_action_new_store: "Nouveau magasin",
  account_management_action_edit: "Modifier",
  account_management_action_edit_status: "Modifier le statut",
  account_management_action_delete: "Supprimer",
  account_management_action_cancel_store: "Annuler le magasin",
  account_management_action_delete_connect: "Supprimer la connexion",
  account_add_page_title: "Ajouter un nouveau compte",
  account_add_save: "Sauvegarder",
  account_add_add_success: "Compte ajout\xE9 avec succ\xE8s",
  account_add_primary_contact: "Contact principal",
  account_add_first_name: "Pr\xE9nom",
  account_add_last_name: "Nom de famille",
  account_add_email: "E-mail",
  account_add_company: "Entreprise",
  account_add_address_line1: "Adresse (ligne 1)",
  account_add_phone_number: "Num\xE9ro de t\xE9l\xE9phone",
  account_add_address_line2: "Adresse (ligne 2)",
  account_add_revenue: "Revenus",
  account_add_country: "Pays",
  account_add_state: "\xC9tat/Province",
  account_add_city: "Ville",
  account_add_zip: "Code postal",
  account_add_same_as_primary: "Remplir le m\xEAme contenu que le contact principal.",
  account_add_create_store: "Cr\xE9er un magasin",
  account_add_store_title: "Cr\xE9er un nouveau magasin",
  account_add_store_name: "Nom du magasin",
  account_add_plan: "Plan",
  account_add_description: "Description",
  account_add_provisioning_profile: "Profil de provisionnement",
  account_add_billing_contact: "Contact de facturation",
  account_add_invalid_email: "Veuillez entrer votre adresse e-mail.",
  account_cancel_store_modal_title: "L'annulation d'un magasin entra\xEEnera la suppression de toutes les commandes associ\xE9es et est irr\xE9versible",
  account_cancel_store_destroyed_success: "Suppression r\xE9ussie.",
  account_cancel_store_store_id: "ID du magasin",
  account_cancel_store_store_id_required: "L'ID du magasin est requis",
  account_cancel_store_store_id_placeholder: "Veuillez saisir l'ID du magasin",
  account_cancel_store_confirm: "Confirmer",
  account_cancel_store_confirm_required: "Veuillez taper le mot 'CONFIRM'",
  account_cancel_store_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  account_disable_modal_title: "La d\xE9sactivation d'un compte entra\xEEnera la suppression de tous les magasins associ\xE9s et est irr\xE9versible",
  account_disable_cancel: "Annuler",
  account_disable_delete: "Supprimer",
  account_disable_success: "Compte supprim\xE9 avec succ\xE8s",
  account_disable_account_id: "ID du compte",
  account_disable_account_id_required: "L'ID du compte est requis",
  account_disable_account_id_placeholder: "Veuillez saisir l'ID du compte",
  account_disable_confirm: "Confirmer",
  account_disable_confirm_required: "Veuillez taper le mot 'CONFIRM'",
  account_disable_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  account_edit_page_title: "Modifier le compte",
  account_edit_primary_contact: "Contact principal",
  account_edit_billing_contact: "Contact de facturation",
  account_edit_first_name: "Pr\xE9nom",
  account_edit_last_name: "Nom de famille",
  account_edit_email: "E-mail",
  account_edit_email_invalid: "Veuillez entrer une adresse e-mail valide.",
  account_edit_company: "Entreprise",
  account_edit_address_line1: "Adresse (ligne 1)",
  account_edit_address_line2: "Adresse (ligne 2)",
  account_edit_phone: "Num\xE9ro de t\xE9l\xE9phone",
  account_edit_country: "Pays",
  account_edit_state: "\xC9tat/Province",
  account_edit_city: "Ville",
  account_edit_zip: "Code postal",
  account_edit_revenue: "Revenus",
  account_edit_save: "Sauvegarder",
  account_edit_success: "Compte mis \xE0 jour avec succ\xE8s.",
  account_edit_status_title: "D\xE9finir le statut du compte",
  account_edit_status_cancel: "Annuler",
  account_edit_status_save: "Sauvegarder",
  account_edit_status_success: "Statut modifi\xE9 avec succ\xE8s",
  account_edit_status_account_id: "ID du compte",
  account_edit_status_account_id_required: "L'ID du compte est requis",
  account_edit_status_account_id_placeholder: "Veuillez saisir l'ID du compte",
  account_edit_status_select_label: "S\xE9lectionner le statut du compte",
  account_edit_status_active: "Actif",
  account_edit_status_unless: "Inactif",
  account_new_store_add_new_store: "Ajouter un nouveau magasin",
  account_new_store_store_name: "Nom du magasin",
  account_new_store_store_name_required: "Le nom du magasin est requis",
  account_new_store_plan: "Plan",
  account_new_store_plan_required: "Le plan est requis",
  account_new_store_company: "Entreprise",
  account_new_store_description: "Description",
  account_new_store_provisioning_profile: "Profil de provisionnement",
  account_new_store_add_store_success: "Magasin ajout\xE9 avec succ\xE8s"
};

// src/locales/fr/common.ts
var common_default3 = {
  common_filter_clear: "Effacer",
  common_filter_apply: "Appliquer",
  common_filter_filter: "Filtrer",
  common_filter_expand: "D\xE9velopper",
  common_btn_text_ok: "OK",
  common_btn_text_cancel: "Annuler",
  common_btn_text_apply: "Appliquer",
  common_btn_text_save: "Sauvegarder",
  common_btn_text_add: "Ajouter",
  common_btn_text_remove: "Supprimer",
  common_btn_text_delete: "Supprimer",
  common_permission_denied: "Vous n'avez pas la permission.",
  common_message_success: "Succ\xE8s !",
  common_enabled: "Activ\xE9",
  common_disabled: "D\xE9sactiv\xE9",
  common_loadingFailure: "\xC9chec du chargement"
};

// src/locales/fr/content.ts
var content_default3 = {
  content_page_action: "Action",
  content_page_id: "ID de contenu",
  content_page_name: "Nom",
  content_page_content_type: "Type de contenu",
  content_page_store: "Boutique",
  content_page_updated: "Mis \xE0 jour",
  content_page_last_updated_by: "Derni\xE8re mise \xE0 jour par",
  content_page_status: "Statut",
  content_page_title: "Contenu",
  content_page_current_status: "Statut actuel",
  content_page_action_edit: "Modifier",
  content_page_action_duplicate: "Dupliquer",
  content_page_action_archive: "Archiver",
  content_page_action_delete: "Supprimer",
  content_page_store_description: "S\xE9lectionnez la boutique",
  content_page_action_create_content: "Cr\xE9er du contenu",
  content_edit_tab_editor: "\xC9diteur",
  content_edit_save_button: "Sauvegarder",
  content_edit_page_title: "Cr\xE9er du contenu",
  content_edit_name_required: "Le nom est obligatoire",
  content_edit_type_required: "Le type est obligatoire",
  content_edit_headline_required: "Le titre est obligatoire",
  content_edit_body_required: "Le corps du texte est obligatoire",
  content_edit_create_success: "Contenu cr\xE9\xE9 avec succ\xE8s.",
  content_edit_update_success: "Contenu mis \xE0 jour avec succ\xE8s.",
  content_edit_failed_to_update_locales: "Impossible de mettre \xE0 jour les locales",
  content_edit_max_media_files: "Vous ne pouvez t\xE9l\xE9charger qu'un maximum de 3 fichiers m\xE9dia",
  content_edit_name_label: "Nom",
  content_edit_name_description: "Entrez le nom",
  content_edit_type_label: "Type",
  content_edit_type_description: "S\xE9lectionnez le type",
  content_edit_editor_headline_label: "Titre",
  content_edit_editor_headline_description: "Maximum 256 caract\xE8res",
  content_edit_editor_body_label: "Corps du texte",
  content_page_toggle_approved: "Approuv\xE9",
  content_page_toggle_pending: "En attente",
  content_page_toggle_archived: "Archiv\xE9",
  content_media_list_title: "Fichiers m\xE9dia ({{count}}/3)",
  content_media_list_no_media_files: "Aucun fichier m\xE9dia t\xE9l\xE9charg\xE9",
  content_media_list_media_file: "Fichier m\xE9dia",
  content_file_upload_please_select_file_first: "Veuillez s\xE9lectionner un fichier d'abord",
  content_file_upload_failed_to_upload_file: "Impossible de t\xE9l\xE9charger le fichier",
  content_file_upload_success: "Fichier t\xE9l\xE9charg\xE9 avec succ\xE8s",
  content_file_upload_uploading: "T\xE9l\xE9chargement en cours...",
  content_file_upload_upload_file: "T\xE9l\xE9charger le fichier",
  content_file_upload_upload_media_files: "T\xE9l\xE9charger les fichiers m\xE9dia (Maximum 3 fichiers)",
  content_detail_versions_failed_to_fetch_content_versions: "Impossible de r\xE9cup\xE9rer les versions du contenu",
  content_detail_versions_updated_time: "Temps de mise \xE0 jour",
  content_detail_versions_review_status: "Statut de r\xE9vision",
  content_detail_status_you_do_not_have_permission_to_update_review_status: "Vous n'avez pas les permissions pour mettre \xE0 jour le statut de r\xE9vision",
  content_detail_status_status_updated_successfully: "Statut mis \xE0 jour avec succ\xE8s",
  content_detail_status_failed_to_update_status: "Impossible de mettre \xE0 jour le statut",
  content_detail_status_updating: "Mise \xE0 jour en cours...",
  content_detail_status_change_status: "Changer le statut",
  content_page_last_saved: "Derni\xE8re mise \xE0 jour",
  content_detail_rich_text_editor_loading: "Chargement de l'\xE9diteur...",
  content_detail_locales_failed_to_update_locales: "Impossible de mettre \xE0 jour les locales",
  content_detail_locales_locales_updated_successfully: "Locales mis \xE0 jour avec succ\xE8s",
  content_detail_locales_title: "Locales",
  content_detail_locales_current_locales: "Locales actuelles",
  content_detail_locales_change_locales: "Changer les locales",
  content_edit_only_en_us_allowed: "Le nom doit \xEAtre coh\xE9rent dans tous les locales",
  content_edit_do_not_have_permission_to_update_review_status: "Vous n'avez pas les permissions pour mettre \xE0 jour le statut de r\xE9vision",
  content_filter_content_type: "Type de contenu",
  content_filter_update_date: "Date de mise \xE0 jour",
  content_restore_modal_title: "Restaurer le contenu",
  content_restore_modal_button: "Restaurer",
  content_restore_modal_message: "Restaurer : Confirmer la restauration de ce contenu ? Apr\xE8s la restauration, il sera visible et op\xE9rationnel normalement dans la liste de contenu.",
  content_restore_success: "Contenu restaur\xE9 avec succ\xE8s",
  content_soft_delete_modal_title: "Supprimer le contenu",
  content_soft_delete_modal_button: "Supprimer",
  content_soft_delete_modal_message: "Ce produit sera supprim\xE9 de la liste de contenu. Si vous souhaitez le r\xE9cup\xE9rer, vous pouvez le restaurer dans l'onglet 'Supprim\xE9s'.",
  content_soft_delete_success: "Contenu supprim\xE9 avec succ\xE8s",
  content_action_delete_permanently: "Supprimer d\xE9finitivement",
  content_action_restore: "Restaurer",
  content_action_duplicate_success: "Duplication r\xE9ussie !",
  content_action_archive_success: "Contenu archiv\xE9 avec succ\xE8s",
  content_action_select_store_modal_title: "S\xE9lectionner la boutique \xE0 dupliquer",
  content_action_cancel: "Annuler",
  content_action_confirm: "Confirmer",
  content_action_un_archive: "D\xE9sarchiver"
};

// src/locales/fr/customerProfile.ts
var customerProfile_default3 = {
  customerProfile_customer_management_first_name: "Pr\xE9nom",
  customerProfile_customer_management_last_name: "Nom de famille",
  customerProfile_customer_management_email: "E-mail",
  customerProfile_customer_management_phone: "T\xE9l\xE9phone",
  customerProfile_customer_management_store_name: "Nom du magasin",
  customerProfile_customer_management_created_at: "Cr\xE9\xE9 le",
  customerProfile_customer_profile_details_page_title: "Profil client",
  customerProfile_customer_profile_details_orders_revenue: "Chiffre d'affaires des commandes",
  customerProfile_customer_order_revenue_page_title: "Chiffre d'affaires des commandes (Client)",
  customerProfile_customer_order_revenue_action_bar_period_0: "Aujourd'hui",
  customerProfile_customer_order_revenue_action_bar_period_1: "Hier",
  customerProfile_customer_order_revenue_action_bar_period_2: "7 derniers jours",
  customerProfile_customer_order_revenue_action_bar_period_3: "14 derniers jours",
  customerProfile_customer_order_revenue_action_bar_period_4: "30 derniers jours",
  customerProfile_customer_order_revenue_action_bar_period_5: "90 derniers jours",
  customerProfile_customer_order_revenue_action_bar_period_6: "Ce trimestre",
  customerProfile_customer_order_revenue_action_bar_period_7: "Dernier trimestre",
  customerProfile_customer_order_revenue_action_bar_period_8: "Cette ann\xE9e",
  customerProfile_customer_order_revenue_action_bar_period_9: "L'ann\xE9e derni\xE8re",
  customerProfile_customer_order_revenue_overview_title: "Nom du client",
  customerProfile_customer_order_revenue_chart_title: "Chiffre d'affaires des commandes",
  customerProfile_customer_order_revenue_chart_unit: "Unit\xE9",
  customerProfile_customer_order_revenue_orders_table_title: "Commandes",
  customerProfile_customer_order_revenue_orders_table_order_id: "ID de commande",
  customerProfile_customer_order_revenue_orders_table_date: "Date",
  customerProfile_customer_order_revenue_orders_table_source: "Source",
  customerProfile_customer_order_revenue_orders_table_subtotal: "Sous-total",
  customerProfile_customer_order_revenue_orders_table_line_item_discounts: "Remises sur les articles",
  customerProfile_customer_order_revenue_orders_table_shipping: "Livraison",
  customerProfile_customer_order_revenue_orders_table_tax: "Taxe",
  customerProfile_customer_order_revenue_orders_table_total: "Total",
  customerProfile_customer_information: "Informations Client",
  customerProfile_first_name: "Pr\xE9nom",
  customerProfile_last_name: "Nom de Famille",
  customerProfile_company_name: "Nom de l'Entreprise",
  customerProfile_phone_number: "Num\xE9ro de T\xE9l\xE9phone",
  customerProfile_email: "E-mail",
  customerProfile_address_line_1: "Ligne d'Adresse 1",
  customerProfile_address_line_2: "Ligne d'Adresse 2",
  customerProfile_suburb_city: "Ville",
  customerProfile_state_province: "\xC9tat/Province",
  customerProfile_country: "Pays",
  customerProfile_zip_postcode: "Code Postal",
  customerProfile_store_name: "Nom du Magasin",
  customerProfile_created_at: "Cr\xE9\xE9 Le",
  customerProfile_customer_orders: "Liste de Commandes"
};

// src/locales/fr/dashboard.ts
var dashboard_default3 = {
  dashboard_customers_report_title: "Rapport des clients",
  dashboard_customers_report_view_all: "Voir tous les rapports",
  dashboard_action_bar_all_stores: "Tous les magasins",
  dashboard_action_bar_filter_by_store: "Filtrer par magasin",
  dashboard_action_bar_create_account: "Cr\xE9er un compte",
  dashboard_action_bar_create_store: "Cr\xE9er un magasin",
  dashboard_latest_orders_title: "Derni\xE8res commandes",
  dashboard_latest_orders_view_all: "Voir toutes les commandes",
  dashboard_latest_orders_id: "ID",
  dashboard_latest_orders_platform_order_id: "ID de commande de plateforme",
  dashboard_latest_orders_store_name: "Nom du magasin",
  dashboard_latest_orders_date: "Date",
  dashboard_latest_orders_status: "Statut",
  dashboard_latest_orders_source: "Source",
  dashboard_latest_orders_total: "Total",
  dashboard_newest_accounts_title: "Comptes les plus r\xE9cents",
  dashboard_newest_accounts_view_all: "Voir tous les comptes",
  dashboard_newest_accounts_view_details: "Voir les d\xE9tails",
  dashboard_orders_revenue_title: "Revenus des commandes",
  dashboard_orders_revenue_view_all: "Voir tous les revenus",
  dashboard_orders_revenue_weekly: "Hebdomadaire",
  dashboard_orders_revenue_daily: "Quotidien",
  dashboard_over_view_store_revenue: "Revenus du magasin",
  dashboard_over_view_store_revenue_total: "Revenus totaux du magasin",
  dashboard_over_view_orders: "Commandes",
  dashboard_over_view_orders_total: "Total des commandes",
  dashboard_over_view_items_sold: "Total des articles vendus",
  dashboard_over_view_products_total: "Total des produits vendus",
  dashboard_over_view_order_revenue: "Revenus des commandes",
  dashboard_over_view_order_revenue_total: "Revenus totaux des commandes",
  dashboard_over_view_fulfilled_orders: "Commandes trait\xE9es",
  dashboard_over_view_fulfilled_orders_total: "Total des commandes trait\xE9es",
  dashboard_product_orders_title: "Commandes par produit",
  dashboard_product_orders_view_all: "Voir tous les produits",
  dashboard_promotion_utilization_title: "Utilisation des promotions",
  dashboard_promotion_utilization_view_all: "Voir toutes les promotions",
  dashboard_promotion_utilization_store_name: "Nom du magasin",
  dashboard_promotion_utilization_store_hash: "Hash du magasin",
  dashboard_promotion_utilization_promotion_name: "Nom de la promotion",
  dashboard_promotion_utilization_coupon: "Coupon",
  dashboard_promotion_utilization_usage: "Utilisation"
};

// src/locales/fr/forgotPassword.ts
var forgotPassword_default3 = {
  forgotPassword_page_title: "Mot de passe oubli\xE9",
  forgotPassword_form_submit_button: "R\xE9initialiser le mot de passe",
  forgotPassword_form_account_label: "Compte",
  forgotPassword_form_verify_code_label: "Code de v\xE9rification",
  forgotPassword_form_email_placeholder: "Veuillez saisir votre adresse e-mail.",
  forgotPassword_form_verify_code_placeholder: "Veuillez saisir le code de v\xE9rification.",
  forgotPassword_form_email_validation: "Veuillez saisir votre adresse e-mail.",
  forgotPassword_form_verify_code_required: "Le code de v\xE9rification est un champ obligatoire.",
  forgotPassword_form_have_account: "Vous avez d\xE9j\xE0 un compte ?",
  forgotPassword_form_login: "Se connecter",
  forgotPassword_captcha_loading_failure: "\xC9chec du chargement",
  forgotPassword_success_message: "Le code de v\xE9rification est correct. Veuillez v\xE9rifier votre e-mail."
};

// src/locales/fr/layout.ts
var layout_default3 = {
  layout_route_text_stores: "Magasins",
  layout_route_text_dashboard: "Tableau de bord",
  layout_route_text_account: "Comptes",
  layout_route_text_content: "Contenu",
  layout_route_text_products: "Catalogue",
  layout_route_text_orders: "Commandes",
  layout_route_text_promotions: "Promotions",
  layout_route_text_themes: "Th\xE8mes",
  layout_route_text_onboarding: "Int\xE9gration",
  layout_route_text_provisioning_profiles: "Profils de provisionnement",
  layout_route_text_customer_profiles: "Profils clients",
  layout_route_text_reports: "Rapports",
  layout_route_text_settings: "Param\xE8tres",
  loyout_global_permission_denied: "Permission refus\xE9e !",
  loyout_app_brand_title: "Portail de gestion des concessionnaires CommerceHub",
  loyout_app_platform_bigcommerce: "Plateforme BigCommerce",
  loyout_app_platform_shopify: "Plateforme Shopify",
  loyout_app_logout: "D\xE9connexion",
  loyout_app_menu_copyright: "Copyright \xA9 {{fullYear}} Silk Software Corp. Tous droits r\xE9serv\xE9s"
};

// src/locales/fr/login.ts
var login_default3 = {
  login_page_title: "Se connecter",
  login_form_submit_button: "Se connecter",
  login_form_account_label: "Compte",
  login_form_password_label: "Mot de passe",
  login_form_email_placeholder: "Veuillez saisir votre adresse e-mail.",
  login_form_password_placeholder: "Veuillez saisir votre mot de passe.",
  login_form_email_validation: "Veuillez saisir votre adresse e-mail.",
  login_form_forgot_password: "Mot de passe oubli\xE9 ?",
  login_recaptcha_loading: "reCAPTCHA se charge. Veuillez patienter un moment et r\xE9essayer"
};

// src/locales/fr/onboarding.ts
var onboarding_default3 = {
  onboarding_page_title: "Configuration d'Int\xE9gration",
  onboarding_bounce_rate_title: "Taux de Rebond",
  onboarding_bounce_rate_weekly: "Hebdomadaire",
  onboarding_bounce_rate_daily: "Quotidien",
  onboarding_wizard_title: "Assistant",
  onboarding_wizard_edit_forms: "Modifier les Formulaires",
  onboarding_wizard_save: "Enregistrer",
  onboarding_wizard_success: "Succ\xE8s !",
  onboarding_wizard_error: "Erreur !",
  onboarding_wizard_form_customer_information: "Formulaire d'Informations Client",
  onboarding_wizard_form_products: "Produits",
  onboarding_wizard_form_themes: "Th\xE8mes",
  onboarding_wizard_form_gateway: "Passerelle",
  onboarding_wizard_form_billing: "Facturation",
  onboarding_wizard_form_description: "Description",
  onboarding_wizard_form_description_placeholder: "Veuillez saisir une description...",
  onboarding_wizard_form_description_optional: " (optionnel)",
  onboarding_wizard_form_required_error: "Le champ Formulaire d'Informations Client est obligatoire.",
  onboarding_themes_title: "Th\xE8mes",
  onboarding_themes_add_themes: "Ajouter des Th\xE8mes",
  onboarding_themes_remove: "Supprimer",
  onboarding_themes_no_permission: "Vous n'avez pas la permission.",
  onboarding_themes_success: "Succ\xE8s !",
  onboarding_themes_modal_select_themes: "S\xE9lectionner les Th\xE8mes",
  onboarding_themes_modal_cancel: "Annuler",
  onboarding_themes_modal_save: "Enregistrer",
  onboarding_themes_modal_success: "Succ\xE8s !",
  onboarding_themes_modal_styles: "styles",
  onboarding_themes_modal_utilization: "Utilisation :",
  onboarding_themes_modal_search_placeholder: "Rechercher des th\xE8mes...",
  onboarding_themes_loading_failure: "\xC9chec du chargement",
  onboarding_themes_remove_modal_title: "Le th\xE8me s\xE9lectionn\xE9 sera supprim\xE9 de la configuration d'int\xE9gration.",
  onboarding_themes_remove_modal_cancel: "Annuler",
  onboarding_themes_remove_modal_delete: "Supprimer",
  onboarding_themes_remove_modal_success: "Succ\xE8s !",
  onboarding_themes_remove_modal_error: "\xC9chec de la suppression des styles.",
  onboarding_category_profiles_title: "Profils de Cat\xE9gorie",
  onboarding_category_profiles_add_profile: "Ajouter un Profil",
  onboarding_category_profiles_remove: "Supprimer",
  onboarding_category_profiles_profiles: "Profils",
  onboarding_category_profiles_table_profile_name: "Nom du Profil",
  onboarding_category_profiles_table_utilization: "Utilisation",
  onboarding_category_profiles_table_products: "Produits",
  onboarding_category_profiles_table_created_at: "Cr\xE9\xE9 le",
  onboarding_category_profiles_table_action: "Action",
  onboarding_category_profiles_select_modal_title: "S\xE9lectionner les Profils d'Approvisionnement",
  onboarding_category_profiles_select_modal_cancel: "Annuler",
  onboarding_category_profiles_select_modal_add_profile: "Ajouter un Profil",
  onboarding_category_profiles_select_modal_success: "Succ\xE8s !",
  onboarding_category_profiles_select_modal_no_permission: "Vous n'avez pas la permission.",
  onboarding_category_profiles_select_modal_qty_products: "Quantit\xE9 de Produits",
  onboarding_category_profiles_select_modal_themes: "Th\xE8mes",
  onboarding_category_profiles_select_modal_search_placeholder: "Rechercher des profils..."
};

// src/locales/fr/orders.ts
var orders_default3 = {
  orders_list_page_title: "Gestion des commandes",
  orders_list_filter_export: "Exporter",
  orders_list_filter_dateRange: "Plage de dates",
  orders_list_filter_search: "Rechercher des commandes",
  orders_list_status_ALL: "Tous",
  orders_list_status_PENDING: "En attente",
  orders_list_status_UNFULFILLED: "Non trait\xE9",
  orders_list_status_IN_PROGRESS: "En cours",
  orders_list_status_PARTIALLY_FULFILLED: "Partiellement trait\xE9",
  orders_list_status_FULFILLED: "Trait\xE9",
  orders_list_status_CANCELLED: "Annul\xE9",
  orders_list_platform_ALL: "Toutes les sources",
  orders_list_platform_Shopify: "Shopify",
  orders_list_platform_Bigcommerce: "BigCommerce",
  orders_list_columns_OrderID: "ID de commande",
  orders_list_columns_OrderPlatformOrderID: "ID de commande de plateforme",
  orders_list_columns_OrderName: "Nom de commande",
  orders_list_columns_OrderStore: "Nom du magasin",
  orders_list_columns_OrderDate: "Date",
  orders_list_columns_OrderStatus: "Statut",
  orders_list_columns_OrderPaymentStatus: "Statut de paiement",
  orders_list_columns_OrderSource: "Source",
  orders_list_columns_OrderCustomerName: "Nom du client",
  orders_list_columns_OrderTotal: "Total",
  orders_list_columns_OrderShipping: "Exp\xE9dition de commande",
  order_detail_page_title: "D\xE9tail de la commande",
  order_detail_info_OrderID: "ID de commande",
  order_detail_info_OrderProducts: "Produits",
  order_detail_info_OrderPrice: "Prix",
  order_detail_info_OrderStatus: "Statut",
  order_detail_info_OrderCustomer: "Client",
  order_detail_info_OrderDate: "Date",
  order_detail_info_OrderAddress: "Adresse",
  order_detail_product_name: "Nom du produit",
  order_detail_product_quantity: "Quantit\xE9",
  order_detail_product_totalprice: "Total",
  order_detail_shoppingAddress_firstName: "Pr\xE9nom",
  order_detail_shoppingAddress_lastName: "Nom de famille",
  order_detail_shoppingAddress_email: "E-mail",
  order_detail_shoppingAddress_phone: "T\xE9l\xE9phone",
  order_detail_shoppingAddress_zip: "Code postal",
  order_detail_shoppingAddress_country: "Pays",
  order_detail_shoppingAddress_country_iso2: "Pays_iso2",
  order_detail_shoppingAddress_city: "Ville",
  order_detail_shoppingAddress_state: "\xC9tat/Province",
  order_detail_shoppingAddress_company: "Entreprise",
  order_detail_shoppingAddress_address1: "Rue 1",
  order_export_radio_filtered: "Commandes filtr\xE9es ({{count}} commandes)",
  order_export_radio_all: "Toutes les commandes"
};

// src/locales/fr/packages.ts
var packages_default3 = {
  package_ui_d5Form_required: "{{name}} est un champ obligatoire.",
  package_ui_d5Form_correctFormat: "Veuillez entrer le format correct",
  package_ui_d5Form_maxLength: "{{name}} ne peut pas d\xE9passer {{length}} caract\xE8res",
  package_ui_d5Form_please: "Veuillez ",
  package_ui_d5Form_fileInput_context: "Cliquez ou faites glisser le fichier dans cette zone pour t\xE9l\xE9charger",
  package_ui_d5Export_success: "Exportation r\xE9ussie, nous vous enverrons un e-mail plus tard, veuillez le v\xE9rifier.",
  package_ui_d5Export_title: "\xCAtes-vous s\xFBr ?",
  package_ui_d5Export_btn_cancelText: "Annuler",
  package_ui_d5Export_btn_okText: "OK",
  package_ui_d5Export_context: "L'exportation des donn\xE9es au format CSV peut prendre un certain temps. Une fois l'exportation termin\xE9e, nous vous enverrons un e-mail pour que vous puissiez le t\xE9l\xE9charger.",
  package_ui_d5Export_order_range: "Plage d'exportation des commandes",
  package_ui_d5ImageUpload_alt: "\xC9chec du chargement",
  package_ui_d5ImageUpload_upload: "T\xE9l\xE9charger",
  package_ui_d5Import_success: "Importation r\xE9ussie, nous vous enverrons un e-mail plus tard, veuillez le v\xE9rifier.",
  package_ui_d5Import_btn_cancelText: "Annuler",
  package_ui_d5Import_btn_okText: "Commencer l'importation",
  package_ui_d5Loading_context: "Chargement...",
  package_ui_d5Loading_certification_left: "Copyright \xA9",
  package_ui_d5Loading_certification_right: "Silk Software Corp. Tous droits r\xE9serv\xE9s",
  package_ui_d5Layout_layoutFrame_h2_title: "CommerceHub",
  package_ui_d5Layout_layoutFrame_title: "Portail de gestion des concessionnaires"
};

// src/locales/fr/product.ts
var product_default3 = {
  product_list_page_title: "Gestion des produits",
  product_list_import_template_text_1: "\xC9tape 1 - T\xE9l\xE9charger le mod\xE8le d'importation de catalogue",
  product_list_import_template_text_2: "Nous vous recommandons de",
  product_list_import_template_link_3: "t\xE9l\xE9charger le mod\xE8le",
  product_list_import_template_text_4: "avant d'importer des fichiers et les champs CSV doivent \xEAtre dans l'ordre suivant : URL de l'image, Nom du produit, Prix, Inventaire, SKU, Cat\xE9gories, Description.",
  product_list_import_template_text_5: "\xC9tape 2 - Importer les produits en CSV",
  product_list_action_click_validate: "Clic trop rapide, veuillez r\xE9essayer plus tard.",
  product_list_action_pull_success: "Synchronisation r\xE9ussie.",
  product_list_action_modal_pull_header: "Mettre \xE0 jour les magasins marchands ?",
  product_list_action_export_btn_text: "Exporter",
  product_list_action_push_selected_product: "Pousser les produits s\xE9lectionn\xE9s",
  product_list_action_push_all_product: "Pousser tous les produits",
  product_list_filter_status_enable: "Activer",
  product_list_filter_status_disable: "D\xE9sactiver",
  product_list_filter_label_search: "Rechercher",
  product_list_filter_label_search_placeholder: "rechercher",
  product_list_filter_label_status: "Statut",
  product_list_filter_label_status_placeholder: "S\xE9lectionner le statut",
  product_list_filter_label_category: "Cat\xE9gorie",
  product_list_filter_label_category_placeholder: "Toutes les cat\xE9gories",
  product_list_filter_form_product_name: "Nom du produit",
  product_list_filter_form_product_name_placeholder: "tapez le nom du produit",
  product_list_filter_form_product_sku: "SKU",
  product_list_filter_form_product_sku_placeholder: "tapez le SKU",
  product_list_filter_form_product_price: "Prix",
  product_list_filter_form_product_price_placeholder: " (\xE9gal)",
  product_list_filter_form_product_price_validate: "Veuillez entrer un nombre dans le champ de texte.",
  product_list_filter_form_product_inventory: "Inventaire",
  product_list_filter_form_product_inventory_placeholder: " (\xE9gal)",
  product_list_table_form_product_image: "Image",
  product_list_table_form_product_name: "Nom du produit",
  product_list_table_form_product_price: "Prix du produit",
  product_list_table_form_product_inventory: "Inventaire",
  product_list_table_form_product_sku: "SKU",
  product_list_table_form_product_status: "Statut",
  product_list_table_form_product_action: "Action",
  product_list_table_form_action_remove: "Supprimer",
  product_list_table_form_action_detail: "Voir les d\xE9tails",
  product_list_table_form_action_distributor_visibility: "Visibilit\xE9 du distributeur",
  product_list_table_form_action_delete_permanently: "Supprimer d\xE9finitivement",
  product_list_table_form_action_restore_product: "Restaurer le produit",
  product_list_table_form_product_languages: "Types de langues",
  product_push_page_title: "Pousser les produits",
  product_push_page_description: "Ajouter les produits s\xE9lectionn\xE9s \xE0 des magasins sp\xE9cifiques peut affecter l'historique des commandes, les rapports et potentiellement d'autres donn\xE9es.",
  product_push_page_form_product_name: "Nom du produit",
  product_push_page_form_product_name_validate: "Le nom du produit est requis",
  product_push_page_form_product_name_placeholder: "Tous les produits",
  product_push_page_form_select_store: "S\xE9lectionner un magasin",
  product_push_page_form_target_language: "Langue cible",
  product_push_page_form_target_language_tooltip: "Si la langue de votre magasin ne correspond pas \xE0 la langue cible que vous avez s\xE9lectionn\xE9e, le produit peut \xEAtre pouss\xE9 vers votre magasin en tant que version traduite",
  product_push_page_form_select_store_placeholder: "S\xE9lectionner un magasin",
  product_push_page_form_confirm: "Confirmer",
  product_push_page_form_confirm_validate: "Veuillez taper le mot 'CONFIRM'",
  product_push_page_form_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  product_push_page_message_success: `Poussez le produit avec succ\xE8s.
    S\u2019il vous pla\xEEt v\xE9rifier votre e-mail pour les r\xE9sultats d\xE9taill\xE9s.
    Il reviendra \xE0 la page pr\xE9c\xE9dente dans trois secondes.`,
  product_action_remove_message_success: "Produit supprim\xE9 avec succ\xE8s",
  product_action_remove_text: "Ce produit sera supprim\xE9 de Distributed Commerce Hub, cela n'affectera pas les produits dans vos magasins.",
  product_action_remove_form_product_name: "Nom du produit",
  product_action_remove_form_product_name_placeholder: "Veuillez taper le nom du produit",
  product_action_remove_form_product_name_validate: "Le nom du produit est requis",
  product_action_remove_form_confirm: "SKU",
  product_action_remove_form_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  product_action_remove_form_confirm_validate: "Veuillez taper le mot 'CONFIRM'",
  product_detail_page_title: "D\xE9tail du produit",
  product_detail_page_SKU: "SKU",
  product_detail_page_button_save: "Sauvegarder les modifications",
  product_detail_page_button_delete: "Supprimer",
  product_detail_page_button_edit: "Modifier",
  product_detail_page_button_change_image: "Changer l'image",
  product_detail_page_product_information: "Informations du produit",
  product_detail_page_product_image: "Image du produit",
  product_detail_page_product_no_image: "Aucune image",
  product_detail_page_dimensions_label: "Dimensions",
  product_detail_page_dimensions_label_tip: "Largeur x Hauteur x Profondeur, ex.(2.5 x 2.5 x 6.5)",
  product_detail_page_form_category: "Cat\xE9gorie",
  product_detail_page_form_product_name: "Nom du produit",
  product_detail_page_form_sku: "SKU",
  product_detail_page_form_description: "Description",
  product_detail_page_form_brand: "Marque",
  product_detail_page_form_status: "Statut",
  product_detail_page_form_regular_price: "Prix r\xE9gulier",
  product_detail_page_form_sale_price: "Prix de vente",
  product_detail_page_form_inventory: "Inventaire",
  product_detail_page_form_weight: "Poids",
  product_detail_page_form_dimension: "",
  product_detail_metafields_section: "M\xE9tachamps",
  product_detail_metafields_key: "Cl\xE9",
  product_detail_metafields_type: "Type",
  product_detail_metafields_value: "Valeur",
  product_detail_page_tags_title: "\xC9tiquettes",
  product_detail_page_tags_add_button: "Ajouter une \xE9tiquette",
  product_detail_page_tags_modal_title: "S\xE9lectionner les \xE9tiquettes",
  product_detail_page_tags_modal_close: "Fermer",
  product_detail_page_tags_search_placeholder: "Rechercher par nom d'\xE9tiquette ou cat\xE9gorie...",
  product_detail_page_tags_selected_count: "{{count}} \xE9tiquettes s\xE9lectionn\xE9es",
  product_detail_page_tags_not_found: 'Aucune \xE9tiquette trouv\xE9e correspondant \xE0 "{{search}}"',
  product_detail_page_language_type: "Type de langue",
  product_disabled_distributor_modal_title: "Visibilit\xE9 du distributeur",
  product_disabled_distributor_modal_cancel: "Annuler",
  product_disabled_distributor_modal_save: "Sauvegarder les modifications",
  product_disabled_distributor_button_disable_all: "D\xE9sactiver tout",
  product_disabled_distributor_checkbox_description: "d\xE9sactiver ce produit dans le portail distributeur",
  product_disabled_distributor_update_success: "Visibilit\xE9 du distributeur mise \xE0 jour avec succ\xE8s",
  product_soft_delete_modal_title: "Supprimer le produit",
  product_soft_delete_modal_confirm: "Ce produit sera supprim\xE9 de la liste des produits. Si vous souhaitez le r\xE9cup\xE9rer, vous pouvez le restaurer dans l'onglet 'Supprim\xE9s'.",
  product_restore_modal_title: "Restaurer le produit",
  product_restore_modal_button_restore: "Restaurer",
  product_action_restore_success: "Produit restaur\xE9 avec succ\xE8s",
  product_restore_modal_confirm: "Restaurer : Confirmez-vous la restauration de ce produit ? Apr\xE8s la restauration, il sera visible et exploitable normalement dans la liste des produits.",
  product_list_toggle_products: "Produits",
  product_list_toggle_deletes: "Supprim\xE9",
  product_variants_modal_title: "Modifier les variantes du produit",
  product_variants_modal_cancel: "Annuler",
  product_variants_modal_update: "Mettre \xE0 jour les variantes",
  product_variants_current_variants: "Variantes actuelles",
  product_variants_generated_variants: "Variantes g\xE9n\xE9r\xE9es :",
  product_variants_current_options: "Options actuelles :",
  product_variants_modification_warning: "La modification des variantes remplacera toutes les variantes existantes par la nouvelle configuration. Assurez-vous de configurer toutes les variantes souhait\xE9es avant de sauvegarder.",
  product_variants_options_title: "Options de variantes",
  product_variants_add_option: "Ajouter une option",
  product_variants_option_number: "Option {{number}}",
  product_variants_edit: "Modifier",
  product_variants_option_name: "Nom de l'option",
  product_variants_option_type: "Type d'option",
  product_variants_not_set: "Non d\xE9fini",
  product_variants_values: "Valeurs",
  product_variants_option_name_required: "Nom de l'option *",
  product_variants_option_name_placeholder: "ex., Taille, Couleur, Mat\xE9riau",
  product_variants_option_type_required: "Type d'option*",
  product_variants_option_type_placeholder: "S\xE9lectionner le type d'option",
  product_variants_values_required: "Valeurs *",
  product_variants_value_placeholder: "Entrer la valeur",
  product_variants_colors_label: "Couleurs :",
  product_variants_color_placeholder: "Valeur de couleur (ex., #ff0000)",
  product_variants_add_color: "Ajouter une couleur",
  product_variants_max_colors: "Maximum 3 couleurs autoris\xE9es",
  product_variants_add_first_value: "Ajouter la premi\xE8re valeur",
  product_variants_add_value: "Ajouter une valeur",
  product_variants_cancel: "Annuler",
  product_variants_done: "Termin\xE9",
  product_variants_no_values: "Aucune valeur ajout\xE9e",
  product_variants_summary: "R\xE9sum\xE9",
  product_variants_options_count: "Options :",
  product_variants_total_combinations: "Combinaisons totales :",
  product_variants_bulk_price_title: "D\xE9finir le prix r\xE9gulier pour toutes les variantes :",
  product_variants_price_error: "Le prix doit \xEAtre sup\xE9rieur \xE0 0",
  product_variants_confirm: "Confirmer",
  product_variants_type_swatch: "\xC9chantillon",
  product_variants_type_radio_buttons: "Boutons radio",
  product_variants_type_rectangle_list: "Liste rectangulaire",
  product_variants_type_dropdown: "Menu d\xE9roulant"
};

// src/locales/fr/promotion.ts
var promotion_default3 = {
  promotion_list_tab_automatic: "Automatique",
  promotion_list_tab_coupon: "Coupon",
  promotion_list_automatic_create_promotion: "Cr\xE9er une promotion",
  promotion_list_automatic_push_promotion: "Pousser la promotion",
  promotion_list_automatic_filter_promotion_name: "Nom de la promotion",
  promotion_list_automatic_filter_promotion_name_extra: " (contient)",
  promotion_list_automatic_filter_currency: "Devise",
  promotion_list_automatic_filter_currency_extra: " (contient)",
  promotion_list_automatic_filter_start_date: "D\xE9but",
  promotion_list_automatic_filter_end_date: "Fin",
  promotion_list_automatic_filter_date_extra: " (\xE9gal)",
  promotion_list_automatic_table_columns_promotion_name: "Nom de la promotion",
  promotion_list_automatic_table_columns_currency: "Devise",
  promotion_list_automatic_table_columns_start_date: "D\xE9but",
  promotion_list_automatic_table_columns_end_date: "Fin",
  promotion_list_automatic_table_columns_redemption_type: "Type de promotion",
  promotion_list_coupon_create_promotion: "Cr\xE9er une promotion",
  promotion_list_coupon_push_promotion: "Pousser la promotion",
  promotion_list_coupon_filter_promotion_name: "Nom de la promotion",
  promotion_list_coupon_filter_promotion_name_extra: " (contient)",
  promotion_list_coupon_filter_coupon_code: " Code de coupon",
  promotion_list_coupon_filter_coupon_code_extra: " (contient)",
  promotion_list_coupon_filter_currency: "Devise",
  promotion_list_coupon_filter_currency_extra: " (contient)",
  promotion_list_coupon_filter_start_date: "D\xE9but",
  promotion_list_coupon_filter_end_date: "Fin",
  promotion_list_coupon_filter_date_extra: " (\xE9gal)",
  promotion_list_coupon_table_columns_promotion_name: "Nom de la promotion",
  promotion_list_coupon_table_columns_coupon_code: "Code de coupon",
  promotion_list_coupon_table_columns_currency: "Devise",
  promotion_list_coupon_table_columns_start_date: "D\xE9but",
  promotion_list_coupon_table_columns_end_date: "Fin",
  promotion_list_coupon_table_columns_redemption_type: "Type de promotion",
  promotion_list_table_action_edit: "Modifier",
  promotion_list_table_action_stop: "Arr\xEAter",
  promotion_list_table_action_duplicate: "Dupliquer",
  promotion_list_pull_promotion_btn: "R\xE9cup\xE9rer les promotions du magasin principal",
  promotion_list_pull_promotion_header: "Mettre \xE0 jour les magasins marchands ?",
  promotion_list_stop_promotion_description: "Arr\xEAter la promotion supprimera les remises des magasins.",
  promotion_list_stop_promotion_columns_promotion_name: "Nom de la promotion",
  promotion_list_stop_promotion_columns_promotion_name_required: "Le nom de la promotion est requis",
  promotion_list_stop_promotion_columns_promotion_name_placeholder: "Veuillez saisir le nom de la promotion",
  promotion_list_stop_promotion_columns_confirm: "Confirmer",
  promotion_list_stop_promotion_columns_confirm_required: "Veuillez taper le mot 'CONFIRM'",
  promotion_list_stop_promotion_columns_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  promotion_list_push_promotion_page_title: "Pousser la promotion",
  promotion_list_push_promotion_description: "Ajouter une promotion aux magasins s\xE9lectionn\xE9s peut affecter l'historique des commandes, les rapports et potentiellement d'autres donn\xE9es.",
  promotion_list_push_promotion_submit_error: "Vous n'avez pas la permission de pousser les promotions.",
  promotion_list_push_promotion_submit_success: "Promotion ajout\xE9e avec succ\xE8s. La page pr\xE9c\xE9dente sera restaur\xE9e dans trois secondes.",
  promotion_list_push_promotion_columns_promotion_name: "Nom de la promotion",
  promotion_list_push_promotion_columns_promotion_name_required: "Le nom de la promotion est requis",
  promotion_list_push_promotion_columns_promotion_name_placeholder: "Veuillez saisir le nom de la promotion",
  promotion_list_push_promotion_columns_stores: "Magasins",
  promotion_list_push_promotion_columns_stores_placeholder: "S\xE9lectionner un magasin",
  promotion_list_push_promotion_columns_confirm: "Confirmer",
  promotion_list_push_promotion_columns_confirm_required: "Veuillez taper le mot 'CONFIRM'",
  promotion_list_push_promotion_columns_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  promotion_bc_add_page_title: "Cr\xE9er une promotion",
  promotion_bc_add_active_columns_ctive_now_title_text: "Activer maintenant ?",
  promotion_bc_add_active_columns_is_active_text: "Oui, rendre cette remise disponible aux clients",
  promotion_bc_add_limits_columns_limits_title_text: "Limites d'utilisation",
  promotion_bc_add_limits_columns_limits: "Limiter l'utilisation totale de cette promotion",
  promotion_bc_add_limits_columns_limits_options_no_limit: "Aucune limite pour l'utilisation totale des promotions",
  promotion_bc_add_limits_columns_limits_options_usage_limit: "Limit\xE9e pour l'utilisation totale des promotions",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_header: "Permet d'autres promotions",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_text: "Cette promotion",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_select_used: "peut \xEAtre utilis\xE9e",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_select_not_used: "ne peut pas \xEAtre utilis\xE9e",
  promotion_bc_add_limits_columns_can_be_used_with_other_promotions_other_text: "utiliser avec d'autres promotions.",
  promotion_bc_add_rule_header: "R\xE8gle",
  promotion_bc_add_rule_text: "Quelles conditions un client doit-il satisfaire pour recevoir la remise que vous offrez ?",
  promotion_bc_add_rule_columns_condition: "Condition",
  promotion_bc_add_rule_columns_condition_buy_products_render: "Ach\xE8te {{minimum_quantity}} produits",
  promotion_bc_add_rule_columns_condition_reaches_subtotal_render: "Atteint un sous-total de commande de {{minimum_spend}}",
  promotion_bc_add_rule_columns_condition_order_qty_render: "Le client a pass\xE9 au moins {{minimum_order_count}} commandes",
  promotion_bc_add_rule_columns_condition_no_render: "Aucune condition",
  promotion_bc_add_rule_columns_reward: "R\xE9compense",
  promotion_bc_add_rule_columns_reward_gift_item_render: "Un cadeau dans leur panier",
  promotion_bc_add_rule_columns_reward_free_shipping_render: "Livraison gratuite",
  promotion_bc_add_rule_columns_reward_discount_order_render: "Remise sur le sous-total de la commande",
  promotion_bc_add_rule_columns_reward_discount_products_render: "Remise sur les produits",
  promotion_bc_add_rule_columns_reward_fixed_price_render: "Prix fixe {{fixed_price}} sur les produits",
  promotion_bc_add_search_products_add_button_text: "Cliquez pour ajouter un s\xE9lecteur de produit",
  promotion_bc_add_search_products_error_no_selection: "Il faut ajouter au moins un produit ici.",
  promotion_bc_add_search_products_modal_title: "S\xE9lectionner des produits",
  promotion_bc_add_search_products_table_banner: "Banni\xE8re",
  promotion_bc_add_search_products_table_name: "Nom du produit",
  promotion_bc_add_search_products_table_sku: "SKU",
  promotion_bc_add_search_products_table_price: "Prix du produit",
  promotion_bc_add_search_products_table_image_alt: "\xC9chec du chargement",
  promotion_bc_add_search_products_table_item_name: "Produits",
  promotion_bc_add_search_products_cancel_button: "Annuler",
  promotion_bc_add_search_products_save_button: "Sauvegarder",
  promotion_bc_add_summary_title: "R\xE9sum\xE9",
  promotion_bc_add_promotion_name: "Nom de la promotion",
  promotion_bc_add_promotion_name_placeholder: "Veuillez saisir le nom de votre promotion ici",
  promotion_bc_add_promotion_type: "Type de promotion",
  promotion_bc_add_select_placeholder: "S\xE9lection",
  promotion_bc_add_coupon_code_label: "Code de coupon",
  promotion_bc_add_coupon_code_placeholder: "Entrez votre code de coupon",
  promotion_bc_add_schedule_title: "Planification",
  promotion_bc_add_start_at_label: "Commence \xE0",
  promotion_bc_add_end_at_label: "Se termine \xE0",
  promotion_bc_add_select_date_placeholder: "S\xE9lectionner une date",
  promotion_bc_add_schedule_toggle_button: "Date / Heure sp\xE9cifique",
  promotion_bc_add_schedule_week_label: "Chaque semaine",
  promotion_bc_add_schedule_day_label: "Jour",
  promotion_bc_add_schedule_day_placeholder: "S\xE9lectionner un jour",
  promotion_bc_add_schedule_time_label: "Heure",
  promotion_bc_add_schedule_to_label: "\xE0",
  promotion_bc_add_clear_button: "Effacer",
  promotion_bc_add_targeting_title: "Ciblage",
  promotion_bc_add_targeting_sub_title: "Cibler le client si...",
  promotion_bc_add_currency_is: "La devise est",
  promotion_bc_add_customer_group: "Groupe de clients",
  promotion_bc_add_is: "est",
  promotion_bc_add_is_not: "n'est pas",
  promotion_bc_add_select_group: "S\xE9lectionner un groupe",
  promotion_bc_add_shipping_destination: "Destination d'exp\xE9dition",
  promotion_bc_add_select_zone: "S\xE9lectionner des zones",
  promotion_bc_add_selection: "S\xE9lection",
  promotion_bc_add_template_rules_button: "Ajouter des r\xE8gles de mod\xE8le",
  promotion_bc_add_template_rules_modal_title: "S\xE9lectionner des r\xE8gles de mod\xE8le"
};

// src/locales/fr/provisioningProfiles.ts
var provisioningProfiles_default3 = {
  "provisioningProfiles.pageTitle": "Profils de Provisionnement",
  "provisioningProfiles.addProfileToStores": "Ajouter le Profil aux Magasins",
  "provisioningProfiles.createProfile": "Cr\xE9er un Profil",
  "provisioningProfiles.noPermission": "Vous n'avez pas les permissions.",
  "provisioningProfiles.shopify.addProfileToStores": "Ajouter le Profil aux Magasins",
  "provisioningProfiles.shopify.createSuccess": "Cr\xE9ation du profil de provisionnement r\xE9ussie",
  "provisioningProfiles.shopify.editSuccess": "Modification du profil de provisionnement r\xE9ussie",
  "provisioningProfiles.shopify.addProductsBySKU": "Ajouter des Produits par SKU",
  "provisioningProfiles.shopify.skuList": "Liste SKU",
  "provisioningProfiles.shopify.skuPlaceholder": "Collez la liste des SKU ici (un par ligne ou s\xE9par\xE9s par des virgules) Exemple: SKU001, SKU002, SKU003, SKU004",
  "provisioningProfiles.shopify.apply": "Appliquer",
  "provisioningProfiles.shopify.cancel": "Annuler",
  "provisioningProfiles.shopify.notFound": "n'est pas trouv\xE9",
  "provisioningProfiles.filter.search": "rechercher",
  "provisioningProfiles.filter.expand": "D\xE9velopper",
  "provisioningProfiles.filter.profileName": "Nom du Profil",
  "provisioningProfiles.filter.profileNameContains": " (contient)",
  "provisioningProfiles.filter.themes": "Th\xE8mes",
  "provisioningProfiles.filter.themesContains": " (contient)",
  "provisioningProfiles.filter.promotions": "Promotions",
  "provisioningProfiles.filter.promotionsEquals": " (\xE9gal)",
  "provisioningProfiles.filter.qtyOfProducts": "Quantit\xE9 de Produits",
  "provisioningProfiles.filter.qtyOfProductsEquals": " (\xE9gal)",
  "provisioningProfiles.filter.utilization": "Utilisation",
  "provisioningProfiles.filter.utilizationEquals": " (\xE9gal)",
  "provisioningProfiles.filter.clear": "Effacer",
  "provisioningProfiles.filter.apply": "Appliquer",
  "provisioningProfiles.table.profileName": "Nom du Profil",
  "provisioningProfiles.table.utilization": "Utilisation",
  "provisioningProfiles.table.qtyOfProducts": "Quantit\xE9 de Produits",
  "provisioningProfiles.table.themes": "Th\xE8mes",
  "provisioningProfiles.table.createdAt": "Cr\xE9\xE9 le",
  "provisioningProfiles.table.action": "Action",
  "provisioningProfiles.action.edit": "Modifier",
  "provisioningProfiles.action.remove": "Supprimer",
  "provisioningProfiles.action.delete": "Supprimer",
  "provisioningProfiles.delete.shopify.title": "Ce profil sera supprim\xE9 de tous les produits et potentiellement d'autres donn\xE9es.",
  "provisioningProfiles.delete.title": "Ce profil sera supprim\xE9 de tous les magasins et peut affecter le catalogue, les th\xE8mes, l'historique des commandes, les rapports et potentiellement d'autres donn\xE9es.",
  "provisioningProfiles.delete.profileName": "Nom du Profil",
  "provisioningProfiles.delete.profileNameRequired": "Le nom du profil est requis",
  "provisioningProfiles.delete.profileNamePlaceholder": "Veuillez saisir le nom du profil",
  "provisioningProfiles.delete.confirm": "Confirmer",
  "provisioningProfiles.delete.confirmRequired": "Veuillez saisir le mot 'CONFIRMER'",
  "provisioningProfiles.delete.confirmValidator": "Veuillez saisir le mot 'CONFIRMER'",
  "provisioningProfiles.delete.confirmPlaceholder": "Veuillez saisir le mot 'CONFIRMER'",
  "provisioningProfiles.delete.cancel": "Annuler",
  "provisioningProfiles.delete.ok": "OK",
  "provisioningProfiles.delete.success": "Profil supprim\xE9 avec succ\xE8s",
  "provisioningProfiles.create.pageTitle": "Cr\xE9er un Profil",
  "provisioningProfiles.create.success": "Cr\xE9ation R\xE9ussie",
  "provisioningProfiles.edit.pageTitle": "Modifier le Profil",
  "provisioningProfiles.edit.success": "Modification R\xE9ussie",
  "provisioningProfiles.form.summary": "R\xE9sum\xE9",
  "provisioningProfiles.form.name": "Nom du Profil",
  "provisioningProfiles.form.namePlaceholder": "veuillez saisir le nom du profil ici",
  "provisioningProfiles.form.industry": "Industrie",
  "provisioningProfiles.form.industryPlaceholder": "veuillez saisir l'industrie ici",
  "provisioningProfiles.form.description": "Description",
  "provisioningProfiles.form.descriptionPlaceholder": "veuillez saisir la description ici",
  "provisioningProfiles.form.categories": "Cat\xE9gories",
  "provisioningProfiles.form.products": "Produits",
  "provisioningProfiles.form.themes": "Th\xE8mes",
  "provisioningProfiles.form.currentTheme": "Th\xE8me Actuel",
  "provisioningProfiles.form.themeList": "Liste des Th\xE8mes",
  "provisioningProfiles.form.image": "Image",
  "provisioningProfiles.form.save": "Enregistrer",
  "provisioningProfiles.form.cancel": "Annuler",
  "provisioningProfiles.form.back": "Retour",
  "provisioningProfiles.form.submit": "Soumettre",
  "provisioningProfiles.categories.name": "Nom",
  "provisioningProfiles.categories.qtyOfItems": "Quantit\xE9 d'\xC9l\xE9ments",
  "provisioningProfiles.categories.status": "Statut",
  "provisioningProfiles.categories.selectAll": "Tout S\xE9lectionner",
  "provisioningProfiles.categories.deselectAll": "Tout D\xE9s\xE9lectionner",
  "provisioningProfiles.products.name": "Nom",
  "provisioningProfiles.products.price": "Prix",
  "provisioningProfiles.products.status": "Statut",
  "provisioningProfiles.products.delete": "Supprimer",
  "provisioningProfiles.products.deleteSelected": "Supprimer la S\xE9lection",
  "provisioningProfiles.products.deleteSuccess": "Supprim\xE9 avec succ\xE8s.",
  "provisioningProfiles.products.noProducts": "Aucun produit s\xE9lectionn\xE9",
  "provisioningProfiles.products.add": "Ajouter",
  "provisioningProfiles.products.remove": "Supprimer",
  "provisioningProfiles.products.filter": "Filtrer",
  "provisioningProfiles.products.clear": "Effacer",
  "provisioningProfiles.products.apply": "Appliquer",
  "provisioningProfiles.products.image": "Image",
  "provisioningProfiles.products.productName": "Nom du Produit",
  "provisioningProfiles.products.inventory": "Inventaire",
  "provisioningProfiles.products.sku": "SKU",
  "provisioningProfiles.themes.selectTheme": "S\xE9lectionner un Th\xE8me",
  "provisioningProfiles.themes.selectThemes": "S\xE9lectionner les Th\xE8mes",
  "provisioningProfiles.themes.currentTheme": "Th\xE8me Actuel",
  "provisioningProfiles.themes.themeList": "Liste des Th\xE8mes",
  "provisioningProfiles.themes.addTheme": "Ajouter un Th\xE8me",
  "provisioningProfiles.themes.removeTheme": "Supprimer le Th\xE8me",
  "provisioningProfiles.themes.version": "Version",
  "provisioningProfiles.themes.styles": "styles",
  "provisioningProfiles.themes.developedBy": "D\xE9velopp\xE9 par",
  "provisioningProfiles.apply.pageTitle": "Appliquer le Profil aux Magasins",
  "provisioningProfiles.apply.confirmPageTitle": "Confirmer l'Application des Profils de Provisionnement",
  "provisioningProfiles.apply.confirmation": "Confirmation",
  "provisioningProfiles.apply.confirmationDescription": "Nous vous recommandons d'envoyer un e-mail de confirmation avant d'appliquer le profil aux magasins.",
  "provisioningProfiles.apply.targetStore": "Magasin Cible*",
  "provisioningProfiles.apply.stores": "Magasins",
  "provisioningProfiles.apply.selectStore": "S\xE9lectionner le magasin",
  "provisioningProfiles.apply.confirmType1": "Envoyer un e-mail de confirmation au propri\xE9taire du magasin pour autoriser l'application du profil.",
  "provisioningProfiles.apply.confirmType2": "D\xE9finir une date d'impl\xE9mentation obligatoire et envoyer un e-mail de confirmation au propri\xE9taire du magasin pour autoriser l'application du profil. Si le propri\xE9taire du magasin n'est pas d'accord avec la confirmation, le profil sera appliqu\xE9 dans des jours sp\xE9cifiques.",
  "provisioningProfiles.apply.confirmType3": "Appliquer le profil directement.",
  "provisioningProfiles.apply.forcingImplementationDate": "Date d'Impl\xE9mentation Forc\xE9e",
  "provisioningProfiles.apply.selectTime": "s\xE9lectionner l'heure",
  "provisioningProfiles.apply.warning": "Avertissement",
  "provisioningProfiles.apply.profileName": "Nom du Profil*",
  "provisioningProfiles.apply.appliedStores": "Magasins Appliqu\xE9s*",
  "provisioningProfiles.apply.type": "Type",
  "provisioningProfiles.apply.inTextField": "dans le champ de texte",
  "provisioningProfiles.apply.apply": "Appliquer",
  "provisioningProfiles.apply.processingSuccess": "Traitement des profils pour application. Cela peut prendre quelques minutes.",
  "provisioningProfiles.apply.selectStores": "S\xE9lectionner les Magasins",
  "provisioningProfiles.apply.applyToStores": "Appliquer aux Magasins",
  "provisioningProfiles.apply.success": "Profil appliqu\xE9 avec succ\xE8s",
  "provisioningProfiles.apply.error": "\xC9chec de l'application du profil",
  "provisioningProfiles.details.pageTitle": "D\xE9tails du Profil",
  "provisioningProfiles.details.basicInfo": "Informations de Base",
  "provisioningProfiles.details.categories": "Cat\xE9gories",
  "provisioningProfiles.details.products": "Produits",
  "provisioningProfiles.details.themes": "Th\xE8mes",
  "provisioningProfiles.details.stores": "Magasins Appliqu\xE9s",
  "provisioningProfiles.details.orders": "Commandes",
  "provisioningProfiles.details.totalSale": "Vente Totale",
  "provisioningProfiles.details.updateSuccess": "mise \xE0 jour r\xE9ussie",
  "provisioningProfiles.changeStyle.changeStyle": "Changer le Style",
  "provisioningProfiles.changeStyle.success": "Succ\xE8s",
  "provisioningProfiles.changeStyle.selectThemeStyle": "S\xE9lectionnez un style de th\xE8me pour le profil actuel",
  "provisioningProfiles.changeStyle.style": "Style",
  "provisioningProfiles.changeStyle.selectStyleName": "Veuillez s\xE9lectionner le nom du style",
  "provisioningProfiles.changeStyle.ok": "OK",
  "provisioningProfiles.changeStyle.setAsCurrentTheme": "D\xE9finir comme th\xE8me actuel",
  "provisioningProfiles.changeStyle.selectedStyle": "Style S\xE9lectionn\xE9",
  "provisioningProfiles.changeStyle.notice": "Avis",
  "provisioningProfiles.changeStyle.unexpectedWarning": "Des choses mauvaises inattendues se produiront si vous ne lisez pas ceci !",
  "provisioningProfiles.changeStyle.applyThemeWarning": "Appliquer ce th\xE8me aux magasins peut affecter les polices, les couleurs et d'autres fonctionnalit\xE9s du magasin.",
  "provisioningProfiles.changeStyle.themeName": "Nom du Th\xE8me",
  "provisioningProfiles.changeStyle.storesToBeApplied": "Magasins \xE0 appliquer",
  "provisioningProfiles.changeStyle.typeConfirmSentence": "Tapez la phrase ci-dessous pour CONFIRMER*",
  "provisioningProfiles.currentTheme.defaultTheme": "Th\xE8me par D\xE9faut",
  "provisioningProfiles.currentTheme.version": "Version",
  "provisioningProfiles.currentTheme.styles": "Styles",
  "provisioningProfiles.currentTheme.developedBy": "D\xE9velopp\xE9 par",
  "provisioningProfiles.addProducts.addProducts": "Ajouter des Produits",
  "provisioningProfiles.addProducts.selectProducts": "S\xE9lectionner des Produits",
  "provisioningProfiles.addProducts.cancel": "Annuler",
  "provisioningProfiles.addProducts.save": "Enregistrer",
  "provisioningProfiles.addProducts.banner": "Banni\xE8re",
  "provisioningProfiles.addProducts.productName": "Nom du Produit",
  "provisioningProfiles.addProducts.sku": "SKU",
  "provisioningProfiles.addProducts.productPrice": "Prix du Produit",
  "provisioningProfiles.addProducts.products": "Produits",
  "provisioningProfiles.addProducts.successfullyAdded": "Ajout\xE9 avec succ\xE8s.",
  "provisioningProfiles.removeTheme.remove": "Supprimer",
  "provisioningProfiles.removeTheme.cancel": "Annuler",
  "provisioningProfiles.removeTheme.themeWillBeRemoved": "Ce th\xE8me sera supprim\xE9 du profil actuel.",
  "provisioningProfiles.removeTheme.themeName": "Nom du Th\xE8me",
  "provisioningProfiles.removeTheme.confirm": "Confirmer",
  "provisioningProfiles.removeTheme.confirmRequired": "Veuillez taper le mot 'CONFIRM'",
  "provisioningProfiles.removeTheme.confirmValidator": "Veuillez taper le mot 'CONFIRM'",
  "provisioningProfiles.removeTheme.confirmPlaceholder": "Veuillez taper le mot 'CONFIRM'",
  "provisioningProfiles.removeTheme.removeAppliedTheme": "Supprimer le th\xE8me appliqu\xE9",
  "provisioningProfiles.removeTheme.selectedTheme": "Th\xE8me S\xE9lectionn\xE9",
  "provisioningProfiles.removeTheme.notice": "Avis",
  "provisioningProfiles.removeTheme.unexpectedWarning": "Des choses mauvaises inattendues se produiront si vous ne lisez pas ceci !",
  "provisioningProfiles.removeTheme.removeThemeWarning": "Supprimer ce th\xE8me appliqu\xE9 aux magasins peut affecter les polices, les couleurs et d'autres fonctionnalit\xE9s du magasin.",
  "provisioningProfiles.removeTheme.iveReadTheseEffects": "J'ai lu ces effets",
  "provisioningProfiles.removeTheme.themeWillBeRemovedFromAllStores": "Ce th\xE8me sera supprim\xE9 de tous les magasins et peut affecter les polices, les couleurs et d'autres fonctionnalit\xE9s du magasin.",
  "provisioningProfiles.removeTheme.storesToBeApplied": "Magasins \xE0 appliquer",
  "provisioningProfiles.removeTheme.typeConfirmSentence": "Tapez la phrase ci-dessous pour CONFIRMER*",
  "provisioningProfiles.removeTheme.confirmTextTemplate": "Je comprends qu'APPLIQUER ce th\xE8me aux magasins cibles peut affecter les mises \xE0 jour futures de version.",
  "provisioningProfiles.themeItemList.themes": "Th\xE8mes",
  "provisioningProfiles.themeItemList.addThemes": "Ajouter des Th\xE8mes",
  "provisioningProfiles.themeItemList.setAsCurrentTheme": "D\xE9finir comme th\xE8me actuel",
  "provisioningProfiles.themeItemList.styles": "styles",
  "provisioningProfiles.themeItemList.utilization": "Utilisation"
};

// src/locales/fr/reports.ts
var reports_default3 = {
  reports_page_title: "Rapports",
  reports_store_overview_title: "Aper\xE7u du magasin",
  reports_plan_revenue_title: "Revenus du plan",
  reports_plan_revenue_text: "Aper\xE7u des magasins et des revenus",
  reports_latest_plan_changes_title: "Derniers changements de plan",
  reports_latest_plan_changes_text: "Historique et statut des changements de plan",
  reports_logs_title: "Journaux",
  reports_portal_logs_title: "Journaux du portail",
  reports_portal_logs_text: "Afficher l'activit\xE9 historique des utilisateurs",
  reports_store_logs_title: "Journaux du magasin",
  reports_store_logs_text: "Afficher le journal d'audit de l'activit\xE9 du magasin",
  reports_orders_title: "Commandes",
  reports_orders_revenue_title: "Revenus des commandes",
  reports_orders_revenue_text: "Donn\xE9es des commandes associ\xE9es aux magasins",
  reports_promotion_utilization_title: "Utilisation des promotions",
  reports_promotion_utilization_text: "Donn\xE9es associ\xE9es aux magasins",
  reports_system_logs_title: "Journaux syst\xE8me",
  reports_plan_revenue_page_title: "Revenus du plan",
  reports_plan_revenue_order_number: "Num\xE9ro de commande",
  reports_plan_revenue_store_hash: "Hash du magasin",
  reports_plan_revenue_store_id: "ID du magasin",
  reports_plan_revenue_store_name: "Nom du magasin",
  reports_plan_revenue_net: "Net",
  reports_plan_revenue_gross: "Brut",
  reports_plan_revenue_plan_code: "Code du plan",
  reports_plan_revenue_date: "Date",
  reports_plan_revenue_status: "Statut",
  reports_plan_revenue_view_details: "Voir les d\xE9tails",
  reports_plan_revenue_more: "Plus",
  reports_plan_revenue_account_info: "Informations du compte",
  reports_plan_revenue_store_info: "Informations du magasin",
  reports_plan_revenue_total_order_count: "(nombre total de commandes)",
  reports_plan_revenue_total_order_amount: "(montant total des commandes)",
  reports_plan_revenue_search_placeholder: "rechercher",
  reports_plan_revenue_export: "Exporter",
  reports_plan_revenue_filter: "Filtrer",
  reports_plan_revenue_equals: " (\xE9gal)",
  reports_plan_revenue_clear: "Effacer",
  reports_plan_revenue_apply: "Appliquer",
  reports_portal_logs_page_title: "Journaux du portail",
  reports_portal_logs_date: "Date",
  reports_portal_logs_user: "Utilisateur",
  reports_portal_logs_ip: "IP",
  reports_portal_logs_module: "Module",
  reports_portal_logs_details: "D\xE9tails",
  reports_portal_logs_search_placeholder: "rechercher",
  reports_portal_logs_export: "Exporter",
  reports_portal_logs_filter: "Filtrer",
  reports_portal_logs_user_label: "Utilisateur",
  reports_portal_logs_module_label: "Module",
  reports_portal_logs_ip_label: "IP",
  reports_portal_logs_date_label: "Date",
  reports_portal_logs_details_label: "D\xE9tails",
  reports_portal_logs_contains: " (contient)",
  reports_portal_logs_equals: " (\xE9gal)",
  reports_portal_logs_clear: "Effacer",
  reports_portal_logs_apply: "Appliquer",
  reports_portal_logs_ip_validation: "Veuillez saisir des chiffres et des points dans le champ de texte.",
  reports_latest_plan_changes_page_title: "Derniers changements de plan",
  reports_latest_plan_changes_company: "Entreprise",
  reports_latest_plan_changes_store_name: "Nom du magasin",
  reports_latest_plan_changes_account_id: "ID du compte",
  reports_latest_plan_changes_current_type: "Type actuel",
  reports_latest_plan_changes_previous_type: "Type pr\xE9c\xE9dent",
  reports_latest_plan_changes_effective_date: "Date d'entr\xE9e en vigueur",
  reports_latest_plan_changes_amount: "Montant",
  reports_latest_plan_changes_status: "Statut",
  reports_latest_plan_changes_last_modified: "Derni\xE8re modification",
  reports_latest_plan_changes_created_on: "Cr\xE9\xE9 le",
  reports_latest_plan_changes_modified_by: "Modifi\xE9 par",
  reports_latest_plan_changes_status_available: "Disponible",
  reports_latest_plan_changes_status_using: "En cours d'utilisation",
  reports_latest_plan_changes_status_suspended: "Suspendu",
  reports_latest_plan_changes_status_cancelled: "Annul\xE9",
  reports_latest_plan_changes_search_placeholder: "rechercher",
  reports_latest_plan_changes_export: "Exporter",
  reports_latest_plan_changes_filter: "Filtrer",
  reports_latest_plan_changes_company_label: "Entreprise",
  reports_latest_plan_changes_store_name_label: "Nom du magasin",
  reports_latest_plan_changes_account_id_label: "ID du compte",
  reports_latest_plan_changes_current_type_label: "Type actuel",
  reports_latest_plan_changes_amount_label: "Montant",
  reports_latest_plan_changes_status_label: "Statut",
  reports_latest_plan_changes_last_modified_label: "Derni\xE8re modification",
  reports_latest_plan_changes_contains: " (contient)",
  reports_latest_plan_changes_equals: " (\xE9gal)",
  reports_latest_plan_changes_clear: "Effacer",
  reports_latest_plan_changes_apply: "Appliquer",
  reports_store_logs_page_title: "Journaux du magasin",
  reports_store_logs_store_id: "ID du magasin",
  reports_store_logs_store_name: "Nom du magasin",
  reports_store_logs_type: "Type",
  reports_store_logs_module: "Module",
  reports_store_logs_severity: "Gravit\xE9",
  reports_store_logs_summary: "R\xE9sum\xE9",
  reports_store_logs_created_time: "Heure de cr\xE9ation",
  reports_store_logs_message: "Message",
  reports_store_logs_search_placeholder: "rechercher",
  reports_store_logs_export: "Exporter",
  reports_store_logs_filter: "Filtrer",
  reports_store_logs_type_label: "Type",
  reports_store_logs_severity_label: "Gravit\xE9",
  reports_store_logs_module_label: "Module",
  reports_store_logs_summary_label: "R\xE9sum\xE9",
  reports_store_logs_store_name_label: "Nom du magasin",
  reports_store_logs_store_id_label: "ID du magasin",
  reports_store_logs_created_date_label: "Date de cr\xE9ation",
  reports_store_logs_clear: "Effacer",
  reports_store_logs_apply: "Appliquer",
  reports_store_logs_store_id_validation: "Veuillez saisir un nombre dans le champ de texte.",
  reports_store_logs_show_details: "afficher les d\xE9tails",
  reports_store_logs_message_title: "Message",
  reports_store_logs_ok: "OK",
  reports_promotion_utilization_page_title: "Utilisation des promotions",
  reports_promotion_utilization_stores: "Magasins",
  reports_promotion_utilization_customers: "Clients",
  reports_promotion_utilization_campaigns: "Campagnes",
  reports_promotion_utilization_period: "P\xE9riode",
  reports_promotion_utilization_search_placeholder: "Rechercher",
  reports_promotion_utilization_clear: "Effacer",
  reports_promotion_utilization_apply: "Appliquer",
  reports_promotion_utilization_total_revenue: "Revenus totaux",
  reports_promotion_utilization_from: "de",
  reports_promotion_utilization_stores_title: "Magasins",
  reports_promotion_utilization_store_name: "Nom du magasin",
  reports_promotion_utilization_store_hash: "Hash du magasin",
  reports_promotion_utilization_promotion_name: "Nom de la promotion",
  reports_promotion_utilization_coupon: "Coupon",
  reports_promotion_utilization_usage: "Utilisation",
  reports_promotion_utilization_chart_title: "Utilisation des promotions",
  reports_order_revenue_page_title: "Revenus des commandes",
  reports_order_revenue_period: "P\xE9riode",
  reports_order_revenue_search_placeholder: "Rechercher",
  reports_order_revenue_clear: "Effacer",
  reports_order_revenue_apply: "Appliquer",
  reports_order_revenue_store_hash: "Hash du magasin :",
  reports_order_revenue_account_id: "ID du compte :",
  reports_order_revenue_total_revenue: "Revenus totaux",
  reports_order_revenue_from: "de",
  reports_order_revenue_orders_title: "Commandes",
  reports_order_revenue_order_id: "ID de commande",
  reports_order_revenue_date: "Date",
  reports_order_revenue_source: "Source",
  reports_order_revenue_subtotal: "Sous-total",
  reports_order_revenue_line_item_discounts: "Remises sur les articles",
  reports_order_revenue_shipping: "Exp\xE9dition",
  reports_order_revenue_tax: "Taxe",
  reports_order_revenue_total: "Total",
  reports_order_revenue_chart_title: "Revenus des commandes",
  reports_order_revenue_chart_unit: "unit\xE9 : $",
  reports_order_revenue_gross: "Brut",
  reports_system_logs_page_title: "Journaux syst\xE8me",
  reports_all_stores: "Tous les magasins",
  reports_dont_have_permission: "Vous n'avez pas la permission."
};

// src/locales/fr/resetPassword.ts
var resetPassword_default3 = {
  resetPassword_page_title: "R\xE9initialiser le mot de passe",
  resetPassword_form_submit_button: "R\xE9initialiser le mot de passe",
  resetPassword_form_have_account: "Vous avez d\xE9j\xE0 un compte ?",
  resetPassword_form_have_login: "Se connecter",
  resetPassword_password_validation_error: "Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caract\xE8re sp\xE9cial, et sa longueur doit \xEAtre comprise entre 8 et 12 caract\xE8res",
  resetPassword_reset_success: "Mot de passe r\xE9initialis\xE9 avec succ\xE8s",
  resetPassword_reset_failed: "\xC9chec de la r\xE9initialisation du mot de passe",
  resetPassword_password_not_match: "Veuillez vous assurer que les deux mots de passe sont identiques",
  resetPassword_new_password_label: "Nouveau mot de passe",
  resetPassword_new_password_placeholder: "Veuillez entrer votre nouveau mot de passe.",
  resetPassword_confirm_password_label: "Confirmer le nouveau mot de passe",
  resetPassword_confirm_password_required: "La confirmation du mot de passe est un champ obligatoire.",
  resetPassword_confirm_password_placeholder: "Veuillez confirmer votre nouveau mot de passe.",
  resetPassword_password_at_most: "Le mot de passe doit contenir au maximum 12 caract\xE8res",
  resetPassword_password_at_least: "Le mot de passe doit contenir au minimum 8 caract\xE8res",
  resetPassword_password_requirements: "Exigences du mot de passe :",
  resetPassword_password_length: "Longueur : 8-12 caract\xE8res",
  resetPassword_password_uppercase: "Au moins une lettre majuscule",
  resetPassword_password_lowercase: "Au moins une lettre minuscule",
  resetPassword_password_number: "Au moins un chiffre",
  resetPassword_password_special: "Au moins un caract\xE8re sp\xE9cial"
};

// src/locales/fr/settings.ts
var settings_default3 = {
  "settings.pageTitle": "Param\xE8tres",
  "settings.noPermission": "Vous n'avez pas les permissions.",
  "settings.home.userAdministration": "Administration des Utilisateurs",
  "settings.home.plan": "Plan",
  "settings.home.scheduleManagement": "Gestion des Programmes",
  "settings.home.storeSetting": "Param\xE8tres de Boutique",
  "settings.home.smsConfiguration": "Configuration SMS",
  "settings.home.mailConfiguration": "Configuration Mail",
  "settings.portalUser.pageTitle": "Gestion des Utilisateurs du Portail",
  "settings.portalUser.addUser": "Ajouter un Utilisateur",
  "settings.portalUser.editUser": "Modifier l'Utilisateur",
  "settings.portalUser.addNewUser": "Ajouter un nouvel utilisateur",
  "settings.portalUser.deleteUser": "Supprimer l'Utilisateur",
  "settings.portalUser.export": "Exporter",
  "settings.portalUser.filter": "Filtrer",
  "settings.portalUser.clear": "Effacer",
  "settings.portalUser.apply": "Appliquer",
  "settings.portalUser.action": "Action",
  "settings.portalUser.edit": "Modifier",
  "settings.portalUser.delete": "Supprimer",
  "settings.portalUser.table.email": "E-mail",
  "settings.portalUser.table.lastLogin": "Derni\xE8re Connexion",
  "settings.portalUser.table.name": "Nom",
  "settings.portalUser.table.group": "Groupe",
  "settings.portalUser.table.status": "Statut",
  "settings.group.messages.adminGroup": "Le groupe d'administrateur ne peut pas \xEAtre \xE9dit\xE9/ajout\xE9 .",
  "settings.portalUser.filter.email": "E-mail",
  "settings.portalUser.filter.emailContains": " (contient)",
  "settings.portalUser.filter.phone": "T\xE9l\xE9phone",
  "settings.portalUser.filter.phoneEquals": " (\xE9gal)",
  "settings.portalUser.filter.lastLogin": "Derni\xE8re Connexion",
  "settings.portalUser.filter.lastLoginEquals": " (\xE9gal)",
  "settings.portalUser.filter.name": "Nom",
  "settings.portalUser.filter.nameContains": " (contient)",
  "settings.portalUser.filter.group": "Groupe",
  "settings.portalUser.filter.groupContains": " (contient)",
  "settings.portalUser.filter.status": "Statut",
  "settings.portalUser.filter.statusEquals": " (\xE9gal)",
  "settings.portalUser.filter.valid": "Valide",
  "settings.portalUser.filter.disabled": "D\xE9sactiv\xE9",
  "settings.portalUser.form.email": "E-mail (ID de Connexion)",
  "settings.portalUser.form.emailPlaceholder": "Veuillez saisir l'e-mail.",
  "settings.portalUser.form.firstName": "Pr\xE9nom",
  "settings.portalUser.form.firstNamePlaceholder": "Veuillez saisir le pr\xE9nom.",
  "settings.portalUser.form.firstNameRequired": "Le pr\xE9nom est un champ obligatoire.",
  "settings.portalUser.form.lastName": "Nom de Famille",
  "settings.portalUser.form.lastNamePlaceholder": "Veuillez saisir le nom de famille.",
  "settings.portalUser.form.lastNameRequired": "Le nom de famille est un champ obligatoire.",
  "settings.portalUser.form.group": "Groupe",
  "settings.portalUser.form.groupPlaceholder": "Veuillez s\xE9lectionner le groupe.",
  "settings.portalUser.form.selectShopifyAccounts": "S\xE9lectionner les comptes Shopify",
  "settings.portalUser.form.selectShopifyAccountsPlaceholder": "Veuillez s\xE9lectionner les comptes Shopify",
  "settings.portalUser.form.selectBigcommerceAccounts": "S\xE9lectionner les comptes BigCommerce",
  "settings.portalUser.form.selectBigcommerceAccountsPlaceholder": "Veuillez s\xE9lectionner les comptes BigCommerce",
  "settings.portalUser.delete.title": "D\xE9sactiver un Utilisateur entra\xEEnera la suppression de tous les messages associ\xE9s et est irr\xE9versible.",
  "settings.portalUser.delete.userEmail": "E-mail de l'Utilisateur",
  "settings.portalUser.delete.userEmailPlaceholder": "Veuillez saisir l'e-mail",
  "settings.portalUser.delete.confirm": "Confirmer",
  "settings.portalUser.delete.confirmPlaceholder": "Veuillez saisir le mot 'CONFIRMER'",
  "settings.portalUser.delete.confirmRequired": "Veuillez saisir le mot 'CONFIRMER'",
  "settings.portalUser.delete.confirmValidator": "Veuillez saisir le mot 'CONFIRMER'",
  "settings.portalUser.delete.enterCorrectEmail": "Veuillez saisir l'e-mail correct",
  "settings.portalUser.delete.cancel": "Annuler",
  "settings.portalUser.delete.delete": "Supprimer",
  "settings.portalUser.delete.success": "Utilisateur supprim\xE9 avec succ\xE8s",
  "settings.portalUser.messages.createSuccess": "Utilisateur cr\xE9\xE9 avec succ\xE8s",
  "settings.portalUser.messages.editSuccess": "Utilisateur modifi\xE9 avec succ\xE8s",
  "settings.portalUser.messages.userAlreadyExists": "L'utilisateur existe d\xE9j\xE0.",
  "settings.portalUser.messages.userGroupDisable": "D\xE9sactiver le groupe d'utilisateur.",
  "settings.portalUser.messages.failedToChangeUserStatus": "\xC9chec du changement du statut de l'utilisateur. Veuillez r\xE9essayer plus tard.",
  "settings.portalUser.messages.invalidGroups": "Groupes invalides.",
  "settings.portalUser.messages.userNotFound": "Utilisateur pour {id} non trouv\xE9.",
  "settings.portalUser.messages.failedToRemoveUser": "\xC9chec de la suppression de l'utilisateur {id}.",
  "settings.plan.pageTitle": "Gestion des Forfaits",
  "settings.plan.addPlan": "Ajouter un Forfait",
  "settings.plan.editPlan": "Modifier le Forfait",
  "settings.plan.deletePlan": "Supprimer le Forfait",
  "settings.plan.export": "Exporter",
  "settings.plan.filter": "Filtrer",
  "settings.plan.clear": "Effacer",
  "settings.plan.apply": "Appliquer",
  "settings.plan.table.name": "Plan",
  "settings.plan.table.code": "Code",
  "settings.plan.table.sku": "SKU",
  "settings.plan.table.description": "Description",
  "settings.plan.table.price": "Prix",
  "settings.plan.table.franchisePrice": "Prix de Franchise",
  "settings.plan.table.status": "Statut",
  "settings.plan.action": "Action",
  "settings.plan.form.name": "Nom du Forfait",
  "settings.plan.form.namePlaceholder": "Veuillez saisir le nom du forfait.",
  "settings.plan.form.price": "Prix",
  "settings.plan.form.pricePlaceholder": "Veuillez saisir le prix.",
  "settings.plan.form.duration": "Dur\xE9e",
  "settings.plan.form.durationPlaceholder": "Veuillez s\xE9lectionner la dur\xE9e.",
  "settings.plan.form.description": "Description",
  "settings.plan.form.descriptionPlaceholder": "Veuillez saisir la description.",
  "settings.group.pageTitle": "Gestion des Groupes",
  "settings.group.add": "Ajouter",
  "settings.group.addTitle": "Ajouter un nouveau groupe",
  "settings.group.save": "Enregistrer",
  "settings.group.addGroup": "Ajouter un Groupe",
  "settings.group.editGroup": "Modifier le Groupe",
  "settings.group.deleteGroup": "Supprimer le Groupe",
  "settings.group.export": "Exporter",
  "settings.group.filter": "Filtrer",
  "settings.group.clear": "Effacer",
  "settings.group.apply": "Appliquer",
  "settings.group.messages.addSuccess": "Groupe ajout\xE9 avec succ\xE8s",
  "settings.group.messages.deleteSuccess": "Groupe supprim\xE9 avec succ\xE8s",
  "settings.group.messages.editSuccess": "Groupe modifi\xE9 avec succ\xE8s",
  "settings.group.action": "Action",
  "settings.group.editTitle": "Modifier le groupe",
  "settings.group.deleteModal.header": "D\xE9sactiver un Groupe entra\xEEnera la suppression de tous les param\xE8tres associ\xE9s et est irr\xE9versible.",
  "settings.group.deleteModal.cancel": "Annuler",
  "settings.group.deleteModal.delete": "Supprimer",
  "settings.group.deleteModal.groupName": "Nom du Groupe",
  "settings.group.deleteModal.groupNameRequired": "Le nom du groupe est requis",
  "settings.group.deleteModal.groupNamePlaceholder": "Veuillez saisir le nom du groupe",
  "settings.group.deleteModal.confirm": "Confirmer",
  "settings.group.deleteModal.confirmRequired": "Veuillez saisir le mot 'CONFIRM'",
  "settings.group.deleteModal.confirmPlaceholder": "Veuillez saisir le mot 'CONFIRM'",
  "settings.group.table.name": "Nom",
  "settings.group.table.description": "Description",
  "settings.group.table.memberCount": "Nombre de Membres",
  "settings.group.table.status": "Statut",
  "settings.group.table.action": "Action",
  "settings.group.table.activeAccount": "Compte Actif",
  "settings.group.edit": "Modifier",
  "settings.group.delete": "Supprimer",
  "settings.group.form.name": "Nom du Groupe",
  "settings.group.form.namePlaceholder": "Veuillez saisir le nom du groupe.",
  "settings.group.form.description": "Description",
  "settings.group.form.descriptionPlaceholder": "Veuillez saisir la description.",
  "settings.group.form.permissions": "Permissions",
  "settings.group.form.permissionsPlaceholder": "Veuillez s\xE9lectionner les permissions.",
  "settings.group.form.users": "Utilisateurs",
  "settings.mailTemplate.pageTitle": "Gestion des Mod\xE8les d'E-mail",
  "settings.mailTemplate.addTemplate": "Ajouter un Mod\xE8le",
  "settings.mailTemplate.editTemplate": "Modifier le Mod\xE8le",
  "settings.mailTemplate.deleteTemplate": "Supprimer le Mod\xE8le",
  "settings.mailTemplate.export": "Exporter",
  "settings.mailTemplate.filter": "Filtrer",
  "settings.mailTemplate.clear": "Effacer",
  "settings.mailTemplate.apply": "Appliquer",
  "settings.mailTemplate.table.name": "Nom",
  "settings.mailTemplate.table.subject": "Sujet",
  "settings.mailTemplate.table.type": "Type",
  "settings.mailTemplate.table.status": "Statut",
  "settings.mailTemplate.table.action": "Action",
  "settings.mailTemplate.form.module": "Module",
  "settings.mailTemplate.form.topic": "Sujet",
  "settings.mailTemplate.form.text": "Texte",
  "settings.mailTemplate.form.name": "Nom du Mod\xE8le",
  "settings.mailTemplate.form.namePlaceholder": "Veuillez saisir le nom du mod\xE8le.",
  "settings.mailTemplate.form.subject": "Sujet",
  "settings.mailTemplate.form.subjectPlaceholder": "Veuillez saisir le sujet.",
  "settings.mailTemplate.form.content": "Contenu",
  "settings.mailTemplate.form.contentPlaceholder": "Veuillez saisir le contenu.",
  "settings.mailTemplate.form.type": "Type",
  "settings.mailTemplate.form.typePlaceholder": "Veuillez s\xE9lectionner le type.",
  "settings.smtp.pageTitle": "Param\xE8tres SMTP",
  "settings.smtp.save": "Enregistrer",
  "settings.smtp.test": "Tester la Connexion",
  "settings.smtp.reset": "R\xE9initialiser",
  "settings.smtp.form.host": "H\xF4te SMTP",
  "settings.smtp.form.hostPlaceholder": "Veuillez saisir l'h\xF4te SMTP.",
  "settings.smtp.form.port": "Port SMTP",
  "settings.smtp.form.portPlaceholder": "Veuillez saisir le port SMTP.",
  "settings.smtp.form.username": "Nom d'Utilisateur",
  "settings.smtp.form.usernamePlaceholder": "Veuillez saisir le nom d'utilisateur.",
  "settings.smtp.form.password": "Mot de Passe",
  "settings.smtp.form.passwordPlaceholder": "Veuillez saisir le mot de passe.",
  "settings.smtp.form.encryption": "Chiffrement",
  "settings.smtp.form.encryptionPlaceholder": "Veuillez s\xE9lectionner le type de chiffrement.",
  "settings.smtp.form.useSSL": "Utiliser SSL",
  "settings.smtp.form.senderName": "Nom de l'exp\xE9diteur",
  "settings.smtp.form.optional": "(optionnel)",
  "settings.smsGateway.pageTitle": "Configuration de la Passerelle SMS",
  "settings.smsGateway.save": "Enregistrer",
  "settings.smsGateway.test": "Tester la Connexion",
  "settings.smsGateway.reset": "R\xE9initialiser",
  "settings.smsGateway.form.provider": "Fournisseur SMS",
  "settings.smsGateway.form.providerPlaceholder": "Veuillez s\xE9lectionner le fournisseur SMS.",
  "settings.smsGateway.form.apiKey": "Cl\xE9 API",
  "settings.smsGateway.form.apiKeyPlaceholder": "Veuillez saisir la cl\xE9 API.",
  "settings.smsGateway.form.apiSecret": "Secret API",
  "settings.smsGateway.form.apiSecretPlaceholder": "Veuillez saisir le secret API.",
  "settings.smsGateway.form.fromNumber": "Num\xE9ro d'Origine",
  "settings.smsGateway.form.fromNumberPlaceholder": "Veuillez saisir le num\xE9ro d'origine.",
  "settings.smsTemplate.pageTitle": "Gestion des Mod\xE8les SMS",
  "settings.smsTemplate.addTemplate": "Ajouter un Mod\xE8le",
  "settings.smsTemplate.editTemplate": "Modifier le Mod\xE8le",
  "settings.smsTemplate.deleteTemplate": "Supprimer le Mod\xE8le",
  "settings.smsTemplate.export": "Exporter",
  "settings.smsTemplate.filter": "Filtrer",
  "settings.smsTemplate.clear": "Effacer",
  "settings.smsTemplate.apply": "Appliquer",
  "settings.smsTemplate.table.name": "Nom",
  "settings.smsTemplate.table.content": "Contenu",
  "settings.smsTemplate.table.type": "Type",
  "settings.smsTemplate.table.status": "Statut",
  "settings.smsTemplate.table.action": "Action",
  "settings.smsTemplate.form.name": "Nom du Mod\xE8le",
  "settings.smsTemplate.form.namePlaceholder": "Veuillez saisir le nom du mod\xE8le.",
  "settings.smsTemplate.form.content": "Contenu",
  "settings.smsTemplate.form.contentPlaceholder": "Veuillez saisir le contenu.",
  "settings.smsTemplate.form.type": "Type",
  "settings.smsTemplate.form.typePlaceholder": "Veuillez s\xE9lectionner le type.",
  "settings.masterStore.pageTitle": "G\xE9rer la Boutique Principale",
  "settings.masterStore.messages.noPermission": "Vous n'avez pas l'autorisation de d\xE9finir la boutique principale.",
  "settings.masterStore.messages.updateSuccess": "Mis \xE0 jour avec succ\xE8s.",
  "settings.masterStore.modal.warning": "D\xE9finir la boutique principale peut affecter le catalogue, les promotions, les th\xE8mes et autres fonctionnalit\xE9s de toutes les boutiques cibles.",
  "settings.masterStore.modal.notice": "Avis",
  "settings.masterStore.modal.noticeText": "Des choses mauvaises inattendues se produiront si vous ne lisez pas ceci !",
  "settings.masterStore.modal.step1Button": "Je suis s\xFBr de d\xE9finir la boutique principale",
  "settings.masterStore.modal.step2Button": "J'ai lu ces effets",
  "settings.masterStore.modal.confirmTitle": "Tapez la phrase ci-dessous pour CONFIRMER *",
  "settings.masterStore.modal.confirmText": "Je comprends que D\xC9FINIR LA BOUTIQUE PRINCIPALE peut affecter les mises \xE0 jour futures de version.",
  "settings.masterStore.modal.cancel": "Annuler",
  "settings.masterStore.modal.set": "D\xE9finir",
  "settings.masterStore.selectTitle": "S\xE9lectionnez une boutique existante",
  "settings.masterStore.selectDescription": "Veuillez s\xE9lectionner une boutique existante.",
  "settings.masterStore.clear": "Effacer",
  "settings.masterStore.setButton": "D\xE9finir la Boutique Principale",
  "settings.masterStore.form.storeName": "Nom de la Boutique",
  "settings.masterStore.form.placeholder": "Veuillez s\xE9lectionner une boutique principale",
  "settings.masterStore.form.label": "S\xE9lectionnez une principale",
  "settings.masterStore.table.name": "Nom de la Boutique",
  "settings.masterStore.table.platform": "Plateforme",
  "settings.masterStore.table.url": "URL",
  "settings.masterStore.table.status": "Statut",
  "settings.masterStore.table.action": "Action",
  "settings.masterStore.form.name": "Nom de la Boutique",
  "settings.masterStore.form.namePlaceholder": "Veuillez saisir le nom de la boutique.",
  "settings.masterStore.form.platform": "Plateforme",
  "settings.masterStore.form.platformPlaceholder": "Veuillez s\xE9lectionner la plateforme.",
  "settings.masterStore.form.url": "URL de la Boutique",
  "settings.masterStore.form.urlPlaceholder": "Veuillez saisir l'URL de la boutique.",
  "settings.masterStore.form.apiKey": "Cl\xE9 API",
  "settings.masterStore.form.apiKeyPlaceholder": "Veuillez saisir la cl\xE9 API.",
  "settings.apiToken.pageTitle": "Jeton API de Franchise",
  "settings.apiToken.messages.noPermission": "Vous n'avez pas les permissions.",
  "settings.apiToken.messages.updateSuccess": "Mise \xE0 jour r\xE9ussie",
  "settings.apiToken.form.franchiseId": "ID de Franchise",
  "settings.apiToken.form.franchiseIdRequired": "L'ID de Franchise est requis.",
  "settings.apiToken.form.clientId": "ID Client",
  "settings.apiToken.form.clientIdRequired": "L'ID Client est requis.",
  "settings.apiToken.form.clientSecret": "Secret Client",
  "settings.apiToken.form.clientSecretRequired": "Le Secret Client est requis.",
  "settings.apiToken.form.country": "Pays",
  "settings.apiToken.form.countryRequired": "Le pays est requis.",
  "settings.apiToken.form.countryUS": "\xC9tats-Unis",
  "settings.apiToken.form.region": "R\xE9gion",
  "settings.apiToken.form.regionRequired": "La r\xE9gion est requise.",
  "settings.apiToken.form.regionUS": "\xC9tats-Unis",
  "settings.apiToken.form.regionEU": "UE",
  "settings.apiToken.form.regionAU": "AU",
  "settings.apiToken.table.token": "Jeton",
  "settings.apiToken.table.name": "Nom",
  "settings.apiToken.table.createdAt": "Cr\xE9\xE9 Le",
  "settings.apiToken.table.expiresAt": "Expire Le",
  "settings.apiToken.table.status": "Statut",
  "settings.apiToken.table.action": "Action",
  "settings.apiToken.form.name": "Nom du Jeton",
  "settings.apiToken.form.namePlaceholder": "Veuillez saisir le nom du jeton.",
  "settings.apiToken.form.expiresAt": "Expire Le",
  "settings.apiToken.form.expiresAtPlaceholder": "Veuillez s\xE9lectionner la date d'expiration.",
  "settings.apiToken.form.permissions": "Permissions",
  "settings.apiToken.form.permissionsPlaceholder": "Veuillez s\xE9lectionner les permissions.",
  "settings.automation.pageTitle": "Gestion des Notifications Automatis\xE9es",
  "settings.automation.addNotification": "Ajouter une Notification",
  "settings.automation.editNotification": "Modifier la Notification",
  "settings.automation.deleteNotification": "Supprimer la Notification",
  "settings.automation.export": "Exporter",
  "settings.automation.filter": "Filtrer",
  "settings.automation.clear": "Effacer",
  "settings.automation.apply": "Appliquer",
  "settings.automation.table.name": "Nom",
  "settings.automation.table.type": "Type",
  "settings.automation.table.trigger": "D\xE9clencheur",
  "settings.automation.table.status": "Statut",
  "settings.automation.table.action": "Action",
  "settings.automation.form.name": "Nom de la Notification",
  "settings.automation.form.namePlaceholder": "Veuillez saisir le nom de la notification.",
  "settings.automation.form.type": "Type",
  "settings.automation.form.typePlaceholder": "Veuillez s\xE9lectionner le type de notification.",
  "settings.automation.form.trigger": "D\xE9clencheur",
  "settings.automation.form.triggerPlaceholder": "Veuillez s\xE9lectionner la condition du d\xE9clencheur.",
  "settings.automation.form.recipients": "Destinataires",
  "settings.automation.form.recipientsPlaceholder": "Veuillez saisir les destinataires.",
  "settings.automation.emailTitle": "Envoyer un e-mail aux clients quand :",
  "settings.automation.smsTitle": "Envoyer un SMS aux clients quand :",
  "settings.automation.createUsers": "Cr\xE9er des Utilisateurs",
  "settings.automation.resetPassword": "R\xE9initialiser le Mot de Passe",
  "settings.automation.createStores": "Cr\xE9er des Boutiques",
  "settings.automation.changePlans": "Changer de Plans",
  "settings.automation.supportRequest": "Demande de Support",
  "settings.automation.ticketUpdates": "Mises \xE0 Jour de Ticket",
  "settings.automation.createUsersEmailText": "Un e-mail sera envoy\xE9 au nouvel utilisateur avec un lien pour activer le compte.",
  "settings.automation.resetPasswordEmailText": "Un e-mail sera envoy\xE9 \xE0 l'utilisateur avec un lien pour r\xE9initialiser le mot de passe.",
  "settings.automation.createStoresEmailText": "Un e-mail sera envoy\xE9 au Contact Principal avec confirmation.",
  "settings.automation.createStoresEmailText2": "BigCommerce enverra \xE9galement un e-mail.",
  "settings.automation.changePlansEmailText": "Un e-mail sera envoy\xE9 au client lors des mises \xE0 jour de plan.",
  "settings.automation.supportRequestEmailText": "Un e-mail sera envoy\xE9 au client avec une demande soumise.",
  "settings.automation.ticketUpdatesEmailText": "Un e-mail sera envoy\xE9 au client lors des mises \xE0 jour de ticket.",
  "settings.automation.createUsersSMSText": "Un SMS sera envoy\xE9 au nouvel utilisateur avec un lien pour activer le compte.",
  "settings.automation.resetPasswordSMSText": "Un SMS sera envoy\xE9 \xE0 l'utilisateur avec un lien pour r\xE9initialiser le mot de passe.",
  "settings.automation.createStoresSMSText": "Un SMS sera envoy\xE9 au Contact Principal avec confirmation.",
  "settings.automation.createStoresSMSText2": "BigCommerce enverra \xE9galement un SMS.",
  "settings.automation.changePlansSMSText": "Un SMS sera envoy\xE9 au client lors des mises \xE0 jour de plan.",
  "settings.automation.supportRequestSMSText": "Un SMS sera envoy\xE9 au client avec une demande soumise.",
  "settings.automation.ticketUpdatesSMSText": "Un SMS sera envoy\xE9 au client lors des mises \xE0 jour de ticket.",
  "settings.automation.save": "Enregistrer",
  "settings.automation.messages.updateSuccess": "Mise \xE0 jour r\xE9ussie",
  "settings.automation.messages.noPermission": "Vous n'avez pas les permissions.",
  "settings.status.active": "Actif",
  "settings.status.inactive": "Inactif",
  "settings.status.enabled": "Activ\xE9",
  "settings.status.disabled": "D\xE9sactiv\xE9",
  "settings.status.valid": "Valide",
  "settings.status.expired": "Expir\xE9",
  "settings.action.view": "Voir",
  "settings.action.edit": "Modifier",
  "settings.action.delete": "Supprimer",
  "settings.action.save": "Enregistrer",
  "settings.action.cancel": "Annuler",
  "settings.action.confirm": "Confirmer",
  "settings.action.back": "Retour",
  "settings.messages.createSuccess": "Cr\xE9\xE9 avec succ\xE8s.",
  "settings.messages.updateSuccess": "Mis \xE0 jour avec succ\xE8s.",
  "settings.messages.deleteSuccess": "Supprim\xE9 avec succ\xE8s.",
  "settings.messages.createFailed": "\xC9chec de la cr\xE9ation : {error}",
  "settings.messages.updateFailed": "\xC9chec de la mise \xE0 jour : {error}",
  "settings.messages.deleteFailed": "\xC9chec de la suppression : {error}",
  "settings.messages.noPermission": "Vous n'avez pas les permissions.",
  "settings.form.required": "Ce champ est obligatoire.",
  "settings.form.invalidEmail": "Veuillez saisir une adresse e-mail valide.",
  "settings.form.invalidPhone": "Veuillez saisir un num\xE9ro de t\xE9l\xE9phone valide.",
  "settings.form.invalidUrl": "Veuillez saisir une URL valide.",
  "settings.form.invalidNumber": "Veuillez saisir un num\xE9ro valide.",
  "settings.form.minLength": "Minimum {min} caract\xE8res requis.",
  "settings.form.maxLength": "Maximum {max} caract\xE8res autoris\xE9s.",
  "settings.form.confirmPassword": "Les mots de passe ne correspondent pas.",
  "settings.form.uniqueName": "Ce nom existe d\xE9j\xE0.",
  "settings.form.uniqueEmail": "Cet e-mail existe d\xE9j\xE0.",
  "settings.home.portalUserManagement": "Gestion des Utilisateurs du Portail",
  "settings.home.groupManagement": "Gestion des Groupes",
  "settings.home.planManagement": "Gestion des Plans",
  "settings.home.automationNotification": "Notification Automatis\xE9e",
  "settings.home.apiFranchiseToken": "Jeton API de Franchise",
  "settings.home.manageMasterStore": "G\xE9rer la Boutique Principale",
  "settings.home.catalogSetting": "R\xE9glage du catalogue",
  "settings.home.smsGatewayConfig": "Configuration de la Passerelle SMS",
  "settings.home.smsTemplate": "Mod\xE8le SMS",
  "settings.home.smtpSetting": "Param\xE8tre SMTP",
  "settings.home.mailTemplate": "Mod\xE8le de Mail",
  "settings.catalogSetting.pageTitle": "R\xE9glage du Catalogue",
  "settings.catalogSetting.save": "Enregistrer",
  "settings.catalogSetting.messages.updateSuccess": "Mis \xE0 jour avec succ\xE8s.",
  "settings.catalogSetting.automaticallyPullProducts": "Synchroniser Automatiquement les Produits depuis la Boutique Principale",
  "settings.catalogSetting.automaticallyPullProductsDescription": "Activez cette option si vous souhaitez synchroniser automatiquement les produits depuis la Boutique Principale lors de la cr\xE9ation de nouveaux produits. Si cette fonctionnalit\xE9 est d\xE9sactiv\xE9e, aucun produit ne sera automatiquement synchronis\xE9 depuis la Boutique Principale vers le Hub Commercial Distributeur.",
  "settings.messages.confirmDelete": "\xCAtes-vous s\xFBr de vouloir supprimer cet \xE9l\xE9ment ?",
  "settings.messages.confirmDeleteDescription": "Cette action ne peut pas \xEAtre annul\xE9e."
};

// src/locales/fr/stores.ts
var stores_default3 = {
  stores_list_page_title: "Gestion des magasins",
  stores_list_column_store_id: "ID du magasin",
  stores_list_column_store_hash: "Hash du magasin",
  stores_list_column_store_name: "Nom du magasin",
  stores_list_column_plan: "Plan",
  stores_list_column_expire_time: "Date d'expiration",
  stores_list_column_status: "Statut",
  stores_list_column_company: "Entreprise",
  stores_list_column_account: "Compte",
  stores_list_column_provisioning_profile: "Profil de provisionnement",
  stores_list_column_live_store: "Magasin en ligne",
  stores_list_column_action: "Action",
  stores_destroy_modal_title: "La suppression d'un magasin connect\xE9 supprimera d\xE9finitivement toutes les commandes associ\xE9es dans Distributed Commerce Hub.",
  stores_destroy_form_store_id_label: "ID du magasin",
  stores_destroy_form_store_id_placeholder: "Veuillez saisir l'ID du magasin",
  stores_destroy_form_store_id_required: "L'ID est requis",
  stores_destroy_form_confirm_label: "Confirmer",
  stores_destroy_form_confirm_placeholder: "Veuillez taper le mot 'CONFIRM'",
  stores_destroy_form_confirm_required: "Veuillez taper le mot 'CONFIRM'",
  stores_destroy_success: "Magasin supprim\xE9 avec succ\xE8s",
  stores_new_order_drawer_title: "Changer de plan",
  stores_new_order_form_store_id_label: "ID du magasin",
  stores_new_order_form_store_id_required: "L'ID est requis",
  stores_new_order_form_store_name_label: "Nom du magasin",
  stores_new_order_form_store_name_required: "Le nom du magasin est requis",
  stores_new_order_form_cur_plan_label: "S\xE9lectionner un plan",
  stores_new_order_form_cur_plan_required: "Le plan est requis",
  stores_new_order_form_effective_label: "En vigueur",
  stores_new_order_form_effective_required: "La date d'entr\xE9e en vigueur est requise",
  stores_new_order_form_effective_option_immediately: "Imm\xE9diatement",
  stores_new_order_form_effective_option_next_billing: "Prochain cycle de facturation",
  stores_new_order_success: "Mise \xE0 jour r\xE9ussie",
  stores_new_store_open_button: "Cr\xE9er un magasin",
  stores_new_store_type_drawer_title: "S\xE9lectionner le type de magasin",
  stores_new_store_type_new_button: "Cr\xE9er un nouveau magasin",
  stores_new_store_type_existing_button: "Connecter un magasin existant",
  stores_new_store_add_drawer_title: "Ajouter un nouveau magasin",
  stores_new_store_add_submit_button: "Sauvegarder",
  stores_new_store_connect_drawer_title: "Connecter un magasin existant",
  stores_new_store_connect_submit_button: "Connecter",
  stores_new_store_field_account_label: "Compte",
  stores_new_store_field_account_required: "Le compte est requis",
  stores_new_store_field_name_label: "Nom du magasin",
  stores_new_store_field_name_required: "Le nom du magasin est requis",
  stores_new_store_field_plan_label: "Plan",
  stores_new_store_field_plan_required: "Le plan est requis",
  stores_new_store_field_company_label: "Entreprise",
  stores_new_store_field_desc_label: "Description",
  stores_new_store_field_profile_label: "Profil de provisionnement",
  stores_new_store_field_store_hash_label: "Hash du magasin",
  stores_new_store_field_store_hash_required: "Le hash du magasin est requis",
  stores_new_store_field_client_id_label: "ID client",
  stores_new_store_field_client_id_required: "L'ID client est requis",
  stores_new_store_field_client_secret_label: "Secret client",
  stores_new_store_field_client_secret_required: "Le secret client est requis",
  stores_new_store_field_access_token_label: "Jeton d'acc\xE8s",
  stores_new_store_field_access_token_required: "Le jeton d'acc\xE8s est requis",
  stores_new_store_add_success: "Magasin ajout\xE9 avec succ\xE8s",
  stores_new_store_connect_success: "Magasin connect\xE9 avec succ\xE8s",
  stores_shopify_create_button: "Connecter un magasin existant",
  stores_shopify_create_modal_header_method: "Connecter un magasin Shopify",
  stores_shopify_create_modal_header_manual: "Connecter un magasin existant",
  stores_shopify_create_modal_header_auth: "Autorisation du magasin Shopify",
  stores_shopify_create_method_tip: "Choisissez comment vous souhaitez connecter votre magasin Shopify \xE0 CommercialHub.",
  stores_shopify_create_manual_title: "Connexion manuelle",
  stores_shopify_create_manual_desc: "Entrez manuellement les identifiants de votre magasin",
  stores_shopify_create_auth_title: "Autorisation en un clic",
  stores_shopify_create_auth_desc: "Autoriser via l'application Shopify",
  stores_shopify_create_form_submit: "Connecter",
  stores_shopify_create_form_back: "Retour",
  stores_shopify_create_field_store_url_label: "URL du magasin",
  stores_shopify_create_field_store_url_required: "L'URL du magasin est requise",
  stores_shopify_create_field_client_id_label: "Cl\xE9 API",
  stores_shopify_create_field_client_id_required: "La cl\xE9 API est requise",
  stores_shopify_create_field_client_secret_label: "Cl\xE9 secr\xE8te API",
  stores_shopify_create_field_client_secret_required: "La cl\xE9 secr\xE8te API est requise",
  stores_shopify_create_field_access_token_label: "Jeton d'acc\xE8s \xE0 l'API Admin",
  stores_shopify_create_field_access_token_required: "Le jeton d'acc\xE8s \xE0 l'API Admin est requis",
  stores_shopify_create_auth_tip: "Pour connecter votre magasin Shopify, vous devez autoriser CommercialHub \xE0 acc\xE9der aux donn\xE9es de votre magasin.",
  stores_shopify_create_auth_submit: "Aller \xE0 l'autorisation",
  stores_shopify_create_success: "Magasin connect\xE9 avec succ\xE8s",
  stores_action_search_placeholder: "rechercher",
  stores_action_export_button: "Exporter",
  stores_action_filter_button: "Filtrer",
  stores_action_store_id_label: "ID du magasin",
  stores_action_store_id_sublabel: "(\xE9gal)",
  stores_action_plan_label: "Plan",
  stores_action_plan_sublabel: "(\xE9gal)",
  stores_action_store_hash_label: "Hash du magasin",
  stores_action_store_hash_sublabel: "(\xE9gal)",
  stores_action_account_name_label: "Compte",
  stores_action_account_name_sublabel: "(contient)",
  stores_action_status_label: "Statut",
  stores_action_status_sublabel: "(\xE9gal)",
  stores_action_exp_date_label: "Date d'expiration",
  stores_action_exp_date_sublabel: "(\xE9gal)",
  stores_management_action_change_plan: "Changer de plan",
  stores_management_action_suspend: "Suspendre",
  stores_management_action_cancel: "Annuler",
  stores_suspend_modal_title: "La suspension d'un magasin entra\xEEnera la suspension de toutes les commandes associ\xE9es.",
  stores_suspend_modal_action_confirm: "Suspendre",
  stores_suspend_form_label_store_id: "ID du magasin",
  stores_suspend_form_placeholder_store_id: "Veuillez saisir l'ID du magasin",
  stores_suspend_form_label_confirm: "Confirmer",
  stores_suspend_form_placeholder_confirm: "Veuillez taper le mot 'CONFIRM'",
  stores_suspend_form_validation_store_id_required: "L'ID du magasin est requis",
  stores_suspend_form_validation_confirm_required: "Veuillez taper le mot 'CONFIRM'",
  stores_suspend_form_validation_confirm_match: "Veuillez taper le mot 'CONFIRM'",
  stores_suspend_success: "Magasin suspendu avec succ\xE8s",
  stores_info_page_title: "Voir les informations du magasin",
  stores_info_store_id: "ID du magasin",
  stores_info_store_hash: "Hash du magasin",
  stores_info_billing_cycle: "Cycle de facturation",
  stores_info_expire_date: "Date d'expiration",
  stores_info_status: "Statut",
  stores_info_account_info_title: "Informations du compte",
  stores_info_account_name: "Nom du compte",
  stores_info_email: "E-mail",
  stores_info_company: "Entreprise",
  stores_info_phone: "T\xE9l\xE9phone",
  stores_info_address: "Adresse",
  stores_info_country: "Pays",
  stores_info_city: "Ville"
};

// src/locales/fr/theme.ts
var theme_default3 = {
  theme_list_page_title: "Th\xE8mes",
  theme_list_set_default: "D\xE9finir par d\xE9faut",
  theme_list_upload: "T\xE9l\xE9charger des th\xE8mes",
  theme_list_apply_store: "Appliquer un th\xE8me au magasin",
  theme_list_default_title: "Th\xE8me par d\xE9faut",
  theme_list_default_name: "Nom du th\xE8me",
  theme_list_default_style: "Style",
  theme_list_loading_failure: "\xC9chec du chargement",
  theme_list_set_default_success: "Th\xE8me par d\xE9faut d\xE9fini avec succ\xE8s.",
  theme_list_set_default_no_permission: "Vous n'avez pas la permission de changer le th\xE8me par d\xE9faut.",
  theme_list_set_default_title_shopify: "S\xE9lectionner un style de th\xE8me par d\xE9faut pour les nouveaux magasins",
  theme_list_set_default_title_other: "\xCAtes-vous s\xFBr ?",
  theme_list_set_default_style_placeholder: "Veuillez s\xE9lectionner le nom du style",
  theme_list_set_default_description: "Ce th\xE8me sera appliqu\xE9 aux nouveaux magasins.",
  theme_list_filter_search_placeholder: "rechercher",
  theme_list_filter_expand: "D\xE9velopper",
  theme_list_filter_clear: "Effacer",
  theme_list_filter_apply: "Appliquer",
  theme_list_filter_equals: " (\xE9gal)",
  theme_list_filter_contains: " (contient)",
  theme_list_filter_theme_name: "Nom du th\xE8me",
  theme_list_filter_upload_date: "Date de t\xE9l\xE9chargement",
  theme_list_filter_utilization: "Utilisation",
  theme_list_table_loading_failure: "\xC9chec du chargement",
  theme_list_table_utilization: "Utilisation",
  theme_list_table_styles: "styles",
  theme_list_table_style: "style",
  theme_list_table_download: "T\xE9l\xE9charger le th\xE8me",
  theme_list_table_remove: "Supprimer le th\xE8me",
  theme_remove_success: "Th\xE8me supprim\xE9 avec succ\xE8s",
  theme_remove_failed: "\xC9chec de la suppression du th\xE8me",
  theme_remove_confirm_title: "Supprimer le th\xE8me",
  theme_remove_confirm_message: "\xCAtes-vous s\xFBr de vouloir supprimer ce th\xE8me ? Cette action ne peut pas \xEAtre annul\xE9e.",
  theme_download_success: "Th\xE8me t\xE9l\xE9charg\xE9 avec succ\xE8s",
  theme_download_failed: "\xC9chec du t\xE9l\xE9chargement du th\xE8me",
  theme_upload_file_size_error: "La taille du fichier doit \xEAtre inf\xE9rieure \xE0 10 Mo.",
  theme_upload_no_permission: "Vous n'avez pas la permission de t\xE9l\xE9charger le th\xE8me.",
  theme_upload_success: "T\xE9l\xE9chargement r\xE9ussi. Veuillez v\xE9rifier votre e-mail et la page pr\xE9c\xE9dente sera restaur\xE9e dans trois secondes.",
  theme_upload_zip_required: "Veuillez t\xE9l\xE9charger le fichier zip du th\xE8me.",
  theme_upload_picture_label: "Image du th\xE8me",
  theme_upload_page_title: "T\xE9l\xE9charger un th\xE8me",
  theme_upload_zip_title: "T\xE9l\xE9charger ZIP",
  theme_upload_notice_header: "Avis",
  theme_upload_notice_text: "Nous ne fournissons aucune assistance technique pour votre th\xE8me personnalis\xE9, ni d'aide pour les fonctionnalit\xE9s personnalis\xE9es que vous avez ajout\xE9es.",
  theme_upload_description: "Vous pouvez t\xE9l\xE9charger votre th\xE8me personnalis\xE9 sous forme de fichier zip ci-dessous.",
  theme_upload_cancel_text: "Annuler",
  theme_upload_save_text: "Sauvegarder",
  theme_apply_no_permission: "Vous n'avez pas la permission d'appliquer le th\xE8me.",
  theme_apply_success: "Application r\xE9ussie. La page pr\xE9c\xE9dente sera restaur\xE9e dans trois secondes.",
  theme_apply_page_title: "Confirmer l'application du th\xE8me",
  theme_apply_select_stores_title: "S\xE9lectionner les magasins",
  theme_apply_select_stores_desc: "Nous recommandons d'envoyer un e-mail de confirmation avant d'appliquer le th\xE8me aux magasins.",
  theme_apply_store_placeholder: "S\xE9lectionner un magasin",
  theme_apply_store_label: "S\xE9lectionner un magasin",
  theme_apply_select_style: "S\xE9lectionner un style",
  theme_apply_loading_failure: "\xC9chec du chargement",
  theme_apply_now_title: "Appliquer maintenant ?",
  theme_apply_email_confirm: "Envoyer un e-mail de confirmation au propri\xE9taire du magasin pour autoriser l'application du th\xE8me.",
  theme_apply_mandatory_date: "D\xE9finir une date de mise en \u0153uvre obligatoire et envoyer un e-mail de confirmation au propri\xE9taire du magasin pour autoriser l'application du th\xE8me. Si le propri\xE9taire du magasin n'est pas d'accord avec la confirmation, le th\xE8me sera appliqu\xE9 dans un d\xE9lai sp\xE9cifique.",
  theme_apply_force_date: "Date de mise en \u0153uvre forc\xE9e",
  theme_apply_direct: "Appliquer le th\xE8me directement.",
  theme_apply_cancel: "Annuler",
  theme_apply_save: "Sauvegarder",
  theme_apply_modal_title_1: "Appliquer ce th\xE8me aux magasins peut affecter les polices, les couleurs et la vitrine. Nous enverrons un e-mail de confirmation au propri\xE9taire du magasin.",
  theme_apply_modal_title_2: "Appliquer ce th\xE8me aux magasins peut affecter les polices, les couleurs et la vitrine. Nous enverrons un e-mail de confirmation au propri\xE9taire du magasin. Si le propri\xE9taire du magasin n'est pas d'accord avec la confirmation, le th\xE8me sera appliqu\xE9 dans un d\xE9lai sp\xE9cifique.",
  theme_apply_modal_title_3: "Appliquer ce th\xE8me aux magasins peut affecter les polices, les couleurs et la vitrine.",
  theme_apply_modal_cancel: "Annuler",
  theme_apply_modal_ok: "OK",
  theme_apply_modal_theme_name: "Nom du th\xE8me",
  theme_apply_modal_selected_stores: "Magasins s\xE9lectionn\xE9s",
  theme_apply_modal_type: "Type",
  theme_apply_modal_confirm_text: "*CONFIRMER* dans le champ de texte"
};

// src/locales/fr/translation.ts
var translation_default3 = {
  ...common_default3,
  ...orders_default3,
  ...packages_default3,
  ...resetPassword_default3,
  ...settings_default3,
  ...theme_default3,
  ...promotion_default3,
  ...layout_default3,
  ...login_default3,
  ...forgotPassword_default3,
  ...product_default3,
  ...stores_default3,
  ...account_default3,
  ...dashboard_default3,
  ...content_default3,
  ...customerProfile_default3,
  ...reports_default3,
  ...onboarding_default3,
  ...provisioningProfiles_default3
};

// src/index.ts
var resources = {
  en: {
    translation: translation_default
  },
  es: {
    translation: translation_default2
  },
  fr: {
    translation: translation_default3
  }
};
i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});
var src_default = i18n;
export {
  src_default as default
};
